import type { KaannosAvain } from "./kaannokset";

/* ═══ Liettuankieliset käyttöliittymätekstit (lt) — Toni 11.10.2026 «liettua GO laajuuden mukaan» ═══
   Vaihe 1: kehys + työnjohtajan näkymät + Testaus + Ohjeet, vain demossa (KIELET=fi,en,lt). Vaihe 2 vasta testaajan
   laadunarvion jälkeen. KONEKÄÄNNÖS: jokainen rivi on «tarkistamatta», kunnes testaaja (tunnus 7831, oikeus
   kaannostarkistus) merkitsee sen Käännökset-näkymässä; alan termit tarkistaa testaaja, hyväksynnän tekee Toni.
   Puuttuva rivi näytetään englanniksi (varakieli, Toni 11.10.2026). Yksi totuus: tämä tiedosto, ei instanssikohtaisia
   käännöksiä. */
export const LT: Partial<Record<KaannosAvain, string>> = {
  // Toni 13.10.2026 (teksti pääChatilta; äidinkielisen tarkistus kesken): punchin ja puutteen vapaatekstin ohje.
  "kirjoitusohje.korjaava": "Rašykite taip, kad taisytojas suprastų.",
  "kt.lahdekieli": "Šaltinio kalba",
  "kt.suomeksi": "suomių k.",
  "kirjautuminen.kenttatili": "Lauko paskyra",
  "kirjautuminen.sahkoposti": "El. paštas",
  "kirjautuminen.salasana": "Slaptažodis",
  "kirjautuminen.koodi": "Darbuotojo kodas",
  "kirjautuminen.koodi_esim": "pvz. JKo",
  "kirjautuminen.pin": "PIN",
  "kirjautuminen.kirjaudu": "Prisijungti",
  "kirjautuminen.kirjaudutaan": "Prisijungiama…",
  "kirjautuminen.kenttatilille": "Prisijungti su lauko paskyra →",
  "kirjautuminen.sahkopostilla": "← Prisijungti el. paštu",
  "kirjautuminen.unohtunut": "Pamiršote slaptažodį?",
  "kirjautuminen.unohtunut_otsikko": "Atkurti slaptažodį",
  "kirjautuminen.unohtunut_ohje": "Įveskite savo paskyros el. pašto adresą. Atsiųsime nuorodą naujam slaptažodžiui nustatyti. Lauko paskyros PIN atkuria administratorius.",
  "kirjautuminen.unohtunut_laheta": "Siųsti nuorodą",
  "kirjautuminen.unohtunut_lahetetty": "Jei adresas naudojamas, į jį išsiųsta slaptažodžio atkūrimo nuoroda. Nuoroda galioja vieną valandą ir veikia vieną kartą. Patikrinkite ir šlamšto aplanką.",
  "kirjautuminen.ei_yhteytta": "Nepavyko pasiekti serverio.",
  "aika.klo": "val.",
  "kirjautuminen.istunto_vanhentui": "Jūsų sesija baigėsi — prisijunkite iš naujo. Jokie duomenys neprarasti.",
  "kieli.otsikko": "Kalba",
  "kieli.instanssin": "Organizacijos numatytoji",
  "kieli.tallennettu": "Kalba pakeista.",
  "kieli.selite": "Naudotojo sąsajos kalba. Ataskaitose ir spaudiniuose naudojama objekto dokumentacijos kalba.",
  "valikko.ryhma.tarkastus": "Patikra",
  "valikko.ryhma.kenttatyo": "Lauko darbai",
  "valikko.ryhma.projekti": "Projektas",
  "valikko.ryhma.myynti": "Pardavimai",
  "valikko.ryhma.resursointi": "Išteklių planavimas",
  "valikko.ryhma.vaki": "Žmonės ir įranga",
  "valikko.ryhma.tuotanto": "Gamyba",
  "valikko.ryhma.seuranta": "Stebėsena ir ataskaitos",
  "valikko.ryhma.luovutusdokumentaatio": "Perdavimo dokumentacija",
  "valikko.ryhma.hallinta": "Administravimas",
  "valikko.academy": "Academy",
  "valikko.ainestodistukset": "Medžiagų sertifikatai",
  "valikko.asiakkaat": "Užsakovai",
  "valikko.etenema": "Pažanga",
  // T646 (1) ja T514 (23.10.2026): työmaasanasto T09 «linijos patikra», T07 «slėgio bandymas» (C-luokka, tarkistamaton).
  "valikko.linjatarkastukset": "Linijų patikros",
  "valikko.koeponnistusvalmius": "Paruošta slėgio bandymui",
  "valikko.henkilosto": "Personalas",
  "valikko.hitsausloki": "Suvirinimo žurnalas",
  "valikko.iv_asennus": "ŠVOK montavimas",
  "valikko.laippaliitokset": "Flanšų jungtys",
  "valikko.portit": "Etapų vartai (TG)",
  "tg.selite": "Vartai – tai rangos darbų patikros taškai nuo kainos užklausos iki perdavimo. Vartai patvirtinami, kai atliktos jų užduotys. Vartus patvirtinti ir jų terminą perkelti gali tik tam įgaliotas asmuo. Kiekvienas įvykis įrašomas į žurnalą.",
  "valikko.kalusto": "Įranga",
  "valikko.laiteasennus": "Įrenginių montavimas",
  "valikko.linjat_ja_tarkastukset": "Linijos ir patikros",
  "valikko.linjatarkastus": "Linijos patikra",
  "valikko.luovutusvalmius": "Pasirengimas perdavimui",
  "valikko.materiaalit": "Medžiagos",
  "valikko.mitoitus": "Dimensionavimas",
  "valikko.omat_tiedot": "Mano duomenys",
  "valikko.osaamisradat": "Kompetencijų keliai",
  "valikko.projekti_hub": "Projekto suvestinė",
  "valikko.puutteet": "Trūkumai",
  "valikko.patevyydet": "Kvalifikacijos",
  "valikko.resurssit": "Ištekliai",
  "valikko.puuttuvat_hitsit": "Trūkstamos siūlės",
  "kuittaus.otsikko": "Trūkstamos siūlės",
  "kuittaus.selite": "Patvirtinkite izometrijos siūlę: atlikta (kas, kada, etapas), neatlikta, ne šioje linijoje arba raudonojo žymėjimo pakeitimas. Patvirtinimas neprideda siūlės į žurnalą — siūlė ateina per master, o patvirtinimas nurodo master prižiūrėtojui, ką įrašyti į master.",
  "kuittaus.r.hitsattu": "Suvirinta",
  "kuittaus.r.ei_hitsattu": "Nesuvirinta",
  "kuittaus.r.ei_talla_linjalla": "Ne šioje linijoje",
  "kuittaus.r.punakyna": "Raudonojo žymėjimo pakeitimas",
  "kuittaus.t.puuttuu_masterista": "Trūksta master",
  "kuittaus.t.masterissa_ilman_lehtea": "Master be lapo",
  "kuittaus.t.kunnossa": "Tvarkoje",
  "kuittaus.virhe.kohteet": "Nepavyko įkelti objektų.",
  "kuittaus.virhe.haku": "Nepavyko įkelti.",
  "kuittaus.virhe.tallennus": "Nepavyko išsaugoti.",
  "kuittaus.kohde": "Objektas",
  "kuittaus.alue": "Zona",
  "kuittaus.kaikki": "Visi ({n} atvirų)",
  "kuittaus.aluenappi": "{alue} ({avoimia} / {linjoja} linijų)",
  "kuittaus.ei_kuitattavia": "Nėra siūlių patvirtinimui.",
  "kuittaus.ei_kuitattavia_alue": "Zonoje {alue} nėra siūlių patvirtinimui.",
  "kuittaus.linja_alue": "zona {alue}",
  "kuittaus.avoinna": "{n} atvirų",
  "kuittaus.kuitattu": "patvirtinta",
  "kuittaus.ei_reittia": "Iš → Į nėra linijų sąraše",
  "kuittaus.vienti": "Eksportuoti patvirtinimus (xlsx)",
  "kuittaus.tuonti_otsikko": "Trūkstamos siūlės iš Excel",
  "kuittaus.tuonti_selite": "Importuokite trūkstamų siūlių sąrašą (stulpeliai linja, lehti, hitsinumero, dn, tila, isometri_tiedosto, karvi_id, huomio). Ta pati linija + lapas + numeris nedubliuojami.",
  "kuittaus.tuonti_esto": "Prieš importuodami pasirinkite objektą.",
  "kuittaus.peruttu": "Patvirtinimas atšauktas.",
  "kuittaus.tallennettu": "Išsaugota.",
  "kuittaus.hitsi": "Siūlė {nro}",
  "kuittaus.lehti": "lapas {lehti}",
  "kuittaus.isometri": "izometrinis brėžinys",
  "kuittaus.huomio_otsikko": "Patikrinti linijoje",
  "kuittaus.r.hitsattu_selvitettava": "Suvirinta – suvirintojas ir data dar tikslinami",
  "kuittaus.t.kohdistus_epavarma": "Izometrija neaiški",
  "kuittaus.tuonti_paivita": "Nauja versija: pakeisti nepatvirtintas eilutes (patvirtintos išsaugomos)",
  "kuittaus.tunnista": "Identifikuoti liniją",
  "kuittaus.tunnista_ohje": "Paieška: žyma, linija arba įrenginys (pvz. 0101)",
  "kuittaus.tunnista_hae": "Ieškoti",
  "kuittaus.rajain_alue": "Zona",
  "kuittaus.rajain_dn": "DN",
  "kuittaus.rajain_spec": "Spec.",
  "kuittaus.rajain_media": "Terpė",
  "kuittaus.tunnista_tulokset": "{n} linijų",
  "kuittaus.tunnista_rajattu": "rodomos pirmos 60 — patikslinkite",
  "kuittaus.tunnista_ei": "Atitikmenų nėra.",
  "kuittaus.tunnista_avaa": "Trūkstamos siūlės ({n})",
  "kuittaus.tunnista_ei_kuittauksia": "trūkstamų siūlių nenurodyta",
  "kuittaus.tapa.tarra": "žyma",
  "kuittaus.tapa.laite": "įrenginys",
  "kuittaus.tapa.tunnus": "linijos ID",
  "kuittaus.tapa.rajaus": "filtras",
  "kuittaus.nayta_isometri": "Rodyti izometriją",
  "kuittaus.isometri_paneeli": "Pasirinkite siūlę arba liniją, kad čia būtų parodyta jos izometrija.",
  "kuittaus.pdf_puuttuu": "Trūksta PDF",
  "kuittaus.isometri_ei": "izometrija {tiedosto} (nėra sistemoje)",
  "kuittaus.kuitattu_tila": "Patvirtinta: {ratkaisu}",
  "kuittaus.ratkaisu": "Sprendimas",
  "kuittaus.hitsaaja": "Suvirintojas (kodas)",
  "kuittaus.asentaja": "Vamzdynų montuotojas (kodas)",
  "kuittaus.paiva": "Data",
  "kuittaus.vaihe": "Etapas",
  "kuittaus.v.esivalmiste": "Išankstinė gamyba",
  "kuittaus.v.asennus": "Montavimas",
  "kuittaus.v.korjaus": "Remontas",
  "kuittaus.huomio": "Pastaba",
  "kuittaus.tallenna": "Išsaugoti",
  "kuittaus.peru": "Atšaukti patvirtinimą",
  "valikko.selailu": "Naršyti",
  "valikko.tarjoukset": "Pasiūlymai",
  "valikko.tarjousasetukset": "Pasiūlymų nustatymai",
  "valikko.tunnukset": "Naudotojų paskyros",
  "valikko.tuntikirjaus": "Darbo laiko apskaita",
  "valikko.tyokohteet": "Objektai",
  "valikko.tyopaketit": "Darbų paketai",
  "valikko.tyovuorot": "Pamainos",
  "valikko.varasto": "Sandėlis",
  "valikko.viestit": "Pranešimai",
  "valikko.yrityksen_tiedot": "Įmonės duomenys",
  "valikko.kaannokset": "Vertimai",
  "virhe.kirjautuminen_epaonnistui": "Neteisingas naudotojo vardas arba slaptažodis.",
  "virhe.kysely_aikaraja": "Sąrašas nebuvo užbaigtas per 15 sekundžių. Susiaurinkite paiešką arba pasirinkite «tik paruoštos».",
  "virhe.linjatarkastus_tuotu": "Šioje linijoje jau yra patikrinimas iš SharePoint. Pakartotinis patikrinimas bus vėliau.",
  "virhe.tuntematon_kieli": "Ši kalba neprieinama.",
  "yla.kirjaudu_ulos": "Atsijungti",
  "yla.vaihda_salasana": "keisti slaptažodį",
  "virhe.kieli_valitsematta": "Pirmiausia pasirinkite savo kalbą skiltyje Mano duomenys — jūs peržiūrite tos kalbos vertimus.",
  "virhe.vieras_kieli": "Peržiūrėtojas mato tik savo kalbos vertimus.",
  "virhe.korjaus_puuttuu": "Įrašykite pataisytą vertimą.",
  "yleinen.ladataan": "Įkeliama…",
  "omat.oma_profiili": "Mano profilis",
  "omat.ohje.kuka": "Kiekvienas mato savo duomenis ir tik juos. Vaizdas tik skaitomas: pataisymus (kontaktai, kvalifikacijos) atlieka darbų vadovas arba administratorius.",
  "omat.ohje.luvut": "Kvalifikacijos būsena nustatoma pagal galiojimą: nebegalioja, nustoja galioti per 30 dienų, nustoja galioti per 90 dienų, galioja arba neturi galiojimo termino. ✓ prieš pavadinimą reiškia, kad sertifikatas pridėtas. Objektas nustatomas pagal jūsų paskirstymą 30 dienų laikotarpyje.",
  "omat.haku_virhe": "Nepavyko įkelti jūsų duomenų.",
  "omat.ei_tyomaata": "Nematote jokio objekto: {syy}. Objektus paskirsto darbų vadovas.",
  "omat.hitsausloki_piilossa": "Suvirinimo žurnalas nerodomas, nes jūsų asmens įraše nenurodyta suvirinimo specialybė (pvz. suvirintojas, montuotojas (suvirinimas) arba darbų vadovas). Administratorius ją prideda asmens kortelėje.",
  "omat.ei_henkiloa": "Su jūsų naudotojo paskyra nesusietas joks asmuo. Kreipkitės į administratorių.",
  "omat.puhelin": "Telefonas",
  "omat.tyosuhde": "Darbo santykiai",
  "omat.osaamiset": "Kompetencijos",
  "omat.ei_patevyyksia": "Kvalifikacijų neįrašyta.",
  "omat.ei_vanhene": "neturi galiojimo termino",
  "pu.haku_virhe": "Paieška nepavyko.",
  "pu.vahvistus_virhe": "Patvirtinti nepavyko.",
  "pu.muutos_virhe": "Pakeisti nepavyko.",
  "pu.ohje.kuka": "Kiekvienas, kuris mato objektą, gali įrašyti trūkumą ir pažymėti jį kaip pradėtą, išspręstą ar atmestą arba vėl jį atidaryti — lauke įrašytas trūkumas galioja taip pat, kaip darbų vadovo. Išsaugoma, kas ir kada jį išsprendė. Objektais apribota paskyra mato tik savo objektų trūkumus ir niekada nemato trūkumų apie asmenis. Nuotraukas gali pridėti administratorius, planuotojas, darbų vadovas ir lauko darbuotojas; ištrinti jas gali tik administratorius ir planuotojas. Vardo pasiūlymą patvirtina administratorius, planuotojas arba darbų vadovas. Lauko darbuotojas nemato išorinės šalies pavadinimo.",
  "pu.ohje.luvut": "Viršuje esantys skaičiai skaičiuoja visas filtrą atitinkančias eilutes, ne tik esančias sąraše. Automatiškai aptikti trūkumai sukuriami naktiniame vykdyme; rankiniu būdu įrašyti atsiranda iš karto. «N d.» skaičiuojama nuo aptikimo, todėl problema yra bent tokio amžiaus. Uždarytas trūkumas lieka įraše: jei priežastis tebeegzistuoja, jis vėl atsiranda kaip nauja eilutė, o «atmesta N× anksčiau» rodo, kiek kartų tas pats trūkumas buvo atmestas. Aprėptis rodo, kokią dalį elementų taisyklė paliečia; taisyklė, paliečianti viską, nieko neišskiria ir neįtraukiama į eilę — eilutės vis tiek išsaugomos.",
  "pu.jonosta_pois": "neįtraukta į eilę",
  "pu.kattavuus_selite": "Taisyklė, paliečianti viską, nieko neišskiria: tai aprėpties rodiklis, o ne radinys. Eilutės išsaugomos.",
  "pu.kohde": "Objektas",
  "pu.kaikki_kohteet": "Visi objektai",
  "pu.tila": "Būsena",
  "pu.tila.avoimet": "Atviri",
  "pu.tila.vain_avoin": "Tik atviri",
  "pu.tila.kaynnissa": "Vykdoma",
  "pu.tila.ratkaistut": "Išspręsti",
  "pu.tila.hylatyt": "Atmesti",
  "pu.kaikki": "Visi",
  "pu.tyyppi": "Tipas",
  "pu.vaikutus": "Poveikis",
  "pu.kirjaa_havainto": "Įrašyti trūkumą",
  "pu.luku.avointa": "atvirų",
  "pu.luku.rivia": "eilučių",
  "pu.luku.pysayttaa": "stabdo darbus",
  "pu.luku.ulkoisia": "išorinių",
  "pu.katkaistu": "sąraše rodomi {n} seniausi / skubiausi",
  "pu.ei_puutteita": "Pagal šiuos filtrus trūkumų nėra.",
  "pu.kentta_tyhja": "Jums nėra atvirų trūkumų. Jūsų linijų defektai yra linijos puslapyje.",
  "pu.mita": "Kas",
  "pu.vastuu": "Atsakingas",
  "pu.havaittu": "Aptikta",
  "pu.kuvat": "Nuotraukos",
  "pu.vrk": "{n} d.",
  "pu.kuittasi": "patvirtino {nimi}",
  "pu.kuittasi_title": "Tai patvirtino asmuo.",
  "pu.saanto_sulki": "uždarė taisyklė (be patvirtinimo)",
  "pu.saanto_sulki_title": "Tai uždarė pati taisyklė (pvz. objektas nustojo rezervuoti pajėgumus) — patvirtinimo nėra ir jo nesitikima.",
  "pu.hylatty_monta_title": "Asmuo tai atmetė kelis kartus, o automatika vis dar tai iškelia. Tikriausiai taisyklė klaidinga.",
  "pu.hylatty_kerran_title": "Tas pats trūkumas jau buvo atmestas vieną kartą.",
  "pu.hylatty_n": "atmesta {n}× anksčiau",
  "pu.tarkista_saanto": "patikrinkite taisyklę",
  "pu.kuvat_title": "Trūkumo nuotraukos ir priedai",
  "pu.ehdotus_title": "Patvirtina rašybą «{asu}» kaip {nimi} registre. Šaltinio eilutė nekeičiama.",
  "pu.hyvaksy_ehdotus": "Priimti pasiūlymą: {nimi}",
  "pu.aloitettu": "Pradėta",
  "pu.ratkaistu": "Išspręsta",
  "pu.hylkaa": "Atmesti",
  "pu.avaa_uudelleen": "Atidaryti iš naujo",
  "pu.valitse_kohde": "Pasirinkite objektą.",
  "pu.kerro_mika": "Trumpai aprašykite, kas negerai.",
  "pu.linjaa_ei_loydy": "Linijos {linja} pasirinktame objekte nėra. Pasirinkite iš sąrašo arba palikite tuščią.",
  "pu.linja_valinnainen": "Linija (nebūtina)",
  "pu.tyhja_koko_kohde": "tuščia = visas objektas",
  "pu.mika_pielessa": "Kas negerai",
  "pu.mika_pielessa_esim": "Pvz. trūksta 3 linijos matmenų brėžinio",
  "pu.vastuu_esim": "priežiūra, projektavimas…",
  "pu.ulkoinen_vastuu": "Išorinė atsakomybė (reikia pareikalauti, galbūt apmokestinama)",
  "pu.tallennetaan": "Išsaugoma…",
  "pu.kirjaa": "Įrašyti",
  "tk.pvraha.ei": "Be dienpinigių",
  "tk.pvraha.osa": "Daliniai dienpinigiai",
  "tk.pvraha.koko": "Pilni dienpinigiai",
  "tk.pvraha_lyhyt.osa": "daliniai",
  "tk.pvraha_lyhyt.koko": "pilni",
  "tk.teht.hitsaus": "Suvirinimas",
  "tk.teht.esivalmistus": "Išankstinė gamyba",
  "tk.teht.dokumentointi": "Dokumentavimas",
  "tk.teht.korjaus": "Taisymas/izometrija",
  "tk.teht.punch": "Defektai",
  "tk.teht.ndt": "NDT",
  "tk.teht.kokoonpano": "Surinkimas",
  "tk.teht.materiaali": "Medžiagos",
  "tk.teht.muu": "Kita",
  "tk.ohje.kuka": "Kiekvienas prisijungęs naudotojas įrašo savo valandas; su asmeniu nesusieta paskyra įrašyti negali. Administratorius, planuotojas ir darbų vadovas mato visų įrašus, gali įrašyti kito vardu ir patvirtinti įrašą (✓). Kiti mato tik savo įrašus ir gali ištrinti tik savo nepatvirtintą įrašą. Kompensacijų tarifus keičia tik administratorius. Darbo užmokesčio duomenų eksportui taip pat reikia teisės į jautrius asmens duomenis, o kiekvienas eksportas registruojamas.",
  "tk.ohje.luvut": "Suvestinė skaičiuoja valandas, kilometrus ir kompensacijas kiekvienam asmeniui pasirinktam laikotarpiui — patvirtintus ir nepatvirtintus kartu. Eurai skaičiuojami pagal dabartinius tarifus, ne pagal įrašymo metu galiojusius. Išvestinės valandos yra įvertis, o ne išmatuotas laikas: suvirintos siūlės, padaugintos iš normų lentelės valandų pagal vamzdžio dydį, visą siūlę priskiriant šaknies suvirintojui. Įrašytos valandos yra to paties asmens įrašai už tą patį laikotarpį; brūkšnys reiškia, kad įrašų nėra, o ne nulį valandų. Siūlė be vamzdžio dydžio negauna normos ir rodoma kaip įspėjimas.",
  "tk.alkaen": "Nuo",
  "tk.asti": "Iki",
  "tk.henkilo": "Asmuo",
  "tk.kirjaa_tunnit": "+ Įrašyti valandas",
  "tk.korvausluvut": "Kompensacijų tarifai",
  "tk.palkka": "Eksportuoti darbo užmokesčio duomenis (Excel)",
  "tk.palkka_title": "Išvestinės + įrašytos valandos + kompensacijos į Excel (darbo užmokesčio skaičiavimui)",
  "tk.yhteenveto": "Suvestinė",
  "tk.tunnit": "Valandos",
  "tk.km_korvaus": "Kilometrai",
  "tk.km_korvaus_iso": "Kilometrų kompensacija",
  "tk.paivaraha": "Dienpinigiai",
  "tk.korvaukset": "Kompensacijos €",
  "tk.johdetut": "Iš siūlių išvestos valandos",
  "tk.johdetut_hint": "apskaičiuota iš įrašytų siūlių (norma DN→h/siūlei) — atskiro įrašo nereikia",
  "tk.saumoja": "Siūlės",
  "tk.arvio_h": "Įvertis h (norma)",
  "tk.kirjatut_h": "Įrašyta h",
  "tk.dia_tuumaa": "dia-inch",
  "tk.ilman_dn": "{n} be DN",
  "tk.ilman_dn_title": "siūlės be DN → normos nėra",
  "tk.kirjattuja_arvio": "Įrašyta {k} h, įvertis {a} h.",
  "tk.arvio_ei_kirjattuja": "Įvertis pagal normą — įrašytų valandų nėra.",
  "tk.arvio_selite": "Įvertis yra siūlės × normų lentelė DN→h/siūlei (ta pati norma kaip pažangos vaizde), o ne išmatuotas darbas. Kitas laikas (susitikimai, kelionės, laukimas) įrašomas atskirai aukščiau. Siūlės be DN negauna normos — pridėkite DN skiltyje Naršyti.",
  "tk.kirjaukset": "Įrašai",
  "tk.n_rivia": "{n} eilučių",
  "tk.ei_kirjauksia": "Šiuo laikotarpiu įrašų nėra.",
  "tk.pvm": "Data",
  "tk.kohde_paketti": "Objektas / paketas",
  "tk.tehtava": "Užduotis",
  "tk.tehtava_esim": "Suvirinimas…",
  "tk.tila.hyvaksytty": "patvirtinta",
  "tk.hyvaksy": "Patvirtinti",
  "tk.poista": "Ištrinti",
  "tk.poista_kysymys": "Ištrinti įrašą?",
  "tk.anna_tunnit": "Įveskite valandas.",
  "tk.tallennus_virhe": "Išsaugoti nepavyko.",
  "tk.mina": "Aš",
  "tk.tyopaketti": "Darbų paketas",
  "tk.huomiot": "Pastabos",
  "tk.eur_pv": "€/d.",
  "tk.valmis": "Atlikta",
  "tk.asetukset_selite": "Mokesčių institucijos tarifai keičiasi kasmet — įveskite galiojančius. Išsaugoma vos palikus lauką.",
  "hl.vain_pari": "Suvirinimo sesiją gali pradėti tik suvirintojas. Jūs esate suvirintojo pora: suvirintojas pradeda įrašymą ir pasirenka jus lauke «Vamzdynų montuotojas». Jei suvirinate, paprašykite darbų vadovo pridėti jums suvirintojo darbo tipą.",
  "sanat.alihankkija": "subrangovas",
  "sanat.vuokrapaikka": "nuomojamo darbuotojo vieta",
  "sanat.nimeamaton": "nepavadinta vieta",
  "sanat.n_alihankkijaa": "{n} subrangovų",
  "sanat.n_vuokrapaikkaa": "{n} nuomojamų darbuotojų vietų",
  "sanat.n_nimeamatonta": "{n} nepavadintų vietų",
  "nippu.syy_ei_valittuja": "Pirmiausia pasirinkite linijas iš sąrašo.",
  "hen.syy_nimike": "Pirmiausia įveskite pareigas.",
  "rooli.paakayttaja": "Administratorius",
  "rooli.suunnittelija": "Projekto vadovas",
  "rooli.tyonjohtaja": "Darbų vadovas",
  "rooli.kenttatekija": "Lauko darbuotojas",
  "rooli.lukija": "Skaitytojas",
  "rooli.tarkastaja": "Inspektorius",
  "rooli.oppija": "Besimokantysis",
  "pc.vastuu_lyhyt": "Taiso",
  // 18.10.2026 (Toni klo 13.55, vaihtoehto A): havaintosääntöjen kuvaukset (puutekuvaus.ts). Konekäännös, tarkistamatta.
  "puute.k.hitsisuunnitelma_puuttuu": "Trūksta suvirinimo plano: {linja} (įrašyta siūlių: {n})",
  "puute.k.paiva_jasentymaton": "Nepavyksta nuskaityti suvirinimo datos: {hitsi} — šaltinyje {raaka}",
  "puute.k.tyhja": "(tuščia)",
  "puute.k.painekoe_valine": "{linja}: slėgio bandymas {pvm} patvirtintas be matavimo prietaiso (trūksta bandymo slėgio, išlaikymo laiko ar prietaiso)",
  "puute.k.painekoe_kalibrointi": "{linja}: slėgio bandymas {pvm} prietaisu, kurio kalibravimas buvo pasibaigęs ({asti}) — rezultatas negalioja",
  "puute.k.kalusto_ehdotus_kohde": "{laite}: lauko darbuotojo pasiūlyta įranga laukia įrangos atsakingojo patvirtinimo (objektas {kohde})",
  "puute.k.kalusto_ehdotus": "{laite}: lauko darbuotojo pasiūlyta įranga laukia įrangos atsakingojo patvirtinimo",
  "puute.k.iv_tiiviys": "{kohta}: sandarumo bandymas nepavyko — nuotėkio oro srautas {vuoto} dm³/s > riba {raja} dm³/s (klasė {luokka}, {paine} Pa)",
  "puute.k.iv_ilmavirta": "{kohta}: oro srautas už tolerancijos ribų — nuokrypis {poikkeama} % > tolerancija ±{toleranssi} % (projektinis {suunniteltu} l/s, išmatuotas {mitattu} l/s)",
  "puute.k.iv_kal_tiiviys": "{kohta}: sandarumo bandymas {pvm} prietaisu {laite} — prietaiso kalibravimas matavimo dieną negaliojo (galiojo iki {asti})",
  "puute.k.iv_kal_tiiviys_ei": "{kohta}: sandarumo bandymas {pvm} prietaisu {laite} — prietaiso kalibravimas matavimo dieną negaliojo (kalibravimo nėra)",
  "puute.k.iv_kal_ilmavirta": "{kohta}: oro srauto matavimas {pvm} prietaisu {laite} — prietaiso kalibravimas matavimo dieną negaliojo (galiojo iki {asti})",
  "puute.k.iv_kal_ilmavirta_ei": "{kohta}: oro srauto matavimas {pvm} prietaisu {laite} — prietaiso kalibravimas matavimo dieną negaliojo (kalibravimo nėra)",
  "puute.k.paiva_puuttuu": "data nenurodyta",
  "puute.k.ei_kalibrointia": "kalibravimo nėra",
  "puute.k.sulatus_puuttuu": "Siūlei {hitsi} trūksta lydinio numerio",
  "puute.k.materiaali_puuttuu": "Siūlei {hitsi} trūksta medžiagos",
  "puute.k.hitsaaja_tuntematon": "Suvirintojas neatpažintas: kodas {koodi} ({hitsi})",
  "puute.k.rt_hylatty_korjaus": "Siūlės taisymas ir pakartotinis RT: siūlės {hitsi} RT atmesta, protokolas {pk}, {pvm}",
  "puute.k.dn_epaselva": "DN neaiškus: dydis {koko} nėra nei nominalus dydis, nei standartinis išorinis skersmuo, o linijos {linja} pavadinime dydžio nėra — siūlei {nro} neskaičiuojami skersmens coliai",
  "puute.k.ndt_poytakirja_puuttuu": "Trūksta NDT protokolo: linijoje {linja} yra {n} NDT rezultatų be tikrintojo ar protokolo numerio",
  "puute.k.isometri_puuttuu": "Trūksta izometrinio brėžinio: {linja}",
  "puute.k.hitsinumero_puuttuu": "Trūksta siūlės numerio: linijoje {linja} (lapas {lehti}) suvirinta siūlė be numerio — siūlės neįmanoma identifikuoti",
  "puute.k.hitsinumero_epaselva": "Neaiškus siūlės numeris: «{nro}» linijoje {linja} nėra nei numeris, nei papildomas numeris (N arba N.N)",
  "puute.k.korjaus_orpo": "Remonto siūlė be pradinės siūlės: {hitsi}",
  "puute.k.kalusto_katsastus": "{laite}: baigiasi techninės apžiūros terminas",
  "puute.k.henkilo": "{kentta}: neatpažintas vardas «{asu}»",
  "puute.k.henkilo_ehdotus": "{kentta}: neatpažintas vardas «{asu}» — pasiūlymas: {ehdotus} (reikia patvirtinti)",
  "puute.k.patevyys_vanhenee": "{nimi}: {patevyys} baigia galioti",
  "puute.k.patevyys_vanhenee_pvm": "{nimi}: {patevyys} baigia galioti {pvm}",
  "puute.k.patevyys_kesken": "{nimi}: {patevyys} baigia galioti, darbai paskirstyti po to",
  "puute.k.perehdytys": "{nimi}: trūksta objekto instruktažo ({kohde})",
  "puute.k.tarra_normalisointi": "Žyma normalizuota į formą {muoto}: «{raaka}» ({lahde}) → {tallennettu} ({peruste}). Patikrinkite šaltinį.",
  "pc.luokka.A": "blokuoja hidraulinį bandymą",
  "pc.luokka.B": "blokuoja izoliavimo darbus",
  "pc.luokka.C": "nieko neblokuoja",
  "pc.maar.A": "nesuvirinti kamščiai · trūksta tarpinių · neteisingi nuolydžiai · nepatikrinti flanšai",
  "pc.maar.B": "nepriveržtos vamzdžių apkabos · flanšų priveržimas · įžeminimo kabeliai · šildymo kabeliai",
  "pc.maar.C": "dažų pataisymas — linija jau gali būti naudojama",
  "pc.lataus_virhe": "Įkelti nepavyko.",
  "pc.kuvaa_vika": "Aprašykite defektą.",
  "pc.valitse_luokka_virhe": "Pasirinkite blokavimo klasę: ką šis defektas blokuoja (A hidraulinis bandymas · B izoliavimas · C nieko).",
  "pc.otsikko": "Defektų sąrašas",
  "pc.n_avoinna": "{n} atvirų",
  "pc.ei_puncheja": "Defektų nėra.",
  "pc.hitsi_pieni": "siūlė",
  "pc.kuvat_title": "Defekto nuotraukos ir priedai",
  "pc.sulje_kuvat": "Uždaryti nuotraukas",
  "pc.ei_kuvia": "nuotraukų nėra",
  "pc.korjattu": "Ištaisyta",
  "pc.mika_vika": "Koks defektas…",
  "pc.huomioinut_oletus": "Pastebėjo (numatyta: jūs)",
  "pc.huomioinut": "Pastebėjo",
  "pc.huomiopaiva": "Pastebėjimo data (numatyta: šiandien)",
  "pc.luokka_title": "Blokavimo klasė: ko dėl to negalima atlikti",
  "pc.valitse_luokka": "pasirinkite blokavimo klasę",
  "pc.lisaa": "Pridėti defektą",
  "pc.korjatut": "Ištaisyti ({n})",
  "pc.korjattu_pieni": "ištaisė",
  "pc.avaa": "Atidaryti iš naujo",
  "pc.tallenna": "Išsaugoti",
  "hl.vp.su": "Sekmadienis",
  "hl.vp.ma": "Pirmadienis",
  "hl.vp.ti": "Antradienis",
  "hl.vp.ke": "Trečiadienis",
  "hl.vp.to": "Ketvirtadienis",
  "hl.vp.pe": "Penktadienis",
  "hl.vp.la": "Šeštadienis",
  "hl.nimike.putki": "Vamzdis",
  "hl.nimike.kayra": "Alkūnė",
  "hl.nimike.laippa": "Flanšas",
  "hl.nimike.t_haara": "Trišakis",
  "hl.nimike.venttiili": "Vožtuvas",
  "hl.nimike.supistus": "Perėjimas",
  "hl.nimike.kartio": "Kūgis",
  "hl.nimike.tulppa": "Aklė",
  "hl.laji.A": "Montavimo siūlė",
  "hl.laji.E": "Išankstinė gamyba",
  "hl.laji.R": "Remontas",
  "hl.laji.S": "S",
  "hl.ei_oikeutta": "Nėra teisės įrašyti siūlių",
  "hl.ei_oikeutta_selite": "Siūlėms įrašyti reikia suvirintojo, darbų vadovo arba planuotojo teisių.",
  "hl.aloita_kirjaus": "Pradėti įrašymą",
  "hl.vaihe.esivalmistettu": "Iš anksto pagaminta {pvm} / {koodi} — bus įrašyta kaip montavimas",
  "hl.vaihe.asennettu": "Sumontuota {pvm} / {koodi} — etapas įrašomas vieną kartą. Remontą žymėkite kaip remontą (R).",
  "hl.vaihe.lisatty": "įrašyta, etapas {vaihe} (ta pati siūlė)",
  "hl.vaihe.esivalmiste": "išankstinė gamyba",
  "hl.vaihe.asennus": "montavimas",
  "hl.ei_tehda": "Siūlė nereikalinga",
  "hl.ei_tehda.selite": "Pažymėkite, kad jungtis visai nebus virinama. Įrašą patvirtina darbų vadovas.",
  "hl.ei_tehda.esitys": "Pasiūlymas įrašytas. Įrašą patvirtina darbų vadovas.",
  "hl.ei_tehda.merkitty": "Pažymėta: siūlė nereikalinga.",
  "het.otsikko": "Siūlė nereikalinga",
  "het.lehti": "Brėžinio lapas",
  "het.valitse_lehti": "pasirinkite lapą",
  "het.ei_lehtia": "lapų nėra",
  "het.numero": "Siūlės numeris",
  "het.numero_esim": "pvz. 8",
  "het.peruste": "Kodėl jungtis nevirinama",
  "het.peruste_esim": "pvz. linija pertrasuota, siūlė 8 atsisakyta",
  "het.merkitse": "Pažymėti",
  "het.peruuta": "Atšaukti",
  "het.vihje_suurin": "Didžiausias įrašytas numeris yra {suurin}. Siūlomas kitas,",
  "het.vihje_numeroimattomia": " tačiau linijoje yra {n} eilučių be numerio — patikrinkite izometriją.",
  "het.vihje_tarkista": " patikrinkite izometriją.",
  "het.vihje_tyhja": "Linijoje nėra sunumeruotų siūlių, todėl siūloma 1. Patikrinkite numerį izometrijoje.",
  "het.monta_lehtea": "Linijoje yra {n} brėžinio lapų, todėl lapo negalima užpildyti iš anksto. Numeracija yra pagal lapą: be tinkamo lapo numeris nerezervuojamas tame lape, kuriame jungtis įrašyta.",
  "het.selite": "Į žurnalą pridedama eilutė, pažymėta «nereikalinga», ir ji lieka matoma. Numeris rezervuojamas: jei jungtis vis dėlto suvirinama, pirmiausia reikia atšaukti įrašą. Perdavimo dokumentacijoje sprendimas pažymimas patvirtintu tik paskirtam tvirtintojui jį patvirtinus — darbai dėl to nestabdomi.",
  "het.virhe": "Įrašo išsaugoti nepavyko.",
  "ohje.kuka": "Kas ką gali daryti",
  "ohje.luvut": "Ką reiškia skaičiai",
  "ohje.ohje": "Pagalba",
  "ohje.pienenna": "Sutraukti pagalbą į vieną eilutę",
  "ohje.avaa": "Atidaryti pagalbą",
  "tuloste.kieli": "Ataskaitos kalba",
  "tuloste.kohteen_kieli": "Objekto numatytoji",
  "kohde.otsikko": "Objektas",
  "kohde.kaikki": "Visi objektai",
  "kohde.ei_suodata": "Visi objektai — šis vaizdas nefiltruojamas pagal viršutinėje juostoje pasirinktą objektą.",
  "hl.tyonjohdon_tuloste": "Darbų vadovo spaudinys",
  "hl.virallinen_loki": "Oficialus suvirinimo žurnalas",
  "hl.vaihda_linja": "Keisti liniją",
  "hl.mille_paivalle": "Kuriai dienai įrašote?",
  "hl.tanaan": "Šiandien",
  "hl.jatka_edellista": "Tęsti ankstesnę dieną {pvm} (prieš {n} d.)",
  "hl.kirjataan_paivalle": "Įrašoma dienai",
  "hl.linja_poistunut": "Linijos {linja} nebėra — sesija uždaryta.",
  "hl.tyomaa_allokaatiosta": "Objektas {tunnus} pasirinktas pagal jūsų paskirstymą ({peruste}). Pakeiskite, jei esate kitur.",
  "hl.ei_tyomaata": "Nematote jokio objekto: {peruste}.",
  "hl.perustiedot_virhe": "Nepavyko įkelti pagrindinių duomenų.",
  "hl.esivalinta_ei_loydy": "Linija {linja} nerasta — jos nėra arba ji priklauso objektui, kurio nematote.",
  "hl.esivalinta_monta": "Linija {linja} yra {n} objektuose. Pasirinkite liniją iš sąrašo.",
  "hl.hitsia_tanaan": "siūlių šiandien",
  "hl.halkaisijatuumaa": "skersmens colių",
  "hl.omia_hitseja_tanaan": "savų siūlių šiandien",
  "hl.omia_tuumia": "savų skersmens colių",
  "hl.puutetta_auki": "atvirų trūkumų",
  "hl.jatka_mista_jait": "Tęsti nuo ten, kur baigėte",
  "hl.omat_viimeisimmat": "Jūsų naujausios linijos",
  "hl.lehti_pieni": "lapas",
  "hl.n_hitsia": "{n} siūlių",
  "hl.jumissa_tyhja": "Kas užblokuota: nieko — atvirų trūkumų nėra.",
  "hl.jumissa": "Kas užblokuota",
  "hl.jumissa_jarjestys": "Pirmiausia blokuojantys, po to seniausi",
  "hl.vastuu_avoin": "nėra atsakingo",
  "hl.ulkoinen": "išorinis",
  "hl.havaittu_tanaan": "aptikta šiandien",
  "hl.havaittu_sitten": "aptikta prieš {n} d.",
  "hl.avaa_linja": "Atidaryti liniją",
  "hl.kenelle_ja_mihin": "Kas ir kur",
  "hl.asetetaan_kerran": "Nustatoma vieną kartą — po to kiekviena siūlė yra vienas paspaudimas",
  "hl.linja": "Linija",
  "hl.ei_osumia": "Nėra atitikmenų",
  "hl.valitusta_kohteesta": "pasirinktame objekte",
  "hl.tarkista_kirjoitusasu": "Patikrinkite rašybą arba pasirinkite Visi objektai.",
  "hl.kirjoita_linjan_alku": "Įveskite linijos pradžią, pavyzdžiui",
  "hl.ei_isometria": "nėra izometrijos",
  "hl.ei_hitsaajia": "Nė vienas asmuo neturi kompetencijos Suvirintojas. Pridėkite ją vaizde Personalas, kitaip negalima pasirinkti jokio suvirintojo.",
  "hl.lehti": "Lapas",
  "hl.valitse_viivat": "— pasirinkite —",
  "hl.muu_kirjoita": "Kita (įveskite)…",
  "hl.johdettu_isometrista": "išvesta iš izometrijos ({mitta})",
  "hl.hitsaaja": "Suvirintojas",
  "hl.mina": "aš",
  "hl.koodi_ei_listalla": "Jūsų kodo {koodi} nėra suvirintojų sąraše (trūksta kompetencijos Suvirintojas). Siūlė įrašoma jūsų kodu, tačiau kvalifikacijos patikra neatpažįsta jūsų kaip suvirintojo. Paprašykite darbų vadovo pridėti kompetenciją.",
  "hl.asentaja": "Vamzdynų montuotojas",
  "hl.prosessi": "Procesas",
  "hl.materiaali": "Medžiaga",
  "hl.lisaaine": "Pridėtinis metalas",
  "hl.materiaali_pakollinen": "Medžiaga privaloma: vien lydinio numeris nenurodo, kokia tai medžiaga, o be jos negalima susieti medžiagos sertifikato.",
  "hl.lehti_pakollinen": "Lapas privalomas: numeracija yra pagal lapą, o be jo vienodi siūlių numeriai skirtinguose lapuose susilietų.",
  "hl.ei_isometria_selite": "Ši linija neturi izometrijos, todėl lapo nėra ir siūlės numeruojamos iš eilės pagal liniją. Spraga įrašoma ir rodoma su atsakingu asmeniu vaizde Trūkumai.",
  "hl.muu": "Kita…",
  "hl.nimike_pieni": "elementas",
  "hl.anna_numero": "Įveskite siūlės numerį.",
  "hl.sulatus_puuttuu_merkitty": "trūksta lydinio numerio, įrašyta kaip trūkumas",
  "hl.teko.toisto": "jau buvo išsaugota ankstesniu pateikimu — antra eilutė nesukurta",
  "hl.teko.taydennetty": "užpildyta (suplanuota → suvirinta)",
  "hl.teko.kirjattu": "įrašyta",
  "hl.hitsi": "Siūlė",
  "hl.kirjaus_ei_onnistunut": "Įrašyti nepavyko.",
  "hl.kohde_pieni": "objektas",
  "hl.ohje.kuka": "Jūs įrašote savo siūles. Siūlė su papildomu numeriu (pvz. 6.1) yra lauke atliktas papildymas: ji išsaugoma iš karto ir paliekama patvirtinti darbų vadovui — darbai nestabdomi.",
  "hl.ohje.numerot_otsikko": "Siūlių numeriai",
  "hl.ohje.numerot": "Sveikasis numeris (6) yra suplanuota siūlė. Papildoma numeracija prasideda nuo x.1: tarp siūlių 6 ir 7 eina 6.1, 6.2 ir t. t. — niekada 7.x. Prieš siūlę 1 naudokite 0.1, 0.2 ir t. t. Panaudotas papildomas numeris niekada nenaudojamas pakartotinai, net jei siūlė buvo ištrinta.",
  "hl.punakyna.miksi": "Kodėl ši siūlė buvo atlikta",
  "hl.punakyna.esim": "pvz. perkelta atrama",
  "hl.punakyna.selite": "{numero} yra papildomas numeris, t. y. lauke atliktas papildymas. Jis išsaugomas iš karto ir paliekamas patvirtinti darbų vadovui — darbai nestabdomi.",
  "hl.tarra": "Žyma",
  "hl.suunnitellut": "Suplanuotos — spustelėkite, kad užpildytumėte",
  "hl.suunniteltu_title": "Suplanuota siūlė — užpildykite spaudą + datą",
  "hl.jo_kirjattu": "Jau įrašyta",
  "hl.alinumero": "Subnumeris",
  "hl.seuraava_vapaa": "kitas laisvas {nro}",
  "hl.haetaan_vapaata": "ieškomas kitas laisvas numeris…",
  "hl.vapaana_valissa": "Laisva tarpe",
  "hl.osat_ja_sulatukset": "Detalės ir lydinių numeriai",
  "hl.vaihda": "Keisti",
  "hl.osa_n": "Detalė {n}",
  "hl.osa_n_pieni": "detalė {n}",
  "hl.nimike": "Gaminys",
  "hl.sulatus": "Lydinio nr.",
  "hl.sulatusnumero": "lydinio numeris",
  "hl.materiaali_molemmat": "Medžiaga (abi detalės)",
  "hl.esim_316l": "pvz., 316L",
  "hl.sulatus_puuttuu": "trūksta lydinio numerio",
  "hl.kohderistiriita": "Sesijos linija {linja} yra objekte {kohde}, bet pasirinktas objektas {valittu}. Įrašymas užblokuotas: pakeiskite liniją («Keisti liniją») arba pasirinkite objektą {kohde}.",
  "hl.kirjataan": "Įrašoma…",
  "hl.kirjaa_hitsi": "Įrašyti siūlę {numero}",
  "hl.korjaa_istunnosta": "pataisykite sesijos nustatymuose (Keisti liniją).",
  "hl.sulatukset_periytyvat": "Lydinių numeriai perkeliami iš siūlės į siūlę. Pakeiskite juos, kai keičiasi vamzdis — tai vienintelė vieta, kur pamiršus nutrūksta atsekamumas.",
  "hl.viimeksi_kirjatut": "Neseniai įrašytos",
  "hl.n_viimeisinta": "{n} naujausių",
  "hl.sulatukset": "Lydinių numeriai",
  "hl.paiva": "Data",
  "hl.sulje": "Uždaryti",
  "hl.kuvat_n": "Nuotraukos ({n})",
  "hl.lisaa_kuva": "+ Nuotrauka",
  "hl.korjaa": "Redaguoti",
  "hl.kuvat_hitsi": "Nuotraukos · siūlė {nro}",
  "hl.muu_paiva": "Kita data…",
  "hl.valitse": "Pasirinkti",
  "hl.peruuta": "Atšaukti",
  "vtm.puuttuu_1": "Trūksta VT {n} siūlei",
  "vtm.puuttuu_n": "Trūksta VT {n} siūlėms",
  "vtm.ilman_tulosta": "{n} su VT įrašu, bet be priimto rezultato",
  "ltar.k71": "Atitiktis brėžiniams",
  "ltar.k72": "Suvirinimas ir NDT",
  "ltar.k73": "Medžiagos ir komponentai",
  "ltar.k74": "Vamzdžių atramos ir tvirtinimai",
  "ltar.k75": "Nuolydžiai, oro išleidimas ir drenažas",
  "ltar.k76": "Flanšinės ir varžtinės jungtys",
  "ltar.k77": "Švara ir paviršiaus apdorojimas",
  "ltar.k78": "Bandymo paruošimo parengtis",
  "ltar.k79": "Žymėjimai",
  "ltar.ei_tarkastettu": "nepatikrinta",
  "ltar.syy_tayta": "Užpildykite visus 9 punktus",
  "ltar.syy_punchit": "{n} atvirų defektų — pataisykite prieš patvirtinimą",
  "ltar.syy_tuleva": "Perdavimo data yra ateityje — linijos negalima perduoti iš anksto",
  "ltar.syy_edustaja": "Būtinas užsakovo atstovas — linija apeinama kartu su atstovu",
  "ltar.syy_ei_tilaa": "Nepavyko įkelti defektų būsenos — patvirtinimas užblokuotas, kol ji neįkelta",
  "ltar.syy_a": "{n} atvirų A klasės defektų — pataisykite juos arba įrašykite nukrypimą",
  "ltar.tallennus_virhe": "Nepavyko išsaugoti.",
  "ltar.ladataan": "Įkeliama…",
  "ltar.otsikko": "Linijos patikra (apėjimas)",
  "ltar.hyvaksytty": "Patvirtinta",
  "ltar.lahteen_poytakirja": "šaltinio protokolas",
  "ltar.kesken": "Vykdoma",
  "ltar.ei_aloitettu": "Nepradėta",
  "ltar.huomio": "pastaba",
  "ltar.nayta_punchit": "Rodyti punch įrašus",
  "ltar.paneeli_otsikko": "Atviri linijos punch įrašai ({n})",
  "ltar.paneeli_tyhja": "Linijoje nėra atvirų punch įrašų.",
  "ltar.paneeli_luokaton": "neklasifikuotas",
  "ltar.paneeli_nasta": "izometrijos smeigtukas {n}",
  "ltar.merkinta_lisaa": "+ pridėti naują",
  "ltar.merkinta_hitsi": "siūlė: nr. arba žyma (tuščia = visas punktas)",
  "ltar.merkinta_kohta": "visas punktas",
  "ltar.merkinta_tallenna": "Pridėti defektą",
  "ltar.merkinta_peru": "Atšaukti",
  "ltar.merkinta_korjattu": "ištaisyta",
  "ltar.hitsi_ei_loydy": "Siūlė «{h}» šioje linijoje vienareikšmiškai nerasta.",
  "virhe.hitsi_eri_linjalla": "Siūlė nėra šioje linijoje.",
  "ltar.tarkastaja": "Tikrintojas",
  "ltar.pvm": "Data",
  "ltar.huomiot": "Pastabos",
  "ltar.luovutus": "Užsakovo atstovas",
  "ltar.luovutus_ohje": "Linijos patikros metu linija apeinama kartu su užsakovo atstovu, kai ji paruošta slėgio bandymui. Patvirtinantysis yra jūsų prisijungusi paskyra.",
  "ltar.edustaja": "Užsakovo atstovas",
  "ltar.edustaja_pieni": "užsakovo atstovas",
  "ltar.nimi": "vardas",
  "ltar.luovutuspaiva": "Perdavimo data",
  "ltar.luokittelemattomia": "Šioje linijoje yra {n} atvirų defektų be blokavimo klasės. Jie neblokuoja patvirtinimo, bet nežinoma, ką jie blokuoja.",
  "ltar.a_punchit": "Linijoje yra {n} atvirų A klasės defektų (blokuoja hidraulinį bandymą). Linijos patikrai reikia juos pataisyti arba įrašyti nukrypimą.",
  "ltar.poikkeaman_syy": "Nukrypimo priežastis (įrašoma jūsų vardu)",
  "ltar.poikkeama_oikeus": "Nukrypimą gali įrašyti tik paskyra, turinti šio objekto teisę «Defekto nukrypimas».",
  "ltar.tallenna": "Išsaugoti",
  "ltar.hyvaksy_title": "Patvirtinti linijos patikrą: linija paruošta NDT ir slėgio bandymui",
  "ltar.hyvaksy": "Patvirtinti linijos patikrą",
  "ltar.luovutettu": "Perduota",
  "ltar.hyvaksyja": "patvirtino",
  "ltar.luovuttaja": "perdavė",
  "ltar.poikkeama_kirjattu": "Nukrypimas: {n} atvirų A klasės defektų",
  "ltar.allekirjoitettu_isometri": "Pasirašyta izometrija",
  "ltar.isometri_puuttuu": "Priedo nėra.",
  "ltar.tunnistetieto_title": "Pataisykite tikrintojo vardą, datą ar pastabas — patvirtinimas išlieka",
  "ltar.tunnistetieto": "Išsaugoti identifikavimo duomenis",
  "ltar.avaa_uudelleen": "Atidaryti iš naujo (atšaukti patvirtinimą)",
  "ltar.poytakirja": "Patikros protokolas",
  "nippu.syy_tarkastettu": "jau patikrinta",
  "nippu.syy_ei_hitseja": "linijoje nėra siūlių",
  "nippu.syy_hitsaamatta": "{n} siūlių nesuvirinta",
  "nippu.syy_numeroton": "{n} eilučių be numerio su data ar suvirintoju — taisytina pagrindiniame žurnale",
  "nippu.syy_a_punchit": "{n} atvirų A klasės defektų",
  "nippu.syy_estavat": "{n} blokuojančių trūkumų",
  "nippu.syy_rt": "Atviras RT taisymas, siūlė {hitsit}",
  "nippu.aloittamaton": "eilutė pagrindiniame žurnale nepradėta, patikrinkite",
  "nippu.lataus_virhe": "Nepavyko įkelti rinkinio.",
  "nippu.haku_virhe": "Nepavyko įkelti.",
  "nippu.minun": "Mano rinkinys",
  "nippu.valmiit": "Paruošta linijos patikrai",
  "nippu.lisatty": "Į rinkinį įtraukta linijų: {n}.",
  "nippu.lisays_virhe": "Nepavyko įtraukti į rinkinį.",
  "nippu.kaikki": "visos",
  "nippu.linja": "Linija",
  "nippu.haku_esim": "Paieška: ID, terpė arba DN (pvz., APR 200)",
  "nippu.isometri": "Izometrinis brėžinys",
  "nippu.isometri_pieni": "izometrinis brėžinys",
  "nippu.on_isometri": "yra izometrija",
  "nippu.ei_isometria": "nėra izometrijos",
  "nippu.vain_valmiit": "tik paruoštos",
  "nippu.valmiita": "Paruošta linijos patikrai",
  "nippu.joista_isometri": "iš jų su izometrija",
  "nippu.valmis_maaritelma": "Paruošta = visos siūlės suvirintos, nėra atvirų A klasės defektų ar blokuojančių trūkumų, dar nepatikrinta. NDT nėra sąlyga (linijos patikra prieš NDT).",
  "nippu.valitse_kaikki": "Pasirinkti visas matomas paruoštas linijas ({n})",
  "nippu.ota": "Paimti rinkinį ({n})",
  "nippu.tila": "Būsena",
  "nippu.valitse_linja": "Pasirinkti {tunnus}",
  "nippu.nipussa": "rinkinyje",
  "nippu.on": "taip",
  "nippu.ei": "ne",
  "nippu.valmis": "paruošta",
  "nippu.tyhja": "Rinkinys tuščias. Pasirinkite linijas iš sąrašo «Paruošta linijos patikrai».",
  "nippu.tehty": "Atlikta",
  "nippu.tehty_pieni": "atlikta",
  "nippu.seuraava_pieni": "kita",
  "nippu.kaikki_kasitelty": "visos apdorotos",
  "nippu.avaa_seuraava": "Atidaryti kitą",
  "nippu.ohitettu": "praleista",
  "nippu.poista_aria": "Pašalinti {tunnus} iš rinkinio",
  "nippu.poista": "pašalinti",
  "nippu.nippu": "Rinkinys",
  "nippu.linja_id": "linija {id}",
  "nippu.edellinen": "Ankstesnė",
  "nippu.ohita": "Praleisti",
  "nippu.seuraava": "Kita",
  "nippu.v_tarkastus": "Patikra",
  "nippu.v_hitsit": "Siūlės",
  "nippu.hitsit_virhe": "Nepavyko įkelti siūlių.",
  "nippu.ladataan_hitseja": "Įkeliamos siūlės…",
  "nippu.ei_hitseja": "Linijoje nėra siūlių.",
  "nippu.ndt_ei": "nėra NDT",
  "nippu.ndt_hylatty": "NDT atmesta",
  "nippu.ndt_hyvaksytty": "NDT priimta",
  "nippu.ndt_kesken": "NDT vykdoma",
  "nippu.avoin_punch": "Atviras defektas",
  "nippu.hitsattu": "suvirinta",
  "nippu.suunniteltu": "suplanuota",
  "nippu.prosessi": "procesas",
  "nippu.tarra": "žyma",
  "psel.otsikko": "Defektai",
  "psel.avointa": "atviri",
  "psel.naytetaan": "rodoma {n}",
  "psel.haku": "Ieškoti linijos ar defekto…",
  "psel.vain_avoimet": "Tik atviri",
  "psel.avoimia_listalla": "{n} atvirų sąraše",
  "psel.ei_loydoksia": "Defektų nėra.",
  "psel.luokka": "Klasė",
  "psel.vika": "Defektas",
  "psel.huomioinut": "Užfiksavo",
  "psel.avaa_linja": "Atidaryti liniją",
  "psel.korjattu": "pataisyta",
  "psel.kuittaaja_ei_tiedossa": "uždarė nežinomas",
  "psel.avoin": "atviras",
  "eten.kaikki": "Visi",
  "eten.ohje.kuka": "Rodinys skirtas tik skaitymui, čia niekas nekeičiama. Jį mato visi, kurie naudoja suvirinimo žurnalą; objektais apribota paskyra mato tik savo objektų pažangą, o «Visi» tada reiškia visus jos objektus.",
  "eten.ohje.luvut": "Dia-inch yra jungties vamzdžio dydis coliais: jis suteikia didesnį svorį didelėms jungtims ir nėra ilgio vienetas. Jungtis be vamzdžio dydžio neįtraukiama nei į skaitiklį, nei į vardiklį, todėl procentas apima tik jungtis, kurių dydis žinomas — aprėptis rodoma šalia skaičių. Įtraukiamos tik suvirintos jungtys. Kreivė kyla nuo jungčių su įrašyta suvirinimo data. Juosta yra atliktas darbas, kurio savaitė nežinoma, bet apribota kitų linijos jungčių datomis: apatinė ir viršutinė riba, ne pasiskirstymas. Raudona punktyrinė linija yra viskas, kas suvirinta, įskaitant jungtis be datos. Savaitės tempas yra paskutinių keturių suvirinimo savaičių vidurkis — tuščios savaitės jo nemažina.",
  "eten.di_hitsattu": "dia-inch suvirinta",
  "eten.kayralla": "kreivėje",
  "eten.josta_kaistana": ", iš jų {p} juostoje",
  "eten.hitsia": "siūlės",
  "eten.mitattu": "jungčių išmatuota — {n} be vamzdžio dydžio nėra nė viename aukščiau esančiame skaičiuje",
  "eten.di_vko": "dia-inch / savaitė (pask. 4)",
  "eten.hitsia_vko": "siūlės / savaitė (pask. 4)",
  "eten.ajoittamaton": "{di} dia-inch ({p}) suvirinto darbo nėra kreivėje",
  "eten.ajoittamaton_jatko": "jis atliktas, bet nežinome kada.",
  "eten.paivaton": "{n} siūlių neturi datos.",
  "eten.epakelpo": "{n} siūlių turi neįmanomą datą.",
  "eten.kaistaan": "{di} dia-inch ({p}) priskirta juostai, jų savaitę riboja kitos linijos siūlės.",
  "eten.tahti_pieni": "Todėl tempas ir iš jo išvesta prognozė yra per maži.",
  "eten.ei_paivattyja": "Šiam pasirinkimui nėra siūlių su data.",
  "eten.viikko": "Savaitė",
  "eten.alku": "Pradžia",
  "eten.hitsia_sarake": "Siūlės",
  "eten.kumulat": "Kaup.",
  "eten.kaista": "Juosta",
  "eten.kaavio_aria": "Kaupiamoji dia-inch S kreivė, juosta ir viso darbo linija",
  "eten.hitsattu_yhteensa": "iš viso suvirinta {n} di",
  "eten.kaista_selite_lyhyt": "juosta = atliktas darbas, kurio savaitė apribota, bet nežinoma",
  "eten.s_viiva": "ištisinė linija",
  "eten.s_viiva_sel": "darbas su data, kaupiamieji dia-inch savaitės pabaigoje",
  "eten.s_piste": "taškas",
  "eten.s_piste_sel": "viena savaitė (ta pati eilutė kaip lentelėje)",
  "eten.s_kaista": "šviesi juosta",
  "eten.s_kaista_sel": "suvirintas, bet be datos darbas, kurio savaitę riboja kitos linijos siūlės (apatinė–viršutinė riba, ne tiksli reikšmė)",
  "eten.s_katko": "punktyrinė linija",
  "eten.s_katko_sel": "iš viso suvirinta, įskaitant darbą, kurio negalima datuoti; tarpas tarp jos ir kreivės yra darbas be datos",
  "kal.syy_valitse_rivit": "Pirmiausia pasirinkite eilutes, kurias patvirtinsite arba atmesite.",
  "liite.avaa_isona": "Atidaryti {nimi} padidintą",
  "liite.haku_virhe": "Nepavyko įkelti priedų.",
  "liite.lahetys_virhe": "įkėlimas nepavyko.",
  "liite.tallennettu": "Priedas išsaugotas.",
  "liite.tallennettu_n": "Išsaugota priedų: {n}.",
  "liite.poista_kysymys": "Ištrinti {nimi}?",
  "liite.poistettu": "Priedas ištrintas.",
  "liite.poisto_virhe": "Nepavyko ištrinti.",
  "liite.ei_liitteita": "Priedų nėra.",
  "liite.kuva_merkki": "VAIZDAS",
  "liite.suojattu_title": "Yra asmens duomenų",
  "liite.suojattu": "apsaugota",
  "liite.poista": "Ištrinti",
  "liite.lahetetaan": "Įkeliama…",
  "liite.henkilotieto_vihje": "Šie priedai pažymėti kaip jautrūs: juos mato tik turintys teisę «Jautrūs asmens duomenys», o kiekvienas atidarymas registruojamas.",
  "liite.luku_virhe": "Nepavyko nuskaityti failo",
  "isom.v_urakoitsija": "Rangovas",
  "isom.v_tilaaja": "Užsakovas",
  "isom.v_suunnittelija": "Projektuotojas",
  "isom.v_materiaali": "Medžiagų tiekėjas",
  "isom.v_eristys": "Izoliacija",
  "isom.v_sahko": "Elektra ir automatika",
  "isom.lataus_virhe": "Nepavyko įkelti izometrijų.",
  "isom.ladataan": "Įkeliamos izometrijos…",
  "isom.otsikko": "Izometrija ir žymėjimai",
  "isom.tyhja": "Linijai nepriskirta jokia izometrija. Izometrijos importuojamos per importą «Izometrijos PDF formatu» skiltyje Naršyti; neatpažintos ten laukia priskyrimo. Žemiau galite pridėti nuotrauką ir joje žymėti.",
  "isom.pohja_aria": "Žymėjimų pagrindas",
  "isom.piirustus": "brėžinys",
  "isom.lehti": "Lapas",
  "isom.n_merk": "{n} žym.",
  "isom.kuva": "Nuotrauka",
  "isom.aiemmat": "Ankstesnės revizijos ({n})",
  "isom.korvattu": "pakeista",
  "isom.yleiskuva": "Žymima bendrajame vaizde ({n} psl.). Detalių puslapiai:",
  "isom.sivu": "{n} psl.",
  "isom.valokuvat": "Linijos nuotraukos kaip žymėjimų pagrindas",
  "isom.lisaa_valokuva": "Pridėti nuotrauką",
  "isom.kuvaa_vika": "Aprašykite defektą.",
  "isom.tallennus_virhe": "Nepavyko išsaugoti — bandykite dar kartą, įrašas nebus išsaugotas du kartus.",
  "isom.revisio": "revizija",
  "isom.korvattu_uudemmalla": "pakeista naujesne revizija",
  "isom.valokuva": "Nuotrauka",
  "isom.avoimia": "{n} atvirų žymėjimų",
  "isom.napauta": "palieskite tašką",
  "isom.merkitaksesi": "kad pažymėtumėte defektą",
  "isom.lahenna": "Priartinti",
  "isom.loitonna": "Nutolinti",
  "isom.sovita": "Pritaikyti",
  "isom.isometrin_sivu": "Izometrijos puslapis",
  "isom.linjan_valokuva": "Linijos nuotrauka",
  "isom.edellinen_revisio": "ankstesnė revizija",
  "isom.uusi": "Naujas žymėjimas",
  "isom.estoluokka": "Blokavimo klasė",
  "isom.vastuu": "Atsakingas (kas taiso)",
  "isom.tallenna": "Išsaugoti žymėjimą",
  "isom.peru": "Atšaukti",
  "isom.tallennettu": "Žymėjimas #{n} išsaugotas",
  "isom.tallennettu_jatko": "kaip defektas. Pridėkite defekto nuotrauką:",
  "isom.kuva_viasta": "Defekto nuotrauka",
  "isom.luokka_pieni": "klasė",
  "isom.vastuu_pieni": "atsakingas",
  "isom.merkitsi": "Pažymėjo",
  "isom.kuittaus_listasta": "Pataisymas patvirtinamas defektų sąraše.",
  "isom.poista_kysymys": "Ištrinti",
  "isom.poista_selite": "Jis dingsta iš sąrašų ir linijos; failas išsaugomas, administratorius gali jį atkurti.",
  "isom.syy_valinnainen": "Priežastis (neprivaloma)",
  "isom.poista_silti": "Vis tiek ištrinti (linijoje lieka {n} žymėjimų)",
  "isom.vahvista_poisto": "Patvirtinti ištrynimą",
  "sel.laji_s": "Papildomas bandymas",
  "sel.vahvistettavat_virhe": "Nepavyko įkelti patvirtinimo laukiančių pakeitimų.",
  "sel.historia_virhe": "Nepavyko įkelti istorijos.",
  "sel.vahvistus_virhe": "Nepavyko patvirtinti.",
  "sel.hylkays_virhe": "Nepavyko atmesti.",
  "sel.peruutus_virhe": "Nepavyko atšaukti.",
  "sel.ehdotus_virhe": "Nepavyko gauti pasiūlymo.",
  "sel.lisays_virhe": "Nepavyko pridėti.",
  "sel.merkinta_virhe": "Nepavyko išsaugoti žymėjimo.",
  "sel.linjaa_ei_loydy": "Linija {tunnus} nerasta — jos nėra arba ji priklauso objektui, kurio nematote.",
  "sel.korvattu": "Linijos ID {vanha} pakeistas į {uusi} ({miten}, aptikta {pvm}). Nukreipta į naują ID.",
  "sel.lahde_ratkaisi": "išspręsta šaltinyje",
  "sel.uusi_ei_listassa": "Naujo ID nėra jūsų sąraše — jis priklauso objektui, kurio nematote.",
  "sel.linja_poistettu": "Linija {tunnus} išimta iš naudojimo ir neturi pakaitalo.",
  "sel.monta_osumaa": "Linijos ID {tunnus} yra {n} objektuose. Pasirinkite liniją iš sąrašo.",
  "sel.ohje_kuka": "Naršymą mato naudotojai, kurie naudoja suvirinimo žurnalą; lauko darbuotojai — tik turintys suvirinimo specialybę, o objektais apribotos paskyros — tik savo objektus. Siūles taiso administratoriai, planuotojai ir darbų vadovai, o lauko darbuotojai — savo ir savo poros siūles per 24 valandas nuo įrašymo. Linijų redagavimas, slėgio bandymas, defektai ir Excel ciklas: administratorius, planuotojas ir darbų vadovas. Siūlių ir priedų trynimas bei importas: administratorius ir planuotojas. Lauke atliktą pakeitimą patvirtina raudonojo žymėjimo patvirtinimo teisės turėtojas.",
  "sel.ohje_luvut": "Linijos «X / Y» yra linijos siūlių eilutės (įskaitant suplanuotas) ir suplanuotų siūlių skaičius. Defektų skaičius yra atviri defektai. Siūlių sąraše rodoma ne daugiau kaip 500 vėliausiai įrašytų. NDT aprėptis yra patikrintos siūlės (priimtos ar atmestos), palyginti su reikalaujama suvirintų dalimi; tuščia reiškia, kad reikalavimas neįrašytas — ne kad jis įvykdytas. «~» prie datos žymi apytikslę datą.",
  "sel.linjat_otsikko": "Linijos iš Excel",
  "sel.linjat_selite": "Atsisiųskite šabloną, užpildykite linijas ir importuokite. Linijos sukuriamos žemiau pasirinktame objekte. Esamos nekeičiamos, nebent atskirai pažymite atnaujinimą; bandomasis paleidimas prieš išsaugant parodo, kas bus sukurta, kas pasikeistų ir kurios eilutės atmetamos.",
  "sel.linjat_esto": "Prieš importuodami pasirinkite objektą žemiau — linijos importuojamos po vieną objektą.",
  "sel.linjat_paivitys": "Taip pat atnaujinti esamas linijas pagal aukščiau išvardytus skirtumus",
  "sel.ndt_otsikko": "NDT reikalavimai iš Excel",
  "sel.ndt_selite": "Objekto NDT reikalavimai pagal PED kategoriją ir metodą. Linijos NDT aprėptis skaičiuojama pagal juos — be reikalavimų aprėptis nieko neskaičiuoja. Reikalavimai importuojami į žemiau pasirinktą objektą; esami nekeičiami.",
  "sel.ndt_esto": "Prieš importuodami pasirinkite objektą žemiau — reikalavimai importuojami po vieną objektą.",
  "sel.wps_otsikko": "WPS sąrašas iš Excel",
  "sel.wps_selite": "Suvirinimo procedūrų specifikacijos yra bendras įmonės sąrašas, iš kurio renkamasi įrašant siūles. Atsisiųskite šabloną, užpildykite ir importuokite; esamos nekeičiamos.",
  "sel.haku_placeholder": "Paieška: ID, terpė arba DN (pvz., APR 200)",
  "sel.kaikki_linjat": "Visos linijos",
  "sel.kaikki_punchit": "Visi defektai",
  "sel.odottaa_vahvistusta": "Laukia patvirtinimo",
  "sel.ei_linjoja": "Linijų nėra.",
  "sel.linjaa": "linijos",
  "sel.naytetaan": "rodoma {n}",
  "sel.avoimia_puncheja": "atviri defektai",
  "sel.punch_lyh": "defektai",
  "sel.valitse_ohje": "Pasirinkite liniją, \"Visos linijos\", \"Visi defektai\" arba \"Laukia patvirtinimo\".",
  "sel.ei_vahvistettavia": "Nėra patvirtinimo laukiančių elementų.",
  "sel.otsikko_vahvistettavat": "Laukia patvirtinimo · {n} pakeitimų",
  "sel.otsikko_kaikki": "Visos linijos · {n} siūlių",
  "sel.otsikko_kaikki_rajattu": "Visos linijos · rodoma {n} naujausių / iš viso {yht}",
  "sel.n_hitsia": "{n} siūlių",
  "sel.sulje_linjatiedot": "Uždaryti linijos duomenis",
  "sel.muokkaa_linjaa": "Redaguoti liniją",
  "sel.ei_tehda_title": "Pažymėti, kad jungtis visai nebus daroma, nors jos nėra sąraše. Sukuria eilutę ir rezervuoja numerį.",
  "sel.ndt_kattavuus": "NDT aprėptis",
  "sel.ei_ndt_vaatimusta": "Vamzdžių klasei {luokka} NDT reikalavimas neįrašytas — aprėpties apskaičiuoti negalima.",
  "sel.ei_ped_luokkaa": "Linijai neįrašyta PED kategorija, todėl reikalavimo rasti negalima.",
  "sel.vaadittu_title": "reikalaujama {p} % · {kpl}/{yht}",
  "sel.ndt_vaje": "NDT trūkumas",
  "sel.ndt_vaje_teksti": "linija neparuošta slėgio bandymui. Prieš slėgio bandymą atlikite patikras; atlikto slėgio bandymo įrašymui dabar reikia pagrindimo, ir pagrindimas lieka eilutėje.",
  "sel.ei_hitseja": "Įrašytų siūlių nėra.",
  "sel.nro": "Nr.",
  "sel.laji": "Tipas",
  "sel.osat_sulatus": "Detalės (lydinio nr.)",
  "sel.sulatus_taydennetty": "Lydinio numeris papildytas vėliau",
  "sel.sul_lyh": "Lydinys",
  "sel.punakyna_title": "Lauke atliktas pakeitimas: papildoma siūlė su subnumeriu arba sprendimas, kad jungtis nebus daroma",
  "sel.punakyna": "Raudonasis žymėjimas",
  "sel.tarra_title": "Fizinė žyma šalia suvirinimo siūlės",
  "sel.ei_valittu": "nepasirinkta",
  "sel.punakyna_historia": "Raudonojo žymėjimo istorija",
  "sel.t_lisa_hyvaksymatta": "papildoma siūlė · nepatvirtinta",
  "sel.t_ei_toteudu_odottaa": "nereikalinga · laukia patvirtinimo",
  "sel.t_lisa_hylatty": "papildoma siūlė · atmesta",
  "sel.t_lisa_hyvaksytty": "papildoma siūlė patvirtinta",
  "sel.t_ei_toteudu_hyvaksytty": "nereikalinga · patvirtinta",
  "sel.t_ei_toteudu_tyonjohto": "nereikalinga · darbų vadovas",
  "sel.kuvat_n": "nuotraukos ({n})",
  "sel.vahvista_title": "Patvirtinkite arba atmeskite lauke atliktą siūlės {nro} pakeitimą",
  "sel.vahvista_lisa": "Patvirtinti: papildoma siūlė {nro}",
  "sel.vahvista_ei_toteudu": "Patvirtinti: {nro} nereikalinga",
  "sel.lisaa_hitsi_title": "Pridėti naują siūlę po {nro} su subnumeriu (pvz., {nro}.1). Lauko papildymas, laukiantis darbų vadovo patvirtinimo.",
  "sel.lisaa_hitsi": "+ siūlė",
  "sel.ei_toteudu_title": "Pažymėti, kad siūlė {nro} nebus daroma. Eilutė lieka žurnale ir neįtraukiama į aprėpties skaičiavimą; reikia pagrindimo, o žymėjimą galima atšaukti.",
  "sel.ei_toteudu": "Nereikalinga",
  "sel.kuvat_hitsi": "Nuotraukos · siūlė {nro}",
  "sel.putkiluokka": "Vamzdžių klasė",
  "sel.ped_luokka": "PED kategorija",
  "sel.suunn_hitseja": "Suplanuotos siūlės",
  "sel.isometri_olemassa": "Izometrija yra",
  "sel.tallenna_linja": "Išsaugoti liniją",
  "sel.osa_nimike": "Detalės {n} gaminys",
  "sel.osa_sulatus": "Detalės {n} lydinio nr.",
  "sel.ndt_ja_painekoe": "NDT ir slėgio bandymas",
  "sel.ei_tarkastuksia": "Patikrų neįrašyta.",
  "sel.ndt_kesken": "vykdoma",
  "sel.ndt_hyvaksytty": "priimta",
  "sel.ndt_hylatty": "atmesta",
  "sel.ei_numeroa": "be numerio",
  "sel.poytakirja": "Protokolas",
  "sel.menetelma": "Metodas",
  "sel.painekoe": "slėgio bandymas",
  "sel.esim_poytakirja": "pvz., RT-26-168",
  "sel.lisaa_tarkastus": "Pridėti patikrą",
  "sel.pk_esitys": "Pasiūlyta papildoma siūlė",
  "sel.pk_ei_toteudu_esitys": "Pasiūlyta: nereikalinga",
  "sel.pk_lisays": "Papildoma siūlė patvirtinta",
  "sel.pk_ei_toteudu": "Patvirtinta: nereikalinga",
  "sel.pk_peruutus": "Atšaukimas",
  "sel.pk_hylkays": "Atmesta",
  "sel.kirjattu_lisa": "Įrašyta — papildoma siūlė {nro}",
  "sel.kirjattu_ei_toteudu": "Įrašyta — {nro} nereikalinga",
  "sel.lisahitsi_nro": "Papildoma siūlė {nro}",
  "sel.hitsi_ei_toteudu": "Siūlė {nro} nereikalinga",
  "sel.emo": "pagrindinė",
  "sel.alinumero_ilman_esitysta": "Subnumeris be pasiūlymo (įrašytas iki 153) — vis dar galima patvirtinti.",
  "sel.asetettu_hyvaksyja": "paskirtas tvirtintojas",
  "sel.tyonjohto_ei_riita": "darbų vadovas — nepakanka perdavimui",
  "sel.peruttu": "atšaukta",
  "sel.peruutus_vaatii": "Atšaukimui reikia pagrindimo",
  "sel.peru_tama": "Atšaukti tai",
  "sel.ei_punakynaa": "Šiai siūlei raudonasis žymėjimas neįrašytas.",
  "sel.peruutuksen_perustelu": "Atšaukimo priežastis",
  "sel.peruutus_placeholder": "pvz., patvirtinta ne tai siūlei",
  "sel.peru_hyvaksynta": "Atšaukti patvirtinimą",
  "sel.pk_vihje_lyhyt": "Raudonasis žymėjimas patvirtina arba su priežastimi atmeta pakeitimą, atliktą eilutės veiksmu («+ siūlė» arba «Nereikalinga»). Darbų vadovo patvirtinimas galioja iš karto; į perdavimo dokumentaciją sprendimas įeina kaip patvirtintas tik iš paskirto tvirtintojo.",
  "sel.lue_lisaa": "Skaityti daugiau",
  "sel.asemassa": "Vaidmenyje",
  "sel.valitse_asema": "Pasirinkite vaidmenį",
  "sel.hylkayksen_peruste": "Atmetimo priežastis (privaloma)",
  "sel.vahvistuksen_perustelu": "Patvirtinimo priežastis",
  "sel.hylkays_placeholder": "kodėl pakeitimas atmetamas",
  "sel.vahvistus_placeholder": "pvz., izometrijos pakeitimas 12.9., atšaka perkelta",
  "sel.hyvaksyn_asemassa": "Tvirtinu vaidmenyje",
  "sel.kelpaa_luovutukseen": "tinka perdavimui",
  "sel.ei_riita_luovutukseen": "nepakanka perdavimui",
  "sel.vahvista": "Patvirtinti",
  "sel.hylkaa_ellipsi": "Atmesti…",
  "sel.vanha_ei_hylata": "Senas subnumeris be pasiūlymo neatmetamas — jis patvirtinamas arba ištrinamas.",
  "sel.pk_vihje": "Raudonasis žymėjimas yra patvirtinimas: pakeitimas atliktas eilutės veiksmu («+ siūlė» arba «Nereikalinga»), o čia jis patvirtinamas arba atmetamas su pagrindimu. Atmesta papildoma siūlė lieka eilutėje su būsena «atmesta»; atmestas «nereikalinga» atkuria eilutę. «Nereikalinga» neištrina siūlės: eilutė lieka kaip sprendimo įrašas ir iš NDT aprėpties vardiklio iškrenta tik patvirtinus.",
  "sel.pk_vihje_tj": "Darbų vadovo patvirtinimas",
  "sel.pk_vihje_heti": "galioja iš karto",
  "sel.pk_vihje_loppu": ", ir darbas dėl jo nesustoja. Į perdavimo dokumentaciją sprendimas įeina kaip patvirtintas tik iš paskirto tvirtintojo — tai kitas klausimas nei «ar galima tai nuspręsti».",
  "sel.valiin_otsikko": "Pridėti siūlę tarpe",
  "sel.valiin_selite": "Nauja siūlė eina po numerio {nro}{lehti}.",
  "sel.lehdella": "lape {lehti}",
  "sel.hitsinumero": "Siūlės numeris",
  "sel.miksi_tarvitaan": "Kodėl reikia šios siūlės",
  "sel.valiin_placeholder": "pvz., atrama perkelta, jungtis pridėta 12.9.",
  "sel.hitsattu_nyt": "Suvirinta dabar — įrašoma šiandienai",
  "sel.suunniteltu_myohemmin": "Suplanuota — įrašoma kaip suvirinta, kai bus atlikta",
  "sel.lisaa_nro": "Pridėti {nro} — laukia patvirtinimo",
  "sel.lisaa_suunniteltuna": "Pridėti {nro} kaip suplanuotą — laukia patvirtinimo",
  "sel.valiin_vihje": "Siūlė išsaugoma iš karto ir laukia darbų vadovo patvirtinimo — ji nedingsta ir neblokuoja darbo. Pagrindimas yra sakinys, kurį skaito tvirtintojas.",
  "sel.valiin_vihje_suunniteltu": "Suplanuota papildoma siūlė lauko įrašyme rodoma kaip suplanuota ir iš ten įrašoma kaip suvirinta; jei ji nedaroma, pažymėkite «Nereikalinga».",
  "sel.alinumero_virhe": "Papildomos siūlės numeris yra jos pagrindinės siūlės {kanta} subnumeris, pvz., {kanta}.1. «{nro}» toks nėra.",
  "sel.miksi_ei_tehda": "Kodėl jungtis nebus daroma",
  "sel.ei_toteudu_placeholder": "pvz., linija ištiesinta, atšaka atsisakyta",
  "sel.merkitse_odottaa": "Pažymėti — laukia patvirtinimo",
  "sel.ei_toteudu_vihje": "Žymėjimas laukia patvirtinimo: eilutė lieka žurnale ir iš aprėpties skaičiavimo iškrenta tik tada, kai tvirtintojas (lauko darbų vadovas arba paskirtas tvirtintojas) patvirtina ją raudonajame žymėjime. Atmestas žymėjimas atkuria eilutę.",
  "sel.linjan_puutteet": "Linijos trūkumai ({n})",
  "sel.linjan_puutteet_suljetut": "Uždaryti ({n})",
  "sel.ei_puutteita": "Šiai linijai trūkumų neįrašyta. Norėdami įrašyti: Trūkumai → «Įrašyti trūkumą» → Linija.",
  "sel.kuvia_n": "nuotraukos {n}",
  "hub.ohje.kuka": "Suvestinę mato kiekviena įmonės paskyra; objektais apribota paskyra mato tik savo objektus. Užsakovai nemato komplektavimo ir darbuotojų. Pasiūlymų kortelę mato tik {roolit} be objekto apribojimo. Kiekvienas gali išsaugoti savo kortelių išdėstymą; vaidmens numatytąjį gali išsaugoti tik administratorius.",
  "hub.ja": " ir",
  "hub.tila.aktiivinen": "VYKDOMAS",
  "hub.tila.keskeytetty": "SUSTABDYTAS",
  "hub.tila.peruuntunut": "ATŠAUKTAS",
  "hub.tila.valmis": "BAIGTAS",
  "hub.tila.suunnitteilla": "PLANUOJAMAS",
  "hub.ei_varaa": "NEREZERVUOJA PAJĖGUMŲ",
  "hub.avaa": "Atidaryti: {nimi}",
  "hub.kohdetta_ei_loydy": "Objektas {tunnus} nerastas — jo nėra arba jūs jo nematote.",
  "hub.asettelu.oma": "savas išdėstymas",
  "hub.asettelu.rooli": "numatytasis vaidmeniui {rooli}",
  "hub.asettelu.oletus": "numatytasis išdėstymas",
  "hub.muokkaa_nakymaa": "Redaguoti rodinį",
  "hub.tallenna_omaksi": "kaip mano išdėstymą",
  "hub.tallenna_rooliin": "kaip numatytąjį vaidmeniui {rooli}",
  "hub.asetettu": " (nustatyta)",
  "hub.tallennus_epaonnistui": "Išsaugoti nepavyko: {virhe}",
  "hub.palautus_epaonnistui": "Atkurti nepavyko: {virhe}",
  "hub.palauta_oletus": "Atkurti numatytąjį",
  "hub.tyhja_asettelu": "Išsaugotas išdėstymas paslėpė visas korteles — rodomas numatytasis. Redaguokite rodinį ir grąžinkite korteles arba atkurkite numatytąjį.",
  "hub.muokkaustila": "Redagavimo režimas: perkelkite su ▲ ▼, paslėpkite arba parodykite. Pakeitimas tampa nuolatinis tik išsaugojus.",
  "hub.ohje.luvut": "Kiekvienas skaičius yra nuoroda į eilutes, iš kurių jis suskaičiuotas. Pažanga yra siūlių su data dia-inch iš viso objekto dia-inch, o juosta rodo siūlių skaičių (su data · be datos · suplanuotos). NDT % yra suvirintų jungčių, patikrintų bent kartą, dalis. Pasirengimas perdavimui yra pradėtų linijų vidurkis pagal penkis punktus; nepradėta linija procento negauna. Objektas be linijų nėra išmatuojamas — tai ne nulis. Pajėgumus rezervuoja tik vykdomas objektas.",
  "hub.kohde_ylapalkista": "Objektas: {kohde} (pasirinktas viršutinėje juostoje)",
  "hub.kohde_iso": "OBJEKTAS",
  "hub.valitse_kohde": "Pasirinkite objektą…",
  "hub.ei_linjoja_suluissa": "  (nėra linijų)",
  "hub.valitse_kohde_ohje": "Pasirinkite objektą, kad iš karto matytumėte visą jo būseną.",
  "hub.piilotettu": "PASLĖPTA",
  "hub.siirra_ylos": "Perkelti aukštyn",
  "hub.siirra_alas": "Perkelti žemyn",
  "hub.nayta_kortti": "Rodyti kortelę",
  "hub.piilota_kortti": "Slėpti kortelę",
  "hub.nayta": "Rodyti",
  "hub.piilota": "Slėpti",
  "hub.perustiedot": "Pagrindiniai duomenys",
  "hub.asiakas": "Užsakovas: {asiakas}",
  "hub.kesto": "Trukmė: {alku} – {loppu}",
  "hub.tyonro": "Darbo nr.: {nro}",
  "hub.ei_mitattavissa_iso": "NEIŠMATUOJAMA",
  "hub.ei_linjoja_selite": "Objekte nėra linijų. Pažangos, kokybės ir pasirengimo perdavimui išmatuoti negalima — tai ne nuliai.",
  "hub.etenema_otsikko": "Suvirinimo žurnalo pažanga",
  "hub.dia_inch_suhde": "dia-inch {tehty} / {tavoite}",
  "hub.linjaa": "linijos",
  "hub.linjaa_hitsattu": "linijos · suvirinta {hitsattu}/{hitseja}",
  "hub.suunniteltu_lisa": " · suplanuota {n}",
  "hub.paivatty": "su data {n}",
  "hub.paivaamaton": "be datos {n}",
  "hub.suunniteltu_n": "suplanuota {n}",
  "hub.saumoja": " (siūlės)",
  "hub.paivattomat_varoitus": "{n} suvirinta be datos — atlikta, bet nerodoma kreivėje",
  "hub.odottaa_vahvistusta": "pakeitimai laukia patvirtinimo",
  "hub.laatu": "Kokybė ir patikra",
  "hub.ndt_hitsatusta": "NDT ({n}/{m} suvirintų)",
  "hub.avointa_punchia": "atviri defektai",
  "hub.rt_hylatty": "{n} RT atmesta (taisytina)",
  "hub.laitetta": "įrangos vienetai",
  "hub.vaihetta_kuitattu": "patvirtinti etapai",
  "hub.liitosta_kuitattu": "patvirtintos jungtys",
  "hub.iv.valmius": "pasirengimas perdavimui (ŠVOK)",
  "hub.iv.jarjestelmaa": "sistemos",
  "hub.iv.osuuksia": "ortakių atkarpos su patvirtintu sandarumu (išmatuota {n})",
  "hub.iv.paatteita": "sureguliuoti galiniai įrenginiai (išmatuota {n})",
  "hub.iv.ei_osuuksia": "Nėra ortakių atkarpų — pasirengimas neišmatuojamas.",
  "hub.miehitys": "Komplektavimas",
  "hub.n_muuta": "+{n} daugiau",
  "hub.tyopaketeista": "iš darbų paketų",
  "hub.paattynyt": "IŠĖJO",
  "hub.pkt": "{n} pkt.",
  "hub.ei_miehitysta_tp": "Nėra komplektavimo. Išvedama iš darbų paketų vykdytojų.",
  "hub.ei_miehitysta": "Nėra paskirstyto personalo.",
  "hub.tarjous_nro": "Pasiūlymas #{id}",
  "hub.puutteet_luokittain": "Trūkumai pagal tipą",
  "hub.ei_avoimia_puutteita": "Nėra atvirų trūkumų.",
  "hub.siru.pysayttaa": "STABDO DARBĄ",
  "hub.siru.hidastaa": "LĖTINA",
  "hub.luku.aloitettua": "pradėtos linijos",
  "hub.luku.aloittamatonta": "nepradėtos linijos",
  "hub.aloitetusta": "pradėtų",
  "hub.aloittamatta_suhde": "/ {n} nepradėta",
  "hub.aukkoa": "{n} SPRAGOS",
  "hub.seuraava_vaihe": "Kitas etapas · {n} / {m} linijų",
  "hub.luku.seuraava_vaihe": "kitas etapas: {vaihe}",
  "hub.vaihe.hitsaus": "vyksta suvirinimas",
  "hub.vaihe.punchit": "atviri A defektai",
  "hub.vaihe.linjatarkastus": "linijos patikra neatlikta (arba su nukrypimu)",
  "hub.vaihe.ndt": "NDT neatlikta",
  "hub.vaihe.painekoe": "slėgio bandymas neatliktas",
  "hub.vaihe.luovutus": "perdavimas neatliktas",
  "hub.vaihe.valmis": "perduota",
  "hub.dim.loki": "Žurnalas užbaigtas",
  "hub.dim.ndt": "NDT atlikta",
  "hub.dim.walkdown": "Apžiūra patvirtinta",
  "hub.dim.ei_punchia": "Nėra atvirų defektų",
  "hub.enn.ei_arvioitavissa": "neįvertinama",
  "hub.enn.tanaan": "šiandien",
  "hub.enn.ei_ikkunaa": "nėra lango",
  "hub.enn.tarve": "Bendra prognozė sudaroma, kai išmatuojamas kiekvienas iš penkių etapų — išmatuojami {n} / 5; trūkstamų pataisymas nurodytas eilutėje «Kas tai pakeistų».",
  "hub.enn.ilman_luokkaa": "be klasės",
  "hub.enn.primaari": "Pirminės atramos",
  "hub.enn.sekundaari": "Antrinės atramos",
  "hub.enn.primaari_sel": "liečia vamzdį (padai, apkabos, slankiosios atramos, inkarai)",
  "hub.enn.sekundaari_sel": "jungia pirminę atramą su pastato konstrukcija (strypai, kronšteinai, bėgiai)",
  "hub.enn.luku.kannake_kesken": "{nimi} — vykdoma (užsakovo %)",
  "hub.enn.tilannekuva": "momentinė būklė, ne tempas",
  "hub.enn.ei_tiedossa": "nežinoma",
  "hub.enn.ei_tuotu": "užsakovo stebėsena šiam objektui neimportuota",
  "hub.enn.valmiusaste_tiedossa": "parengtis žinoma",
  "hub.enn.tiedossa_rivi": "{n} linijose, vidurkis {ka} % · užsakovo stebėsena {pvm}",
  "hub.enn.tahti_mitattavissa": " · tempas išmatuojamas ({n} linijos su dviem būklės momentais)",
  "hub.enn.tahti_toisesta": " · tempas išmatuojamas nuo antrojo importo",
  "hub.enn.ketjun_kohta": "vieta grandinėje neišmatuota",
  "hub.enn.tuonti_progress": "importas iš užsakovo Progress lapo (atramų importas)",
  "hub.enn.toinen_tuonti": "antrasis importas su nauja būklės data duoda pirmąjį tempą",
  "hub.enn.otsikko": "Užbaigimo prognozė",
  "hub.enn.aikaisin_myohaisin": "anksčiausiai – vėliausiai, penki etapai grandinėje (etapas nebaigiamas anksčiau už ankstesnį)",
  "hub.enn.tahti_peruste": "tempas pagal paskutinių {n} darbo dienų faktinius duomenis ({ikkuna}), sklaida iš penkių dienų laikotarpių",
  "hub.enn.ei_kokonaisennustetta": " · neišmatuotas etapas nėra baigtas, todėl bendra prognozė nepateikiama",
  "hub.enn.vaihe": "Etapas",
  "hub.enn.jaljella": "Liko",
  "hub.enn.tahti": "Tempas",
  "hub.enn.valmis_oma": "Baigta (atskirai)",
  "hub.enn.ketjussa": "Grandinėje",
  "hub.enn.muuttaisi": "Kas tai pakeistų",
  "hub.enn.jaljella_selite": "{vaihe} — liko",
  "hub.enn.tahti_arvo": "{tahti} linijų/darbo dieną",
  "hub.enn.tayttyi": "{n} užbaigta",
  "hub.enn.jaksot": ", laikotarpiai {a}–{b}",
  "hub.enn.leikattu": ", langas nukirptas ties {pvm}",
  "hub.enn.paivaton": "{n} užbaigta be datos — nepriskirta, į tempą neįtraukta",
  "hub.enn.arkipaivaa": "{n} darbo dienų vidutiniu tempu",
  "hub.enn.ketju_katkennut": "grandinė nutrūko",
  "hub.enn.nimittaja": "Vardiklis:",
  "hub.enn.nimittaja_rivi": "{n} linijų sistemoje (pradėta {a} · nepradėta {b} · žurnalas užbaigtas {c}).",
  "hub.enn.jaljella_lasketaan": "Likutis skaičiuojamas iš visų linijų, suvestinės pasirengimas perdavimui — iš pradėtų: apžiūra {w}, slėgio bandymas {p} ir NDT {ndt} atlikti nepradėtose linijose, kurių aukščiau esanti kortelė neskaičiuoja.",
  "hub.enn.rajaus": "Apimtis:",
  "hub.enn.linjan_tila": "linijos būsena {tilat}",
  "hub.enn.kesken_selite": " — duomenų bazėje nėra klasifikacijos vykdoma/baigta/neatlikta, todėl kiekviena linija lieka, kol etapas užbaigiamas.",
  "hub.enn.avoimet_punchit": "Atviri defektai:",
  "hub.enn.punch_luokat": "{luokat} (A blokuoja hidraulinį bandymą, B blokuoja izoliavimo darbus, C nieko neblokuoja).",
  "hub.enn.kannakointi": "Atramos:",
  "hub.enn.tilaajan_arvo": "užsakovo vertė {n} linijose,",
  "hub.enn.luku.kannake_ei_tiedossa": "atramos nežinomos",
  "hub.enn.ristiriita": "prieštaravimas: užsakovo montavimas 100 % / antrinės vykdomos:",
  "hub.enn.luku.ristiriita": "prieštaravimas: montavimas 100 %, antrinės vykdomos",
  "hub.enn.ristiriita_jatko": "linijos — atrodo baigtos, bet nėra. Šaltinis: {lahde}. Užsakovo Progress % formulė nekartojama.",
  "hub.enn.suunniteltu_varoitus": "Suplanuotų siūlių eilučių {n}, mediana {m} nepradėtai linijai — izometrijų siūlių skaičius neimportuotas, todėl «žurnalas užbaigtas» reiškia «suvirintos visos sistemai žinomos eilutės», o likusio suvirinimo skaičius yra apatinė riba.",
  "hub.kirjaukset": "Naujausi įrašai",
  "hub.ei_kirjauksia": "Nėra įrašų su data.",
  "esto.moduuli": "Modulis nenaudojamas",
  "esto.rooli": "Nepakankamas vaidmuo",
  "esto.rajaus": "Paskyra apribota objektais",
  "esto.tyolaji": "Trūksta darbo rūšies",
  "esto.paasy": "Prieiga",
  "esto.otsikko": "Nėra prieigos",
  "esto.osoite": "adresas",
  "esto.pyysit": "Paprašėte rodinio «{nimi}», bet ši paskyra jo neturi. Jūs nebuvote nukreipti — tai atsakymas būtent į šį adresą.",
  "esto.pyyda": "Jei rodinys reikalingas darbui, kreipkitės į administratorių. Vaidmenis ir objektų apribojimus jis mato rodinyje Naudotojų paskyros, o darbo rūšis — rodinio Personalas pareigose; modulius įjungia tiekėjas.",
  "esto.siirry": "Eiti į rodinį «{nimi}»",
  "hl.sulatus_kysy": "Tas pats lydinio numeris kaip ankstesnės siūlės?",
  "hl.sulatus_kysy.kirjaaja": "Ankstesnę siūlę įrašė kita paskyra.",
  "hl.sulatus_kysy.linja": "Linija pasikeitė.",
  "hl.sulatus_kysy.lehti": "Lapas pasikeitė.",
  "hl.sulatus_kysy.tauko": "Nuo ankstesnio įrašo praėjo daugiau nei {h} val.",
  "hl.sulatus_kylla": "Taip, tas pats",
  "sal.sulje_kopioimatta": "Dar nenukopijavote reikšmės. Uždarius jos niekur nebebus galima gauti — vis tiek uždaryti?",
  "sal.lahetettiin_alku": "Nuoroda išsiųsta adresu",
  "sal.lahetettiin_loppu": ". Ji rodoma tik dabar.",
  "sal.vain_nyt": "Rodoma tik dabar. Uždarius reikšmės niekur nebebus galima gauti.",
  "sal.kopioitu": "Nukopijuota",
  "sal.kopioi": "Kopijuoti",
  "sal.kaikki_kopioitu": "Viskas nukopijuota",
  "sal.kopioi_kaikki": "Kopijuoti viską",
  "sal.tulosta": "Spausdinti",
  "sal.lahetys_virhe": "Išsiųsti nepavyko.",
  "sal.lahetetaan": "Siunčiama…",
  "sal.laheta_sahkopostilla": "Siųsti el. paštu: {osoite}",
  "sal.ei_lahetysta": "Siuntimas el. paštu negalimas: {syy}.",
  "sal.ei_osoitetta": "gavėjas neturi el. pašto adreso",
  "sal.tallennettu_sulje": "Išsaugojau — uždaryti",
  "pin.nelja_numeroa": "PIN susideda iš keturių skaitmenų.",
  "pin.ei_tasmaa": "PIN kodai nesutampa.",
  "pin.vaihto_virhe": "Pakeisti nepavyko.",
  "pin.vaihda": "Keisti PIN",
  "pin.ohje": "Sveiki, {nimi}. Jūsų dabartinį PIN nustatė administratorius, todėl prieš tęsdami pakeiskite jį savo. Jūsų naujo PIN niekas kitas nematys.",
  "pin.nykyinen": "Dabartinis PIN",
  "pin.uusi": "Naujas PIN (4 skaitmenys)",
  "pin.toisto": "Pakartokite naują PIN",
  "pin.vaihdetaan": "Keičiama…",
  "vie.haku_virhe": "Nepavyko įkelti pranešimų.",
  "vie.merkinta_virhe": "Nepavyko pažymėti kaip perskaityto.",
  "vie.tiedotteet": "Pranešimai",
  "vie.ohje.kuka": "Kiekvienas mato savo gautuosius. Siuntimui, išsiųstųjų sąrašui ir atšaukimui reikia teisės «Siųsti pranešimus», o objektais apribotas siuntėjas gali siųsti tik savo objekto darbų vadovams. Savo pranešimą galite atšaukti nurodę priežastį; administratorius gali atšaukti bet kurį pranešimą.",
  "vie.ohje.luvut": "Raudonas skaičius meniu yra neperskaitytų galiojančių pranešimų skaičius. «Perskaitė X / Y» — perskaičiusieji iš visų gavėjų, kurie užfiksuojami siunčiant pranešimą. Nebegaliojantis pranešimas gavėjui dingsta, bet lieka siuntėjo sąraše.",
  "vie.saapuneet": "Gautieji",
  "vie.ei_saapuneita": "Nėra galiojančių pranešimų.",
  "vie.voimassa_asti": "galioja iki {pvm}",
  "vie.luettu_pvm": "perskaityta {pvm}",
  "vie.merkitse_luetuksi": "Pažymėti kaip perskaitytą",
  "vie.syy_otsikko_viesti": "Įrašykite temą ir pranešimą.",
  "vie.syy_otsikko": "Įrašykite temą.",
  "vie.syy_viesti": "Įrašykite pranešimą.",
  "vie.syy_kohde": "Pasirinkite objektą, kurio darbų vadovai gaus pranešimą.",
  "vie.ei_vastata": "Į pranešimus programoje neatsakoma — tai skelbimai.",
  "vie.ei_oikeutta": "Pranešimus siunčia tie, kuriems administratorius rodinyje Naudotojų paskyros suteikė teisę «Siųsti pranešimus».",
  "vie.ei_vastaanottajia": "Nepasirinkta gavėjų. Pasirinkite atskirus gavėjus arba «Visi objekto darbų vadovai» — tuščias pasirinkimas nereiškia nei niekam, nei visiems. Pranešimas neišsiųstas.",
  "vie.lahetetty_n": "Išsiųsta {n} gavėjui (-ams).",
  "vie.lahetys_virhe": "Išsiųsti nepavyko.",
  "vie.peru_kysymys": "Kodėl pranešimas atšaukiamas? (rodoma išsiųstųjų sąraše)",
  "vie.peruutus_virhe": "Atšaukti nepavyko.",
  "vie.laheta_tiedote": "Siųsti pranešimą",
  "vie.kenelle": "Kam",
  "vie.kaikille": "Visiems",
  "vie.valituille": "Pasirinktiems asmenims",
  "vie.kohteen_tyonjohdolle": "Objekto darbų vadovams",
  "vie.voimassa_kentta": "Galioja iki (neprivaloma)",
  "vie.valitse_tyonjohtajat": "Pasirinkite visus objekto darbų vadovus arba atskirus. Tuščias pasirinkimas nereiškia nei niekam, nei visiems.",
  "vie.valitse_vastaanottajat": "Pasirinkite gavėjus.",
  "vie.kaikki_tyonjohtajat": "Visi objekto darbų vadovai ({n})",
  "vie.ei_tyonjohtajia": "Objektas neturi darbų vadovų — pranešimas neturi gavėjų.",
  "vie.otsikko": "Tema",
  "vie.viesti": "Pranešimas",
  "vie.laheta": "Siųsti",
  "vie.lukitaan_vihje": "Gavėjai užfiksuojami siunčiant pranešimą, o išsiųsto pranešimo redaguoti negalima. Pranešimas rodomas tik programoje — ne el. paštu.",
  "vie.lahetetyt": "Išsiųsti",
  "vie.ei_lahetettyja": "Nėra išsiųstų pranešimų.",
  "vie.luettu_x_y": "perskaitė {x} / {y}",
  "vie.peruttu": "atšauktas",
  "vie.vanhentunut": "nebegalioja",
  "vie.peru": "Atšaukti",
  "vie.vastaanottajat": "Gavėjai",
  "vie.lukematta": "neperskaityta",
  "hen.yrita_uudelleen": "Bandyti dar kartą",
  "hen.haku_virhe": "Nepavyko įkelti duomenų.",
  "pat.todistuksia_liitteena": "Pridėta sertifikatų: {n}",
  "pat.nahty_ei_liitteena": "Matyta sertifikate, nepridėta",
  "pat.ei_varmennettu_title": "Nepatvirtinta — sertifikatas nematytas",
  "pat.todistus": "Sertifikatas",
  "pat.myonnetty": "Išduota",
  "pat.voimassa_asti": "Galioja iki",
  "pat.eyebrow": "Kvalifikacijos",
  "pat.otsikko": "Kas ką gali daryti ir kiek dar laiko",
  "pat.kirjaa": "Įrašyti kvalifikaciją",
  "pat.ohje.kuka": "Kvalifikacijas įrašo ir šalina administratorius ir planuotojas. Kiti mato sąrašą.",
  "pat.ohje.varoitus": "Įspėjimas rodomas likus 90 ir 30 dienų iki kvalifikacijos galiojimo pabaigos.",
  "pat.ohje.liitteena": "sertifikatas pridėtas ·",
  "pat.ohje.nahty": "sertifikatas matytas, bet nepridėtas ·",
  "pat.ohje.ei_varmennettu": "nepatvirtinta.",
  "pat.ohje.tarkea": "Svarbi informacija yra arba patvirtinta, arba pažymėta kaip neaiški, bet niekada nespėjama.",
  "pat.ei_riskeja": "Per artimiausias {n} sav. nėra darbų su baigiančia galioti kvalifikacija.",
  "pat.riskit_otsikko": "Darbai su baigiančia galioti kvalifikacija",
  "pat.riskit_hint": "{n} vnt. · artimiausios {v} sav.",
  "pat.riski_otsikko": "{nimi}: {patevyys} baigia galioti {pvm}",
  "pat.riski_teksti": "{kohde} · po to {h} val. darbo, paskutinis {pvm}.",
  "pat.huomiota_vaativat": "Reikia dėmesio",
  "pat.kaikki": "Visos ({n})",
  "pat.ei_huomioitavaa": "Nieko, kam reikėtų dėmesio",
  "pat.ei_kirjattuja": "Kvalifikacijų neįrašyta",
  "pat.kaikki_voimassa": "Visos įrašytos kvalifikacijos galioja ilgiau nei 90 dienų.",
  "pat.kirjaa_ensimmainen": "Įrašykite pirmąją kvalifikaciją ir čia bus rodomas galiojimo pabaigos laikas.",
  "pat.haku": "Ieškoti pagal asmenį ar kvalifikaciją…",
  "pat.piilossa": "{n} paslėpta paieškos",
  "pat.yksikko": "kvalifikacijos",
  "pat.patevyys": "Kvalifikacija",
  "pat.voimassa": "Galioja",
  "pat.voimassaolo": "Galiojimas",
  "pat.vrk_sitten": "prieš {n} d.",
  "pat.vrk_jaljella": "liko {n} d.",
  "pat.henkiloa": "{n} asmenys",
  "pat.liite_virhe": "Kvalifikacija išsaugota, bet sertifikato įkelti nepavyko: {virhe} Jį galite pridėti iš sąrašo mygtuku Sertifikatas.",
  "pat.tuntematon_virhe": "nežinoma klaida",
  "pat.uusinta_korvaa": "Atnaujinimas pakeičia to paties asmens tą pačią kvalifikaciją",
  "pat.nahty_todistuksesta": "Matyta sertifikate",
  "pat.poista_valinta": "Pašalinti pasirinkimą",
  "pat.liite_todentaa": "Pridėtas sertifikatas pažymi kvalifikaciją kaip patvirtintą.",
  "pat.kasin_annettu": "Data įvesta rankiniu būdu. Pagal tipo trukmę būtų",
  "pat.laskettu_kestosta": "Apskaičiuota pagal tipo trukmę ({kk} mėn.). Pakeiskite datą, jei sertifikate nurodyta kitaip.",
  "pat.ei_vanhene_vihje": "Ši kvalifikacija nebaigia galioti. Įveskite datą, jei ji nurodyta sertifikate.",
  "pat.kk": "{kk} mėn.",
  "pat.uusi_tyyppi": "Naujas kvalifikacijos tipas",
  "pat.uusi_tyyppi_esim": "Karštųjų darbų pažymėjimas",
  "pat.lisaa_tyyppi": "Pridėti tipą",
  "pat.tiedoston_luku": "Nepavyko perskaityti failo",
  "hpa.otsikko": "Kvalifikacijos",
  "hpa.poista": "Šalinti kvalifikaciją",
  "hpa.lisaa": "Pridėti kvalifikaciją…",
  "hpa.todistus_nahty": "Sertifikatas matytas",
  "hpa.kirjaa": "Įrašyti",
  "hpa.valitse_tyyppi": "Pasirinkite kvalifikacijos tipą.",
  "hpa.vihje": "Kvalifikacijos rodomos ir rodinyje Kvalifikacijos. {nimi}: pridėkite sertifikatą, kad žymė taptų žalia ir veiktų priminimas apie galiojimo pabaigą.",
  "hpo.otsikko": "Neatvykimai",
  "hpo.ei_kirjattuja": "Neatvykimų neįrašyta.",
  "hpo.kaynnissa": "vyksta",
  "hpo.mennyt": "praėjęs",
  "hpo.tuleva": "būsimas",
  "hpo.poista": "Šalinti neatvykimą",
  "hpo.lisaa": "Pridėti neatvykimą…",
  "hpo.alkaa": "Pradžia",
  "hpo.paattyy": "Pabaiga",
  "hpo.huomiot": "Pastabos (neprivaloma)",
  "hpo.merkitse": "Įrašyti",
  "hpo.valitse_laji": "Pasirinkite neatvykimo rūšį.",
  "hpo.anna_paivat": "Įveskite pradžios ir pabaigos datą.",
  "hpo.loppu_ennen": "Pabaigos data yra ankstesnė už pradžios datą.",
  "hpo.vihje": "{nimi}: neatvykimai rodomi ir išteklių pajėgume — įrašytos atostogos automatiškai sumažina turimą laiką.",
  "lau.ulot.aloittamatta": "nepradėta",
  "lau.ulot.aloitettu": "pradėta",
  "lau.ulot.loki": "žurnalas užbaigtas (iš pradėtų)",
  "lau.ulot.ndt": "NDT atlikta (iš pradėtų)",
  "lau.ulot.painekoe": "slėgio bandymas (iš pradėtų)",
  "lau.ulot.walkdown": "apžiūra priimta (iš pradėtų)",
  "lau.ulot.ei_punchia": "nėra atvirų defektų (iš pradėtų)",
  "lau.ulot.ndt_kesken": "NDT nebaigta — reikalaujama aprėptis nepasiekta (iš pradėtų)",
  "lau.ulot.ndt_ei_vaadita": "NDT nereikalaujama — sprendimas, aprėptis 0 (iš pradėtų)",
  "lau.ulot.ndt_luokalle_ei_kirjattu": "šiai PED kategorijai trūksta NDT reikalavimo (iš pradėtų)",
  "lau.ulot.ndt_ei_asetettu": "objektui neįrašyta NDT reikalavimų (iš pradėtų)",
  "lau.ulot.ndt_luokka_puuttuu": "linija neturi PED kategorijos (iš pradėtų)",
  "lau.ulot.painekoe_kesken": "slėgio bandymas įrašytas, rezultatas nepriimtas (iš pradėtų)",
  "lau.ulot.hitsaus_jaljella": "liko suvirinti (iš visų linijų)",
  "lau.ulot.ndt_jaljella": "liko NDT (iš visų linijų)",
  "lau.ulot.painekoe_jaljella": "liko slėgio bandymas (iš visų linijų)",
  "lau.ulot.walkdown_jaljella": "liko apžiūra (iš visų linijų)",
  "lau.ulot.punchit_jaljella": "atviri defektai (iš visų linijų)",
  "lau.ulot.primaari_jaljella": "pirminės atramos nebaigtos (užsakovo %, mažiau nei 100)",
  "lau.ulot.sekundaari_jaljella": "antrinės atramos nebaigtos (užsakovo %, mažiau nei 100)",
  "lau.ulot.kannakointi_ei_tiedossa": "atramos nežinomos (nėra užsakovo vertės)",
  "lau.ulot.kannakointi_ristiriita": "prieštaravimas: užsakovo montavimas 100 %, antrinės nebaigtos",
  "lau.ulot.walkdown_poikkeama": "apžiūra priimta su nukrypimu (atviras defektas arba A defektas) — ne visiškai užbaigta",
  "lau.ulot.luovutusliite_puuttuu": "perduota, trūksta pasirašytos izometrijos",
  "lau.ndt_sana.valmis": "✓",
  "lau.ndt_sana.kesken": "vykdoma",
  "lau.ndt_sana.aloittamatta": "nepradėta",
  "lau.ndt_sana.ei_vaadita": "nereikalaujama",
  "lau.ndt_sana.luokalle_ei_kirjattu": "kategorijai neįrašyta",
  "lau.ndt_sana.ei_asetettu": "objektui nėra reikalavimų",
  "lau.ndt_sana.luokka_puuttuu": "nėra PED kategorijos",
  "lau.ndt_sel.valmis": "Reikalaujama NDT aprėptis pasiekta visais metodais.",
  "lau.ndt_sel.kesken": "Patikros atliktos, bet kuriuo nors metodu dar trūksta.",
  "lau.ndt_sel.aloittamatta": "Nėra nei priimtos, nei atmestos patikros.",
  "lau.ndt_sel.ei_vaadita": "Sprendimas: šiai PED kategorijai NDT nereikalaujama (aprėptis 0). Todėl skolos nėra.",
  "lau.ndt_sel.luokalle_ei_kirjattu": "Objektui NDT reikalavimai įrašyti, bet ne šiai PED kategorijai. Tai spraga, ne sprendimas.",
  "lau.ndt_sel.ei_asetettu": "Objektui neįrašytas joks NDT reikalavimas — jie gaunami iš užsakovo kokybės sistemos. Nežinoma, ar NDT reikalaujama.",
  "lau.ndt_sel.luokka_puuttuu": "Linija neturi PED kategorijos, todėl reikalavimo negalima nustatyti.",
  "lau.leima_tilanne": "Būklė {pvm} {klo}",
  "lau.leima_kohde": "objektas {tunnus}",
  "lau.leima_kaikki": "visi objektai",
  "lau.n_linjaa": "{n} linijų",
  "lau.ohje.kuka": "Šis rodinys skirtas tik skaityti; čia niekas nekeičiama. Jį mato visi, kurie naudoja suvirinimo žurnalą; objektais apribota paskyra mato tik savo objektus. Kiekvienas, matantis rodinį, gali eksportuoti pretenzijos medžiagą į Excel, ir kiekvienas eksportas registruojamas: kas, ką, kada.",
  "lau.ohje.luvut": "Viršutinė dalis — kitos šalies skola mums: linijos, kurioms trūksta pradinių duomenų (izometrijos detalių sąrašo, medžiagų poreikio ar P&ID). Rimčiausia — «atlikta be pradinių duomenų». Brūkšnys ties P&ID skaičiumi reiškia, kad linijų sąrašas neimportuotas — nežinoma, ne nulis. Apatinė dalis — mūsų skola užsakovui: linijos parengtis yra atliktų penkių punktų dalis (žurnalas užbaigtas, NDT, slėgio bandymas, apžiūra priimta, nėra atvirų defektų). Linija, kurioje niekas nesuvirinta, procento negauna ir į vidurkį neįtraukiama, nes «nėra atvirų defektų» būtų tiesa tik todėl, kad nėra darbo. «NDT atlikta», «slėgio bandymas» ir «apžiūra OK» skaičiuojami iš visų linijų.",
  "lau.lahdeaukot": "Trūkstami pradiniai duomenys",
  "lau.vie_title": "Papildomų darbų / vėlavimo pretenzija į Excel — galima įkelti ir į SharePoint",
  "lau.vie": "Eksportuoti Excel (pretenzija)",
  "lau.vyo_tilaajalta": "LAUKIAMA IŠ UŽSAKOVO",
  "lau.vyo_tilaajalta_selite": "— pradiniai duomenys ir projektavimas",
  "lau.vyo_toinen": "KITOS ŠALIES SKOLA MUMS",
  "lau.vyo_toinen_selite": "— pradiniai duomenys ir projektavimas — tai pretenzijos medžiaga",
  "lau.tehty_ilman": "atlikta BE pradinių duomenų",
  "lau.dn_ristiriita_pid": "DN prieštaravimas (P&ID)",
  "lau.ei_linjalistaa": "linijų sąrašas neimportuotas",
  "lau.puuttuu_pid": "trūksta sistemoje (P&ID)",
  "lau.ei_lahtotietoa_bom": "nėra pradinių duomenų (BOM+MTO)",
  "lau.isometri_bom_puuttuu": "trūksta izometrijos BOM",
  "lau.nimi_vs_kanta": "pavadinimas ir dydis nesutampa",
  "lau.dn_epaselva": "DN/ID neaiškus",
  "lau.pid_ei_ajossa": "Dvi patikros nevykdomos: šiam objektui neimportuotas P&ID linijų sąrašas. Tai ne nuliai, o nežinomieji.",
  "lau.ei_aukkoja": "Netrūksta pradinių duomenų. 👍",
  "lau.media": "Terpė",
  "lau.aukot": "Spragos",
  "lau.m_tehty_ilman": "atlikta be pradinių duomenų",
  "lau.m_dn_ristiriita": "DN prieštaravimas: P&ID {dn}",
  "lau.m_ei_lahtotietoa": "nėra pradinių duomenų",
  "lau.m_isometri": "izometrinis brėžinys",
  "lau.m_nimi_sanoo": "pavadinime {koko}",
  "lau.m_dn_epaselva": "DN neaiškus",
  "lau.naytetaan_400": "Rodoma 400 / {n}.",
  "lau.puuttuvat_linjat": "Trūkstamos linijos — yra P&ID, nėra sistemoje ({n})",
  "lau.puuttuvat_selite": "Suprojektuotos, bet sistemoje niekada neįrašytos ir nesuplanuotos — stipriausias pagrindas papildomų darbų / vėlavimo pretenzijai.",
  "lau.pid_linja": "P&ID linija",
  "lau.luovutusaineisto": "Perdavimo dokumentacija",
  "lau.vyo_puuttuu": "PERDAVIMO DOKUMENTACIJA",
  "lau.vyo_puuttuu_selite": "— dar trūksta",
  "lau.ohje.kuka_tilaaja": "Šis rodinys skirtas tik skaityti; čia niekas nekeičiama. Matote savo objekto būklę.",
  "lau.ohje.luvut_tilaaja": "Viršutinėje dalyje rodomos linijos, kurioms rangovas laukia pradinių duomenų (izometrijos detalių sąrašo, medžiagų poreikio ar P&ID). Brūkšnys ties P&ID skaičiumi reiškia, kad linijų sąrašas neimportuotas — nežinoma, ne nulis. Apatinėje dalyje rodoma dar trūkstama perdavimo dokumentacija: linijos parengtis yra atliktų penkių punktų dalis (žurnalas užbaigtas, NDT, slėgio bandymas, apžiūra priimta, nėra atvirų defektų). Linija, kurioje niekas nesuvirinta, procento negauna.",
  "lau.dokvelka": "Dokumentacijos skola",
  "lau.dokvelka_hint": "perdavimo dokumentacijos parengtis pagal liniją — nepradėta yra spraga",
  "lau.vyo_meidan": "MŪSŲ SKOLA UŽSAKOVUI",
  "lau.vyo_meidan_selite": "— perdavimo dokumentacija — tai darbų sąrašas",
  "lau.keskivalmius": "vid. parengtis",
  "lau.ei_aloitettuja": "nė viena linija nepradėta",
  "lau.aloitetusta": "iš {n} pradėtų linijų",
  "lau.ei_prosenttia": "nėra procento — neišmatuojama",
  "lau.valmista_linjaa": "baigtos linijos",
  "lau.ndt_tehty": "NDT atlikta",
  "lau.painekoe": "slėgio bandymas",
  "lau.walkdown_ok": "apžiūra OK",
  "lau.nayta": "Rodyti",
  "lau.kaikki_linjat": "visos linijos",
  "lau.seuraava_vaihe": "Kitas etapas",
  "lau.kaikki": "visos",
  "lau.linjaa": "linijos",
  "lau.seuraava_vaihe_pieni": "kitas etapas: {vaihe}",
  "lau.valmius": "Parengtis",
  "lau.loki": "Žurnalas",
  "lau.painekoe_sarake": "Slėgio bandymas",
  "lau.walkdown": "Apžiūra",
  "lau.punchit": "Defektai",
  "lau.aloittamatta_merkki": "NEPRADĖTA",
  "lau.luokka": "Kategorija: {luokka}.",
  "lau.kirjasi": "Įrašė: {kuka}.",
  "lau.ei_tiedossa": "nežinoma",
  "lau.pk_title_ok": "Įrašytas priimtas slėgio bandymas.",
  "lau.pk_title_kesken": "Slėgio bandymas įrašytas, bet rezultatas nepriimtas (vykdoma arba nežinoma).",
  "lau.pk_title_ei": "Slėgio bandymas neįrašytas.",
  "lau.ei_linjoja": "Šiame rinkinyje nėra linijų.",
  "lau.ei_keskiarvoa": "Nė viena linija nepradėta, todėl vidurkio nėra.",
  "lau.keskiarvo_lause": "Pradėtos linijos vidutiniškai užbaigtos {p} ({n} linijų), o {a} / {m} nepradėtos.",
  "lau.ei_yhtaan": "nė vienos",
  "hen.eyebrow": "Personalas",
  "hen.otsikko": "Kas ką gali daryti ir kokia ilga diena",
  "hen.haku": "Ieškoti pagal vardą ar pareigas",
  "hen.vie_hitsaajalista": "Eksportuoti suvirintojų sąrašą",
  "hen.lisaa_henkilo": "Pridėti asmenį",
  "hen.yksikko": "asmenys",
  "hen.ohje.kuka": "Asmenis prideda ir redaguoja administratorius ir planuotojas. Darbo užmokestį, asmens kodą ir banko sąskaitos numerį gali matyti ir redaguoti tik tas, kuriam administratorius atskirai suteikė teisę į jautrius asmens duomenis.",
  "hen.ohje.luvut": "Dienos, savaitės ir mėnesio maksimumai yra skirtingi dalykai: 12 valandų dienos galimos savaitei neviršijant 50 valandų, o mėnesiui — 170 valandų. Visada taikoma griežčiausia riba. Tuščias laukas reiškia, kad ribos nėra.",
  "hen.tuonti_otsikko": "Personalas iš Excel",
  "hen.tuonti_selite": "Pirmosios dienos sąrašas: atsisiųskite šabloną, įrašykite vardus ir importuokite. Personalas priklauso įmonei, ne objektui. Darbo užmokestis, asmens kodas ir banko sąskaitos numeris šiuo šablonu neimportuojami — jie saugomi atskira teise ir įvedami asmens kortelėje.",
  "hen.tuonti_paivitys": "Taip pat atnaujinti esamus asmenis pagal aukščiau išvardytus skirtumus",
  "hen.henkilosto": "Personalas",
  "hen.omaa": "{n} savų",
  "hen.osaamiset": "Kompetencijos",
  "hen.tyopaivat": "Darbo dienos",
  "hen.tyopaiva": "Darbo diena",
  "hen.max_pv": "Maks. val./d.",
  "hen.max_vko": "Maks. val./sav.",
  "hen.max_kk": "Maks. val./mėn.",
  "hen.vuokrapaikat": "Nuomojamos vietos",
  "hen.vuokrapaikat_selite": "bevardės vietos, ne asmenys",
  "hen.peruste.hitsaa": "Darbo rūšis apima suvirinimą",
  "hen.peruste.fitter": "Suvirinimo poros montuotojas",
  "hen.peruste.valvoo_hitsausta": "Prižiūri ar vadovauja suvirinimo darbams",
  "hen.peruste.kirjaa_tarkastaa": "Pildo ar tikrina suvirinimo žurnalą",
  "hen.peruste.muu": "Kita — įrašykite priežastį",
  "hen.peruste.ei_hitsaustyota": "Darbo rūšis nei dalyvauja suvirinimo darbuose, nei juos tikrina",
  "hen.peruste.hitsit_muualla": "Siūlės registruojamos už šios sistemos ribų",
  "hen.peruste.myonto_virhe": "Suteikimas buvo klaida",
  "hen.peruste.asentaa_laitteita": "Darbo rūšis apima įrangos montavimą",
  "hen.peruste.valvoo_laiteasennusta": "Prižiūri ar vadovauja įrangos montavimui",
  "hen.peruste.kuittaa_vaiheita": "Patvirtina montavimo etapus",
  "hen.peruste.kayttoonotto": "Dalyvauja paleidime",
  "hen.peruste.asentaa_kanavistoa": "Darbo rūšis apima ortakių ar galinių įrenginių montavimą",
  "hen.peruste.mittaa": "Matuoja sandarumą ar oro srautus",
  "hen.peruste.valvoo_iv": "Prižiūri ar vadovauja ŠVOK montavimui",
  "hen.peruste.kuittaa_suojaus": "Patvirtina montavimą ir apsaugą",
  "hen.peruste.ei_iv": "Darbo rūšis nei dalyvauja ŠVOK montavime, nei jį tikrina",
  "hen.peruste.iv_muualla": "ŠVOK montavimas registruojamas už šios sistemos ribų",
  "hen.peruste.ei_laiteasennusta": "Darbo rūšis nei dalyvauja įrangos montavime, nei jį tikrina",
  "hen.peruste.laite_muualla": "Įrangos montavimas registruojamas už šios sistemos ribų",
  "hen.peruste.oletus_127": "Migracijos 127 numatytoji reikšmė",
  "hen.palautettu": "{nimi} grąžintas į pasirinkimo sąrašus.",
  "hen.palautus_virhe": "Nepavyko grąžinti.",
  "hen.myonto": "suteikimas",
  "hen.peruutus": "atšaukimas",
  "hen.hitsaustyo": "suvirinimo darbai",
  "hen.laiteasennus": "įrangos montavimas",
  "hen.iv_asennus": "ŠVOK montavimas",
  "hen.paalle": "įjungta",
  "hen.pois": "išjungta",
  "hen.muutos_virhe": "pakeitimas nepavyko",
  "hen.tallennettu_n": "Išsaugota ({n}): {lista}. Priežastis išsaugota prie kiekvieno.",
  "hen.ei_tallentunut": "Neišsaugota: {virhe}.",
  "hen.passivoi_vahvistus1": "{nimi}: šias pareigas turi {n} asmenys.",
  "hen.passivoi_vahvistus2": "Pareigos pašalinamos iš pasirinkimų sąrašų, bet senos eilutės išsaugomos — niekas nepraranda savo kompetencijos.",
  "hen.passivoi_vahvistus3": "Galite jas atkurti įvesdami tą patį pavadinimą kaip naujas pareigas.",
  "hen.passivoitu": "{nimi} pašalinta iš pasirinkimų sąrašų. Senos eilutės išsaugomos — tas pats pavadinimas kaip naujos pareigos ją atkuria.",
  "hen.nimikkeet_otsikko": "Profesijų ir kompetencijų pareigos",
  "hen.nimikkeet_ohje": "Pareigos nurodo, kokį darbą asmuo dirba. Jos turi įtakos trims dalykams:",
  "hen.nimikkeet_tarpeet": "Išteklių poreikiai:",
  "hen.nimikkeet_tarpeet_teksti": "kai objektui įrašomas poreikis (pvz., 3 suvirintojai), trūkstamas darbo krūvis apskaičiuojamas pagal asmenis, turinčius šias pareigas.",
  "hen.nimikkeet_ruudukko": "Išteklių tinklelis:",
  "hen.nimikkeet_ruudukko_teksti": "tinklelį galima apriboti, kad būtų rodomi tik tam tikras pareigas turintys asmenys.",
  "hen.nimikkeet_nakymat": "Lauko paskyrų rodiniai:",
  "hen.nimikkeet_nakymat_teksti": "pažymėjimas suteikia rodinį šias pareigas turintiems asmenims, kurie turi lauko paskyrą. Suvirinimo darbai atveria Suvirinimo žurnalą ir Naršymą, Įrangos montavimas atveria Įrangos montavimą. Naršyklės paskyra rodinius gauna pagal savo rolę, ir pažymėjimas jai neturi įtakos. Jei atskiram darbuotojui reikia rodinio, suteikite jam pareigas, kurios jį suteikia.",
  "hen.nimike": "Pareigos",
  "hen.henkiloita_title": "Kiek asmenų turi šias pareigas",
  "hen.henkiloita": "Asmenys",
  "hen.hlot": "Asm.",
  "hen.hitsaustyo_title": "Lauko paskyra, kurios asmuo turi šias pareigas, mato Suvirinimo žurnalą ir Naršymą: siūlių registravimą, linijas, NDT patikras, defektus ir medžiagų sertifikatus. Be pažymėjimo API atsako 403 «ei_hitsaustyota». Neturi įtakos naršyklės paskyroms — jos rodinius gauna pagal savo rolę.",
  "hen.hitsaustyo_sarake": "Suvirinimo darbai",
  "hen.hitsaus_kapea": "Suvirinimas",
  "hen.laiteasennus_title": "Lauko paskyra, kurios asmuo turi šias pareigas, mato Įrangos montavimą: įrangą, etapų grandines ir jungčių bei flanšinių jungčių patvirtinimą. Be pažymėjimo API atsako 403 «ei_laiteasennustyota». Neturi įtakos naršyklės paskyroms.",
  "hen.laiteasennus_sarake": "Įrangos montavimas",
  "hen.laite_kapea": "Įrang.",
  "hen.iv_title": "Lauko paskyra, kurios asmuo turi šias pareigas, mato ŠVOK montavimą: sistemas, ortakių atkarpas, galinius elementus ir sandarumo bei oro srauto matavimų registravimą. Be pažymėjimo API atsako 403 ei_ivtyota. Numatytoji reikšmė išjungta ir senoms pareigoms (sprendimas 52).",
  "hen.iv_sarake": "ŠVOK montavimas",
  "hen.iv_kapea": "ŠVOK",
  "hen.poistettu_listoilta_title": "Pašalinta iš pasirinkimų sąrašų, bet vis dar naudojama senose eilutėse",
  "hen.poistettu_listoilta": "pašalinta iš sąrašų",
  "hen.nakee_hitsauslokin": "Šios profesijos lauko darbuotojas mato suvirinimo žurnalą",
  "hen.nakee_laiteasennuksen": "Šios profesijos lauko darbuotojas mato įrangos montavimą",
  "hen.nakee_iv": "Šios profesijos lauko darbuotojas mato ŠVOK montavimą",
  "hen.peruste_title": "Priežastis: {peruste}",
  "hen.odottaa_vahvistusta": "laukia patvirtinimo",
  "hen.palauta": "Atkurti",
  "hen.poista_nimike_title": "Šias pareigas turi {n} asmenys — jos pašalinamos iš pasirinkimų sąrašų, bet senos eilutės išsaugomos",
  "hen.poista_nimike_title0": "Pašalina pareigas iš pasirinkimų sąrašų",
  "hen.muutos_odottaa1": "Laukia 1 pakeitimas",
  "hen.muutos_odottaa": "Laukia pakeitimų: {n}",
  "hen.myonto_selite": "Suteikimas atveria rodinį visiems profesijos lauko darbuotojams, atšaukimas jį uždaro visiems. Ta pati priežastis išsaugoma kiekvienoje eilutėje.",
  "hen.peruste": "Priežastis",
  "hen.peruste_ryhma": "Priežastis ({ryhma})",
  "hen.tarkennus": "Išsami informacija",
  "hen.pakollinen": " (privaloma)",
  "hen.tallenna_muutokset": "Išsaugoti pakeitimus",
  "hen.hylkaa_muutokset": "Atmesti pakeitimus",
  "hen.ei_nimikkeita": "Nėra kompetencijų pareigų.",
  "hen.passivoitu_selite": "Išjungtos pareigos rodomos, jei jas dar kas nors turi — kitaip lentelėje būtų pareigos, kurių nėra pasirinkimų sąraše. Išjungtų pareigų negalima pasirinkti naujam asmeniui; «atkurti» grąžina jas naudojimui.",
  "hen.uusi_nimike": "Naujos pareigos",
  "hen.uusi_nimike_esim": "pvz., Izoliuotojas",
  "hen.lisaa": "Pridėti",
  "hen.v_tyopaiva": "Darbo diena turi būti nuo 0 iki 24 h.",
  "hen.v_paivamax": "Dienos maksimumas turi būti nuo 0 iki 24 h.",
  "hen.v_paivamax_pieni": "Dienos maksimumas negali būti mažesnis už darbo dieną.",
  "hen.v_viikkomax": "Savaitės maksimumas turi būti nuo 0 iki 168 h.",
  "hen.v_kkmax": "Mėnesio maksimumas turi būti nuo 0 iki 744 h.",
  "hen.v_tyopaivat": "Pasirinkite bent vieną darbo dieną.",
  "hen.v_palkka": "Valandinis atlygis turi būti 0–9999 €/h.",
  "hen.v_matkat": "Kelionės per mėnesį turi būti 0–99.",
  "hen.tallennettu": "Išsaugota.",
  "hen.tyosuhde_paattynyt": "DARBO SANTYKIAI PASIBAIGĖ {pvm}",
  "hen.kenttakirjautuminen_estetty": " · prisijungimas lauke užblokuotas",
  "hen.ei_osaamisia": "nėra kompetencijų — neįtraukta į trūkumo skaičiavimą",
  "hen.ei_viikkokattoa_title": "Nėra savaitės ribos: lemia dienos ribų suma",
  "hen.ei_kkkattoa_title": "Nėra mėnesio ribos: lemia dienos ir savaitės ribos",
  "hen.ei_kattoa": "nėra ribos",
  "hen.tyosuhde": "Darbo santykiai",
  "hen.tyotunnus": "Suvirintojo / darbuotojo ID",
  "hen.tyotunnus_esim": "pvz., ZX01",
  "hen.alkoi": "Darbo santykių pradžia",
  "hen.paattyi_title": "Pabaigos data blokuoja prisijungimą lauke nuo kitos dienos (auth.ts). Norėdami atšaukti: išvalykite datą.",
  "hen.paattyi": "Darbo santykių pabaiga",
  "hen.yleispalkka": "Bendras atlygis €/h",
  "hen.ei_asetettu": "nenustatyta",
  "hen.arkaluonteiset_piilossa": "Atlygis, kolektyvinė sutartis ir kelionės rodomi tik turint teisę į jautrius asmens duomenis — ją suteikia administratorius rodinyje Paskyros. Išsaugojimas jų nekeičia.",
  "hen.tes": "TES",
  "hen.ei_valittu": "— nepasirinkta —",
  "hen.tes_lista": "Kolektyvinių sutarčių sąrašas gaunamas iš pasiūlymų modulio nustatymų.",
  "hen.matkat_kk": "Kelionės/mėn.",
  "hen.osaamisluokan_mukaan": "pagal kompetencijų klasę",
  "hen.tehtavapalkat": "Užduočių atlygis",
  "hen.yleispalkka_pieni": "bendras atlygis",
  "hen.palkka_vihje": "Darbuotojas gali turėti skirtingą atlygį skirtingoms užduotims — nurodykite kompetencijai užduoties atlygį, kitaip taikomas bendras atlygis. Naudojama faktinėms sąnaudoms; pasiūlymuose naudojamas kompetencijų klasės valandinis įkainis. Kolektyvinė sutartis prideda priedų skaičiavimą; tuščios kelionės/mėn. = kompetencijų klasės numatytoji reikšmė. Sutartys — priedai žemiau.",
  "hen.tyoaika": "Darbo laikas",
  "hen.tyopaiva_h": "Darbo diena h",
  "hen.tallenna_tiedot": "Išsaugoti asmens duomenis",
  "hen.tallenna_selite": "Išsaugo kompetencijas, darbo dienas, darbo santykius ir darbo laiką. Kvalifikacijos ir paskyros išsaugomos savo mygtukais.",
  "hen.asiakirjat": "Dokumentai",
  "hen.tyoaika_vihje": "Darbo dienos lemia, kurios dienos skaičiuojamos kaip pajėgumas. Pamaininiame darbe tai gali būti bet kurios dienos; dirbti kitomis dienomis vis tiek galima, bet tai pažymima kaip išimtis. Darbo diena valandomis — tai, kiek asmuo paprastai dirba; iš jos apskaičiuojamas turimas laikas. Dienos ir savaitės maksimumai nuspalvina tinklelį raudonai. Mėnesio maksimumas langelių nespalvina, nes savaitė gali apimti du mėnesius — viršijimas matomas sprendimų sąraše. Tuščias laukas reiškia, kad ribos nėra.",
  "hen.tyomaat_virhe": "Nepavyko įkelti objektų.",
  "hen.kenttatunnus_ja_pin": "Lauko paskyra ir PIN",
  "hen.kenttatunnus_virhe": "Nepavyko sukurti lauko paskyros.",
  "hen.uusi_pin_vahvistus1": "Suteikti {nimi} naują PIN?",
  "hen.uusi_pin_vahvistus2": "Senasis iškart nustoja veikti ir bet koks prisijungimas nutraukiamas. Naujas PIN rodomas tik vieną kartą.",
  "hen.uusi_pin": "Naujas PIN",
  "hen.pin_virhe": "Nepavyko nustatyti PIN.",
  "hen.kutsulinkki": "Kvietimo nuoroda",
  "hen.linkki": "Nuoroda",
  "hen.kayttajatili_virhe": "Nepavyko sukurti naudotojo paskyros.",
  "hen.on": "TAIP",
  "hen.ei": "NE",
  "hen.tunnukset": "Paskyros",
  "hen.kenttatunnus": "Lauko paskyra",
  "hen.luo_kenttatunnus": "Sukurti lauko paskyrą",
  "hen.anna_uusi_pin": "Išduoti naują PIN",
  "hen.kayttajatili": "Naudotojo paskyra",
  "hen.luo_kayttajatili": "Sukurti naudotojo paskyrą",
  "hen.ladataan_tyomaita": "Įkeliami objektai…",
  "hen.luodaan": "Kuriama…",
  "hen.luo_ilman_tyomaata": "Sukurti lauko paskyrą be objekto",
  "hen.luo_kentta_ja_pin": "Sukurti lauko paskyrą ir PIN",
  "hen.rooli": "Rolė",
  "hen.luo_ja_kutsu": "Sukurti ir išduoti kvietimo nuorodą",
  "hen.kutsu_vihje": "Gavėjas slaptažodį nustato pats. Nuoroda veikia vieną kartą ir nustoja galioti po 7 dienų.",
  "hen.pin_vihje": "PIN rodomas tik dabar. Prisijungimas: kodas + PIN prisijungimo puslapio režimu Lauko paskyra.",
  "hen.linkki_sama": "Aukščiau esanti nuoroda yra tokia pati kaip pranešime.",
  "hen.ei_lahetetty": "Neišsiųsta: {syy}. Pasidalykite nuoroda rankiniu būdu.",
  "hen.tuntematon_syy": "nežinoma priežastis",
  "hen.lisatty": "Pridėta. Santrumpa: {lyh}",
  "hen.uusi_henkilo": "Naujas asmuo",
  "hen.lyhenne_vihje": "Santrumpa sudaroma iš vardo, nebent ją įvesite",
  "hen.etunimi": "Vardas",
  "hen.sukunimi": "Pavardė",
  "hen.nimike_esim": "Suvirintojas",
  "hen.lyhenne": "Santrumpa",
  "hen.johdetaan": "sudaroma",
  "hen.lyhenne_title": "Tuščia = sudaroma iš vardo (vardo pirmoji raidė + pirmosios dvi pavardės raidės). Įveskite patys, jei sudaryta jau užimta.",
  "hen.tyosuhde_oma": "Nuosavas",
  "hen.tyosuhde_vuokra": "Nuomojamas",
  "hen.tyosuhde_alihankinta": "Subranga",
  "hen.nimeamaton": "Nepavadinta pajėgumo vieta",
  "hen.pv.ma": "Pr",
  "hen.pv.ti": "An",
  "hen.pv.ke": "Tr",
  "hen.pv.to": "Kt",
  "hen.pv.pe": "Pn",
  "hen.pv.la": "Š",
  "hen.pv.su": "Sk",
  "main.linkki_ei_kelpaa": "Nuoroda negalioja.",
  "main.salasanat_eivat_tasmaa": "Slaptažodžiai nesutampa.",
  "main.salasana_12": "Slaptažodis turi būti bent 12 simbolių.",
  "main.tarkistetaan_linkkia": "Tikrinama nuoroda…",
  "main.linkki_ei_kelpaa_otsikko": "Nuoroda negalioja",
  "main.kirjautumiseen": "Eiti į prisijungimą",
  "main.salasana_vaihdettu": "Slaptažodis pakeistas",
  "main.salasana_asetettu": "Slaptažodis nustatytas",
  "main.vanha_ei_toimi": "Senas slaptažodis ir ankstesni prisijungimai nebeveikia. Prisijunkite su nauju.",
  "main.voit_kirjautua": "Dabar galite prisijungti.",
  "main.vaihda_salasana": "Keisti slaptažodį",
  "main.aseta_salasana": "Nustatyti slaptažodį",
  "main.on_jo_salasana": "Paskyra jau turi slaptažodį. Kai jį pakeisite čia, senas slaptažodis ir ankstesni prisijungimai nustos veikti.",
  "main.salasana_uudelleen": "Pakartokite slaptažodį",
  "main.kutsu_vihje": "Bent 12 simbolių. Nuoroda veikia tik vieną kartą.",
  "main.uudet_eivat_tasmaa": "Nauji slaptažodžiai nesutampa.",
  "main.uusi_12": "Naujas slaptažodis turi būti bent 12 simbolių.",
  "main.vaihto_virhe": "Nepavyko pakeisti slaptažodžio.",
  "main.vaihdettu_huom": "Slaptažodis pakeistas. Kitos sesijos nutrauktos — jei buvote prisijungę kitame įrenginyje, ten reikės prisijungti iš naujo.",
  "main.nykyinen": "Dabartinis slaptažodis",
  "main.uusi": "Naujas slaptažodis",
  "main.uusi_uudelleen": "Pakartokite naują",
  "main.vaihdetaan": "Keičiama…",
  "main.vaihda": "Keisti",
  "main.vaihto_vihje": "Bent 12 simbolių. Pakeitimas nutraukia kitas sesijas.",
  "main.esto_moduuli": "Modulis «{moduuli}» šiame egzemplioriuje nenaudojamas.",
  "main.esto_rooli": "Rodinys skirtas rolėms {sallitut}. Jūsų paskyra turi {roolit}.",
  "main.ei_yhtaan_roolia": "nėra rolių",
  "main.esto_rajaus": "Rodinys apima visą įmonę, o jūsų paskyra apribota objektais. API turi tą patį apribojimą (403).",
  "main.esto_tyolaji_hitsaus": "Rodinys skirtas suvirinimo profesijoms. Asmens pareigos neturi suvirinimo žymos (Personalas → pareigos).",
  "main.esto_tyolaji_iv": "Rodinys skirtas ŠVOK montavimo profesijoms. Asmens pareigos neturi ŠVOK montavimo žymos (Personalas → pareigos).",
  "main.esto_tyolaji_laite": "Rodinys skirtas įrangos montavimo profesijoms. Asmens pareigos neturi įrangos montavimo žymos (Personalas → pareigos).",
  "main.esto_tilaaja": "Rodinys yra rangovo vidinė informacija (personalas, valandos, sandėlis). Užsakovo paskyra jo nemato.",
  "main.esto_kaannokset": "Vertimų peržiūrai reikia teisės «Vertimų peržiūra» arba «Vertimų patvirtinimas».",
  "main.esto_kuittaus": "Trūkstamų siūlių patvirtinimas priklauso darbų vadovams (teisė «Suvirinimo žurnalo darbų vadovo rodinys»).",
  "main.esto_ei_valikossa": "Rodinio «{nakyma}» šios paskyros meniu visai nėra. Jūsų paskyra turi rolę {roolit}.",
  "main.ei_yhtaan": "nėra",
  "main.valikko": "Meniu",
  "main.lukematonta": "Neperskaitytų pranešimų: {n}",
  "kap.tallennus_virhe": "Išsaugoti nepavyko.",
  "kap.poisto_virhe": "Ištrinti nepavyko.",
  "kap.anna_paivat": "Įveskite pradžios ir pabaigos datas.",
  "kap.loppu_ennen_alkua": "Pabaigos data yra ankstesnė už pradžios datą.",
  "kap.vuokrapaikka": "Nuomojamos darbo jėgos vieta",
  "kap.haku_virhe": "Nepavyko įkelti duomenų.",
  "kap.pk_vaje_otsikko": "{luokka}: {vk} savaitės negalima padengti net nuomojama darbo jėga",
  "kap.pk_vaje_teksti": "Trūkumas {h} h. Įdarbinkite arba perplanuokite sutartį.",
  "kap.pk_alih_otsikko": "{luokka}: {vk} savaitei reikia nuomojamos darbo jėgos",
  "kap.pk_alih_teksti": "Dalį padengia nuosavas personalas; {h} h reikia įsigyti.",
  "kap.pk_ristiriita_otsikko": "{nimi} paskirstytas(-a) nebuvimo metu",
  "kap.pk_ristiriita_teksti": "{vk} savaitė: {h} h darbo, nėra laisvų darbo dienų.",
  "kap.pk_yli_viikko": "{nimi} viršija savaitės maksimumą {vk} savaitę",
  "kap.pk_yli_paiva": "{nimi} viršija dienos maksimumą {vk} savaitę",
  "kap.pk_yli_viikko_teksti": "{h} h, savaitės maksimumas {max} h.",
  "kap.pk_yli_paiva_alku": "Savaitės suma {h} h telpa į {max} h maksimumą, bet",
  "kap.pk_yli_paiva_lkm": "{n} dienos viršija dienos maksimumą ({a} h, o leidžiama {b} h).",
  "kap.pk_yli_paiva_jokin": "viena diena viršija dienos maksimumą.",
  "kap.pk_kk_otsikko": "{nimi}: {kk} viršija mėnesio maksimumą",
  "kap.pk_kk_teksti": "{h} h, maksimumas {max} h.",
  "kap.yrita_uudelleen": "Bandyti dar kartą",
  "kap.ei_henkiloita": "Kol kas nėra žmonių",
  "kap.ei_henkiloita_teksti": "Pridėkite žmonių ir objektų, ir čia pradės rodytis pajėgumas.",
  "kap.eyebrow": "Ištekliai ir pajėgumas",
  "kap.viikot_vali": "savaitės {a}–{b}",
  "kap.otsikko": "Kas kur yra ir kur trūksta",
  "kap.edellinen": "Ankstesnis",
  "kap.tanaan": "Šiandien",
  "kap.seuraava": "Kitas",
  "kap.ohje.kuka": "Administratoriai ir planuotojai priskiria žmones objektams ir registruoja nebuvimus. Kiti mato tinklelį. Tam tikrais objektais apribota paskyra nemato visos įmonės trūkumo.",
  "kap.ohje.luvut": "Skaičius langelyje — užsakytos valandos. Valandos registruojamos pagal dienas; savaitės ir procentai apskaičiuojami iš jų. Savaitės «trūkumas» — reikalingų valandų skaičius, kurių dar niekas nepadengia. Filtras apriboja eilutes pagal kompetenciją. Nebuvimo priežastis šiame rodinyje nerodoma.",
  "kap.paivitetaan": "Atnaujinama…",
  "kap.yritystaso_kiinni": "Trūkumas, pavaduotojai ir mėnesio krūvis yra visos įmonės duomenys ir apribotai paskyrai nematomi. Todėl savaitės trūkumas nerodomas — tuščia vieta nereiškia, kad žmonių pakanka.",
  "kap.henkiloa_laskennassa": "žmonių skaičiavime",
  "kap.merkitty_paattyneeksi": "pažymėta kaip pasibaigę",
  "kap.joku_lahtenyt": "Jei kas nors išėjo, tikrasis pajėgumas yra mažesnis.",
  "kap.tyoaikamallilla": "su darbo laiko modeliu",
  "kap.harkko_aria": "Savaitės ir bendras krūvis",
  "kap.vk_vaje": "trūkumas {h}",
  "kap.vk_vuokra": "nuoma {h}",
  "kap.ei_huomioitavaa": "Šiuo laikotarpiu nėra ką pažymėti: nėra trūkumo ir perkrovos.",
  "kap.huomioitavaa": "Atkreipkite dėmesį!",
  "kap.kohtaa": "{n} punktai",
  "kap.puskuri_otsikko": "Kiek nebuvimų galima sugerti",
  "kap.puskuri_hint": "Mažoje kategorijoje pavaduotojų skaičius pasako daugiau nei užimtumo rodiklis",
  "kap.osaaminen": "Kompetencija",
  "kap.vk": "sav. {n}",
  "kap.vuokrapaikkaa_vapaana": "Laisvų nuomojamos darbo jėgos vietų: {n}",
  "kap.kaikki": "Visi",
  "kap.viikot": "Savaitės",
  "kap.paivat": "Dienos",
  "kap.nayta_aikataulu": "Rodyti tvarkaraštį",
  "kap.tuntia": "{n} val.",
  "kap.ei_tietoa": "nėra duomenų",
  "kap.selite_kevyt": "mažiau nei 50 % maksimumo",
  "kap.selite_yli": "virš maksimumo",
  "kap.selite_vapaa": "nėra paskirstymo",
  "kap.selite_vuokravapaa": "nepavadinta vieta, laisva",
  "kap.selite_poissa": "neprieinamas (nebuvimas)",
  "kap.selite_poikkeus": "darbas savaitgalį arba šventinę dieną",
  "kap.selite_ristiriita": "paskirstyta nebuvimo dieną",
  "kap.punainen": "Raudona = virš asmens savaitės maksimumo",
  "kap.hvko_kaikilla": "{h} h/sav. visiems",
  "kap.hvko": "h/sav.",
  "kap.oletusmaksimi": "veikia pagal nenustatytą numatytąją 10 h/d. reikšmę",
  "kap.lauantai_alku": "Šeštadienis skaičiuojamas kaip ilga darbo diena ({h} h) —",
  "kap.lauantai_henkilolla": "žmonėms.",
  "kap.lauantai_loppu": "Jei šeštadienis iš tikrųjų trunka 8 h, pasiūla pervertinta {a} h/sav. vienam asmeniui, t. y. iš viso {b} h/sav. Lubos teisingos; pasiūla — ne.",
  "kap.h_ikkunassa": "{h} h lange",
  "kap.ei_allokaatioita": "Šiuo laikotarpiu nėra paskirstymų ar nebuvimų.",
  "kap.poissa": "Nėra",
  "kap.kuormitus": "Krūvis",
  "kap.aikataulu_vihje": "Tas pats laikotarpis kaip tinklelyje. Valandos — savaitės sumos; tarpas eilutėje reiškia, kad tą savaitę asmuo tame objekte nėra.",
  "kap.tunnit_0_24": "Valandų skaičius turi būti nuo 0 iki 24.",
  "kap.tallennettu_joukko": "Išsaugota {n} žmonėms, iš viso {p} darbo dienų.",
  "kap.joukko_nollat": "Laikotarpiu nėra darbo dienų: {nimet}.",
  "kap.joukko_poissa": "Laikotarpiu yra nebuvimas: {nimet} — perkelkite darbą arba atšaukite nebuvimą.",
  "kap.joukko_ylittyy": "Viršytas maksimumas: {nimet}.",
  "kap.ei_tyopaivia": "Laikotarpiu nėra darbo dienų — patikrinkite datas.",
  "kap.tallennettu_poissaolo": "Išsaugota {p} darbo dienoms — laikotarpiu yra nebuvimas. Perkelkite darbą arba atšaukite nebuvimą.",
  "kap.tallennettu_ylitys": "Išsaugota {p} darbo dienoms — viršytas maksimumas.",
  "kap.tallennettu": "Išsaugota {p} darbo dienoms.",
  "kap.jakso_ennen": "Visas laikotarpis yra prieš objekto pradžią {pvm}.",
  "kap.jakso_jalkeen": "Visas laikotarpis yra po objekto pabaigos {pvm}.",
  "kap.alkaa_ennen": "Prasideda prieš objekto pradžią {pvm}.",
  "kap.jatkuu_jalkeen": "Tęsiasi po objekto pabaigos {pvm}.",
  "kap.poistettu": "Ištrinta.",
  "kap.poissaolo_merkitty": "Nebuvimas pažymėtas. Pajėgumas atnaujintas.",
  "kap.poissaolo_poistettu": "Nebuvimas ištrintas.",
  "kap.maksimi_0_24": "Maksimumas turi būti nuo 0 iki 24.",
  "kap.maksimi_tallennettu": "Išsaugotas {h} h/d. maksimumas.",
  "kap.viikko": "{n} savaitė",
  "kap.allokoitu_vk": "Paskirstyta sav. {n}",
  "kap.kaytettavissa": "Turima",
  "kap.maksimi": "Maksimumas",
  "kap.vapaana": "Laisva",
  "kap.nimellinen_ylittaa": "nominalios {a} h viršija savaitės ribą {b} h",
  "kap.vapaa_katosta": "laisvas laikas apskaičiuojamas pagal ribą. Riba nurodyta asmens darbo santykių duomenyse.",
  "kap.poissa_tyopaivaa": "Nėra {n} darbo dienų.",
  "kap.poikkeuspaivaa": "{n} darbo dienų savaitgalį arba šventinę dieną.",
  "kap.allokoitu_poissaolon_paalle": "Paskirstyta nebuvimo metu. Perkelkite darbą arba atšaukite nebuvimą.",
  "kap.ylittaa_maksimin": "Viršija maksimumą {h} val.",
  "kap.ei_kuormita": "nėra krūvio",
  "kap.poista_vuoro": "Ištrinti pamainą",
  "kap.poista_viikolta": "Ištrinti iš savaitės",
  "kap.valitse_kohde": "Pasirinkite objektą",
  "kap.tehtava_tarve": "Užduotis (poreikis)",
  "kap.valitse_tehtava": "Pasirinkite užduotį — objektas turi {n} poreikius",
  "kap.hlo": "{n} asm.",
  "kap.vaatimus": "{n} reikalavimas",
  "kap.vaatimusta": "{n} reikalavimai",
  "kap.ei_vaatimuksia": "nėra reikalavimų",
  "kap.tuntia_pv": "Valandos/d.",
  "kap.este_selite": "Paskirstymas leidžiamas, bet priežastis įrašoma su autoriumi ir laiku.",
  "kap.palvelin": "Serveris",
  "kap.katso_viesti": "žr. pranešimą po mygtuku",
  "kap.peruste_esim": "pvz., laukiama saugumo patikrinimo, kortelė atnaujinta prieš pradžią",
  "kap.valitse_ensin_tehtava": "Pirmiausia pasirinkite užduotį (poreikį)",
  "kap.tallennetaan": "Išsaugoma…",
  "kap.allokoi_n": "Paskirstyti {n} žmones",
  "kap.allokoi": "Paskirstyti",
  "kap.allokoi_muita": "Paskirstyti ir kitus tam pačiam",
  "kap.valittu_lkm": "(pasirinkta {n})",
  "kap.hae_nimella": "Ieškoti pagal vardą…",
  "kap.joukko_vihje": "Tas pats objektas, laikotarpis ir valandos visiems, kiekvienam jo darbo dienomis. Lauko paskyra mato objektą per paskirstymą — atskiro priskyrimo nereikia.",
  "kap.jatkuva_sopimus": "nuolatinė sutartis, pradėta {pvm}",
  "kap.kaynnissa": "vykdoma {a} – {b}",
  "kap.myos_viikonloput": "Taip pat savaitgaliai ir šventinės dienos",
  "kap.pikavalinta": "Greitas pasirinkimas",
  "kap.vko": "{n} sav.",
  "kap.tama_viikko": "Ši savaitė",
  "kap.koko_kohde": "Visas objektas",
  "kap.jakso_vihje": "Laikotarpis gali prasidėti ir baigtis bet kurią dieną — stabdymas gali prasidėti ketvirtadienį ir baigtis antradienį. Pagal numatytąją reikšmę įtraukiamos tik asmens darbo dienos; pažymėjus įtraukiami ir savaitgaliai bei šventinės dienos.",
  "kap.merkitse_poissaolo": "Pažymėti nebuvimą",
  "kap.laji": "Tipas",
  "kap.valitse": "Pasirinkti",
  "kap.merkitse_poissaolevaksi": "Pažymėti kaip nesantį",
  "kap.poissaolo_vihje": "Naudojamas aukščiau pasirinktas laikotarpis. Nebuvimas nustato turimą laiką į nulį ir neskaičiuojamas kaip pajėgumas. Jei laikotarpiu jau yra paskirstymų, jie lieka, o langelis pažymimas kaip konfliktas.",
  "kap.tyoaika_asetukset": "Darbo laiko nustatymai",
  "kap.maksimi_hpv": "Maksimumas h/d.",
  "kap.tallenna_maksimi": "Išsaugoti maksimumą",
  "kap.maksimi_vihje": "Virš šios ribos krūvis tampa raudonas. Komandiruočių darbe ilgos dienos yra įprastos, todėl per mažas maksimumas verčia tinklelį nuolat šaukti.",
  "koh.virhe.haku": "Nepavyko gauti duomenų.",
  "koh.virhe.luovutus": "Nepavyko išsaugoti perdavimo datos.",
  "koh.virhe.tyolaji": "Nepavyko išsaugoti darbo tipo.",
  "koh.virhe.kieli": "Nepavyko išsaugoti dokumentacijos kalbos.",
  "koh.virhe.tila": "Nepavyko pakeisti būsenos.",
  "koh.virhe.sidonta": "Priskyrimas nepavyko.",
  "koh.virhe.sitominen": "Priskirti nepavyko.",
  "koh.virhe.purku": "Nepavyko pašalinti priskyrimo.",
  "koh.virhe.asiakastiedot": "Nepavyko gauti užsakovo duomenų.",
  "koh.virhe.liittaminen": "Susieti nepavyko.",
  "koh.virhe.rooli": "Nepavyko pakeisti rolės.",
  "koh.virhe.irrotus": "Nepavyko atsieti.",
  "koh.virhe.perehdytys": "Nepavyko gauti instruktažo būsenos.",
  "koh.virhe.kirjaus": "Nepavyko įrašyti.",
  "koh.virhe.vaatimus_lisays": "Reikalavimas nepridėtas.",
  "koh.virhe.vaatimus_poisto": "Reikalavimas nepašalintas.",
  "koh.virhe.muutos": "Pakeitimas nepavyko.",
  "koh.virhe.luonti": "Nepavyko sukurti.",
  "koh.yksikko": "objektai",
  "koh.yrita_uudelleen": "Bandyti dar kartą",
  "koh.otsikko": "Kas vyksta ir ko tam reikia",
  "koh.lisaa_kohde": "Pridėti objektą",
  "koh.ohje.kuka": "Administratoriai ir planuotojai prideda objektus, poreikius ir kvalifikacijos reikalavimus. Administratoriai, planuotojai ir darbų vadovai priskiria žmones poreikiams ir šalina priskyrimus.",
  "koh.ohje.luvut": "Poreikis nurodo, kiek ir kokios kompetencijos žmonių objektui reikia ir kada. «Atvira X / N» — kiek vietų dar nepriskirta. «Tinkami» — kiek kompetentingų darbuotojų atitinka poreikio kvalifikacijos reikalavimus visą laikotarpį. Be poreikių sistema žino, kas užsakytas, bet ne tai, ar komandos pakanka.",
  "koh.ei_kohteita": "Kol kas nėra objektų",
  "koh.ei_kohteita_ohje": "Pridėkite pirmąjį objektą, kad galėtumėte pradėti skirti jam žmones.",
  "koh.haku": "Ieškoti pagal ID, pavadinimą, užsakovą…",
  "koh.tunnus": "ID",
  "koh.nimi": "Pavadinimas",
  "koh.asiakas": "Užsakovas",
  "koh.laji": "Tipas",
  "koh.aikajana": "Objektai laiko juostoje",
  "koh.tanaan": "Šiandien",
  "koh.tyomaa": "Objektas",
  "koh.jana_title": "{tunnus} · {n} žmonės · {h} h",
  "koh.kaynnissa_yhta_aikaa": "Vykdoma tuo pačiu metu",
  "koh.ei_varaa_title": "sustabdytas arba planuojamas — pajėgumo nerezervuoja",
  "koh.ei_tyomaita_valilla": "Šiuo laikotarpiu objektų nėra.",
  "koh.era.ei_saatu": "terminas negautas iš serverio",
  "koh.era.myohassa": "vėluojama {n} d., laikotarpis prasidėjo {pvm}",
  "koh.era.tanaan": "Turi būti sutvarkyta šiandien ({pvm})",
  "koh.era.aikaa": "Turi būti sutvarkyta iki {pvm}, liko {n} d.",
  "koh.tarjokas.tayttaa": "Atitinka reikalavimus",
  "koh.tarjokas.uusittava": "Laikotarpiu reikia atnaujinti",
  "koh.tarjokas.ei_kelpaa_nyt": "Šiuo metu netinka",
  "koh.tarjokas.ei_tayta": "Neatitinka reikalavimų",
  "koh.ilm.maara_nolla": "Kiekis turi būti didesnis už nulį.",
  "koh.ilm.kokonaisluku": "Žmonių skaičius yra sveikasis skaičius — poreikį sudaro vietos, o pusės vietos užpildyti negalima. Ne visas darbo laikas yra vietos savybė, o ne žmonių skaičiaus.",
  "koh.ilm.anna_alku": "Įveskite pradžios datą.",
  "koh.ilm.vaatimus_yli": "Reikalavimas taikomas {n} žmonėms, bet poreikis yra {m}.",
  "koh.ilm.tarve_ja_n": "Pridėtas poreikis ir {n} reikalavimai.",
  "koh.ilm.tarve_lisatty": "Poreikis pridėtas.",
  "koh.vahv.poista_tarve": "Ištrinti visą poreikį {n} × {luokka}?",
  "koh.vahv.poista_tarve_vaatimukset": "Taip pat bus ištrinti jo {n} kvalifikacijos reikalavimai.",
  "koh.ilm.poistettu": "Ištrinta.",
  "koh.ilm.tyopaiva_pituus": "Darbo dienos trukmė yra 1–24 h.",
  "koh.ilm.anna_valin_alku": "Įveskite intervalo pradžios datą.",
  "koh.ilm.valin_loppu": "Intervalo pabaigos data yra ankstesnė už pradžios datą.",
  "koh.ilm.sidottu": "{nimi} priskirtas(-a).",
  "koh.ilm.toistaiseksi_ei_paivia": "Poreikis neterminuotas, todėl darbo dienos neįrašytos — įrašykite jas rodinyje Pajėgumas.",
  "koh.ilm.paivia_kirjattu": "Įrašyta darbo dienų: {n}.",
  "koh.ilm.varoitukset": "⚠ {n} savaitės su perkrova arba nebuvimu — patikrinkite Pajėgumą.",
  "koh.ilm.liitetty": "{nimi}: {n} paskirstymo dienos priskirtos užduočiai — valandos ir pastabos nepakeistos.",
  "koh.ilm.liitetty_peruste": "{nimi}: {n} paskirstymo dienos priskirtos užduočiai su pagrindimu — valandos ir pastabos nepakeistos.",
  "koh.toistaiseksi": "neterminuotai",
  "koh.vahv.pura": "Pašalinti priskyrimą {nimi} {vali}?",
  "koh.vahv.pura_selite": "Kartu bus ištrintos jo darbo dienos šiame objekte šiame intervale.",
  "koh.ilm.purettu": "Priskyrimas pašalintas: {nimi} {vali}, ištrinta darbo dienų: {n}.",
  "koh.ilm.lukumaara": "Skaičius yra sveikasis skaičius arba tuščia = visi.",
  "koh.ilm.vaatimus_lisatty": "Reikalavimas pridėtas.",
  "koh.vahv.poista_rivivaatimus": "Pašalinti reikalavimą «{nimi}» iš poreikio {n} × {luokka}?",
  "koh.vahv.tarjokkaat_muuttuu": "Kandidatų skaičius pasikeis.",
  "koh.ilm.rivivaatimus_poistettu": "Reikalavimas «{nimi}» pašalintas iš poreikio.",
  "koh.ilm.vaatimus_poistettu": "Reikalavimas pašalintas.",
  "koh.tunnus_muutettu_title": "ID pakeistas — senas ID pakeitimų žurnale",
  "koh.entinen": "anksčiau {tunnus}",
  "koh.jatkaa": "tęsia {tunnus}",
  "koh.oma_teksti_title": "objekto nuosavas tekstas",
  "koh.ei_liitetty_title": "Objektas nesusietas su užsakovų registru",
  "koh.ei_rekisterissa": "nėra registre",
  "koh.yhdista_asiakas": "Susieti užsakovą",
  "koh.laji.jatkuva": "nuolatinis",
  "koh.laji.projekti": "projektas",
  "koh.tyolaji": "Darbo tipas",
  "hkor.syy.nappailyvirhe": "Įvedimo klaida",
  "hkor.syy.vaara_sauma": "Netinkama siūlė",
  "hkor.syy.vaara_sulatus": "Netinkamas lydinio numeris",
  "hkor.syy.vaara_tekija": "Netinkamas darbuotojas",
  "hkor.syy.taydennys": "Papildyti trūkstami duomenys",
  "hkor.syy.muu": "Kita",
  "koh.virhe.asetus": "Nepavyko išsaugoti nustatymo.",
  "koh.lahtoaukot_tilaajalle": "Rodyti pradinių duomenų spragas užsakovui",
  "koh.edustaja_pakollinen": "Linijos patikroje privalomas užsakovo atstovas",
  "koh.dok_kieli": "Dokumentacijos kalba",
  "koh.org_oletus": "Organizacijos numatytoji",
  "koh.org_oletus_pieni": "organizacijos numatytoji",
  "koh.kieli_suomi": "Suomių",
  "koh.luovutettu": "Perduota",
  "koh.paivaa_ei_tiedeta": "— data nežinoma",
  "koh.tarpeet": "Poreikiai",
  "koh.resurssitarve": "Išteklių poreikis",
  "koh.ei_tarpeita": "Nėra poreikių. Be jų šis objektas neįtraukiamas į trūkumo skaičiavimą.",
  "koh.avoinna": "atvira {a} / {n}",
  "koh.sidottu_n": "priskirta {n}",
  "koh.kelpoisia": "tinkami {n}",
  "koh.sidottu_vajain": "{n} priskirta be reikalaujamos kvalifikacijos",
  "koh.n_ei_kelpaa_nyt": "{n} šiuo metu netinka",
  "koh.n_uusittava": "{n} reikia atnaujinti",
  "koh.ei_vaatimuksia_lyh": "nėra reikalavimų",
  "koh.osaajia_luokassa": "{n} kompetentingi darbuotojai klasėje",
  "koh.sitomatta_title": "Paskirstyta šiam objektui poreikio laikotarpiu, bet nepriskirta šiam poreikiui (seni paskirstymai). Priskirkite užduočiai žemiau — keičiasi tik užduotis; valandos ir pastabos išsaugomos.",
  "koh.kohteessa_sitomatta": "{n} objekte, nepriskirta poreikiui",
  "koh.plus_vaatimus": "+ reikalavimas",
  "koh.piilota_tarjokkaat": "Slėpti kandidatus",
  "koh.tarjokkaat_n": "Kandidatai ({n})",
  "koh.poista_tarve": "Ištrinti poreikį",
  "koh.n_maarasta": "{n} iš {m}",
  "koh.tayttaa": "atitinka {n} / {m}",
  "koh.tanaan_n": "šiandien {n}",
  "koh.poista_vaatimus_title": "Pašalinti reikalavimą {nimi} iš šio poreikio",
  "koh.patevyys": "Kvalifikacija",
  "koh.montako": "Kiek iš {n}",
  "koh.tyhja_kaikilta": "tuščia = visi ({n})",
  "koh.lisaa": "Pridėti",
  "koh.sitomaton_rivi": "{nimi} — objekte {pv} d. · {h} h, be užduoties",
  "koh.liita_selite": "Priskirti užduočiai leidžiama, tačiau priežastis išsaugoma kartu su autoriumi ir laiku.",
  "koh.pakollinen_patevyys": "privaloma kvalifikacija",
  "koh.liita_placeholder": "pvz., kortelė bus atnaujinta prieš pradžią",
  "koh.liita_title": "Priskirti esamas paskirstymo dienas šiai užduočiai. Valandos, būsena ir pastabos nesikeičia.",
  "koh.sido_tehtavaan_peruste": "Priskirti užduočiai su pagrindimu",
  "koh.sido_tehtavaan": "Priskirti užduočiai",
  "koh.sidottu_sana": "priskirta",
  "koh.peruste_kirjattu": "pagrindimas įrašytas",
  "koh.pura": "Atšaukti priskyrimą",
  "koh.tarve_taynna": "Poreikis užpildytas — padidinkite poreikį, jei reikia daugiau žmonių.",
  "koh.sido_avaa": "Priskirti…",
  "koh.patevyydet_kp": "Kvalifikacijos:",
  "koh.ei_korttia": "(nėra kortelės)",
  "koh.umpeutui": "(baigėsi {pvm})",
  "koh.voimassaolo_kirjaamatta": "(galiojimas neįrašytas)",
  "koh.perehdytys_kp": "Instruktažas: {lista}",
  "koh.ennen": "iki {pvm}",
  "koh.sidottu_iso": "Priskirta",
  "koh.tahan": "čia",
  "koh.kohteeseen": "į objektą {kohde}",
  "koh.ei_vapaita": "šiuo laikotarpiu laisvų dienų nėra",
  "koh.vapaa_alkaen": "laisvas nuo {pvm}",
  "koh.allokoitu_pv": "{n} darbo d. įrašyta šiame objekte per laikotarpį",
  "koh.peruste_kirjattu_kp": "Pagrindimas įrašytas: {peruste}",
  "koh.sidotaan": "Priskirti",
  "koh.koko_jaksolle": "Visam laikotarpiui",
  "koh.osalle_jaksosta": "Laikotarpio daliai",
  "koh.paattyy_mukaan": "Baigiasi (imtinai)",
  "koh.tyopaiva": "Darbo diena",
  "koh.h_pv": "h/d.",
  "koh.sidonta_selite": "Priskirti leidžiama, tačiau priežastis išsaugoma kartu su autoriumi ir laiku.",
  "koh.sidonta_placeholder": "pvz., laukiama saugumo patikrinimo, prašymas pateiktas 18.9.",
  "koh.sido_peruste": "Priskirti su pagrindimu",
  "koh.sido": "Priskirti",
  "koh.sidonta_huom": "Priskyrimas įrašo darbo dienas priskirtam intervalui. «Neatitinka reikalavimų» ir «Šiuo metu netinka» vis tiek galima priskirti su pagrindimu — sistema neblokuoja, o praneša.",
  "koh.ei_kelpaa_nyt": "šiuo metu netinka",
  "koh.uusittava": "reikia atnaujinti",
  "koh.uusi_tarve": "Naujas poreikis",
  "koh.tyhja_loppu": "Tuščia pabaigos data reiškia neterminuotą. Priežiūros sutarčiai reikia darbuotojų, nors niekas nežino, iki kada.",
  "koh.tyomaa_vaatii_tarpeelta": "Ką objektas reikalauja iš šio poreikio",
  "koh.tyomaa_vaatii_hint": "kvalifikacijos, pvz., karštųjų darbų kortelė — neprivaloma",
  "koh.lisaa_patevyysvaatimus": "+ Pridėti kvalifikacijos reikalavimą",
  "koh.lisaa_tarve_ja_1": "Pridėti poreikį ir 1 reikalavimą",
  "koh.lisaa_tarve_ja_n": "Pridėti poreikį ir {n} reikalavimus",
  "koh.lisaa_tarve": "Pridėti poreikį",
  "koh.valitse_osaaminen": "Pirmiausia pasirinkite kompetenciją.",
  "koh.patevyysvaatimukset": "Kvalifikacijos reikalavimai",
  "koh.ei_vaatimuksia": "Reikalavimų nėra. Nurodykite, kokių kvalifikacijų reikia objekte, ir matysite, kas jas turi ir kas laisvas tuo laikotarpiu.",
  "koh.osaajaa_vapaana": "{n} specialistų · {v} laisvi",
  "koh.ei_ketaan": "Niekas neturi galiojančios šio tipo kvalifikacijos.",
  "koh.kohdistamattomat": "Nepriskirti reikalavimai",
  "koh.kohdistamattomat_hint": "{n} · įrašyti objekte, kol dar nebuvo galima reikalavimų susieti su poreikio eilute",
  "koh.kohdistamattomat_selite": "Jie neriboja kandidatų, nes nežinoma, kam jie taikomi. Pridėkite reikalavimą iš naujo prie tinkamos poreikio eilutės žemiau — tada senąją eilutę galima ištrinti.",
  "koh.ei_mahdu": "netelpa į objektą",
  "koh.kohdistamaton": "nepriskirta",
  "koh.kirjattu_lukuna": "įrašyta kaip {n}",
  "koh.ei_tarverivit": "objektas neturi poreikio eilučių — pirmiausia pridėkite poreikį",
  "koh.koko_tarve_on": "viso objekto poreikis yra {n} — skaičius turi pasikeisti, kad būtų galima priskirti",
  "koh.mahtuu": "telpa:",
  "koh.ei_yhdellekaan": "nė viena eilutė atskirai — padalykite arba sumažinkite skaičių",
  "koh.uusi_kohde": "Naujas objektas",
  "koh.jatkuva_hint": "Tęstinei sutarčiai pabaigos datos nereikia",
  "koh.nimi_placeholder": "Celiuliozės gamyklos remontinis sustabdymas",
  "koh.sijainti": "Vieta",
  "koh.rajattu_projekti": "Terminuotas projektas",
  "koh.jatkuva_sopimus": "Tęstinė sutartis",
  "koh.ei_liitetty": "Objektas nesusietas su užsakovų registru.",
  "koh.oma_teksti_on": "Objekto paties tekstas yra «{teksti}»; jis lieka šaltinio reikšme ir nesikeičia susiejus.",
  "koh.irrota": "Atsieti",
  "koh.asiakas_rekisterista": "Užsakovas iš registro",
  "koh.valitse_viiva": "— pasirinkite —",
  "koh.uusi_asiakas": "+ Naujas užsakovas…",
  "koh.rooli": "Vaidmuo",
  "koh.uuden_asiakkaan_nimi": "Naujo užsakovo pavadinimas",
  "koh.asiakas_placeholder": "pvz., Nammo Lapua Oy",
  "koh.luo_ja_liita": "Sukurti ir susieti",
  "koh.liita_kohteeseen": "Susieti su objektu",
  "koh.kirjoita_nimi": "Įveskite naujo užsakovo pavadinimą.",
  "koh.valitse_asiakas": "Pasirinkite užsakovą iš registro, kad susietumėte jį su objektu.",
  "koh.rooli_vihje": "Vaidmuo apibūdina sutartinį ryšį, ne prieigą. Užsakovo susiejimas ar vaidmens keitimas niekam nesuteikia ir neatima šio objekto matomumo — matomumas suteikiamas rodinyje Naudotojai.",
  "koh.vahv.irrota": "Atsieti «{nimi}» nuo šio objekto?",
  "koh.vahv.irrota_selite": "Užsakovas lieka registre, o objekto paties užsakovo tekstas išsaugomas. Tai neturi įtakos prieigos teisėms.",
  "koh.tyomaaperehdytys": "Objekto instruktažas",
  "koh.n_puuttuu": "trūksta {n}",
  "koh.ei_miehitysta": "Objektas neturi personalo, todėl nėra ką instruktuoti. Sąrašas užsipildys, kai žmonės bus paskirstyti.",
  "koh.paivia": "Dienos",
  "koh.ensimmainen": "Pirma",
  "koh.vaatimus": "Reikalavimas",
  "koh.perehdytys": "Instruktažas",
  "koh.perehdyttaja": "Instruktavo",
  "koh.oletus_title": "Objektui neįrašyta instruktažo reikalavimų — tai numatytoji reikšmė",
  "koh.oletus": "numatyta",
  "koh.voimassa": "galioja iki {pvm}",
  "koh.vanhentunut": "baigėsi {pvm}",
  "koh.puuttuu": "trūksta",
  "koh.tyhja_sina": "tuščia = jūs",
  "koh.voimassa_asti": "Galioja iki",
  "koh.mita_kaytiin": "Kas aptarta",
  "koh.mita_kaytiin_placeholder": "pavojingos zonos, avariniai išėjimai, …",
  "koh.kirjaa_perehdytys": "Įrašyti instruktažą",
  "koh.mita_tyomaa_vaatii": "Ką reikalauja šis objektas",
  "koh.oletettu_selite": "Objektui neįrašyta instruktažo reikalavimų. Kol kas sąrašas veikia su vienu numanomu reikalavimu («objekto instruktažas») — ta pačia taisykle, kurią iki šiol kėlė aptikimas. Tai nėra užsakovo reikalavimas.",
  "koh.vapaaehtoinen": "neprivaloma",
  "koh.perehdytyksen_laji": "Instruktažo rūšis",
  "koh.laji_placeholder": "pvz., objekto instruktažas",
  "koh.alue": "Zona",
  "koh.alue_placeholder": "tuščia = paties objekto",
  "koh.lisaa_vaatimus": "Pridėti reikalavimą",
  "koh.perehdytys_vihje": "Instruktažas priklauso objektui ir nepersikelia: naujame objekte jis atliekamas iš naujo, net jei ankstesnis buvo vakar. Tuščias galiojimas reiškia visam objektui.",
  "koh.vahv.poista_perehdytysvaatimus": "Pašalinti reikalavimą «{laji}»?",
  "koh.vahv.perehdytykset_sailyvat": "Įrašyti instruktažai išsaugomi, tačiau jie nebeatitinka jokio reikalavimo.",
  "koh.ilm.tunnus_vaihdettu": "ID {vanha} → {uusi}. Senasis ID lieka pakeitimų žurnale ir paieškoje.",
  "koh.ilm.jatko_luotu": "Sukurtas naujas objektas {uusi} kaip objekto {vanha} tęsinys: užsakovas ir vieta nukopijuoti, įrašai liko senajame.",
  "koh.muokkaa_tunnusta": "Redaguoti ID",
  "koh.uusi_tunnus": "Naujas ID",
  "koh.tunnus_peruste_placeholder": "pvz., užsakymo numeris įvestas klaidingai",
  "koh.kirjoitusvirhe": "Rašybos klaidos taisymas (leidžiama, net jei yra įrašų)",
  "koh.vaihda_tunnus": "Keisti ID",
  "koh.uusi_jatkona": "Naujas objektas kaip tęsinys",
  "koh.luo_jatkona": "Sukurti kaip tęsinį",
  "koh.jatko_hint": "Užsakovas, vieta ir užsakovų sąsajos nukopijuojamos; įrašai, valandos ir perdavimas lieka senajame.",
  "esto.oikeus": "Trūksta teisės",
  "main.esto_academy": "Academy suteikiama asmeniškai: ją jums gali suteikti administratorius arba jūsų objekto darbų vadovas.",
  "hen.academy": "Academy",
  "hen.academy_anna": "Suteikti Academy",
  "hen.academy_pois": "Pašalinti Academy",
  "hen.academy_virhe": "Nepavyko pakeisti Academy teisės.",
  "sel.t_poisto_odottaa": "Ištrynimas laukia patvirtinimo",
  "sel.pyyda_poistoa": "Prašyti ištrinti",
  "sel.pyyda_poistoa_otsikko": "Prašyti ištrinti siūlę {nro}",
  "sel.ratkaise_poisto": "Ištrynimo prašymas {nro}",
  "sel.miksi_poistetaan": "Kodėl siūlė ištrinama?",
  "sel.laheta_poistoesitys": "Siųsti ištrynimo prašymą",
  "sel.vahvista_poisto": "Patvirtinti ištrynimą",
  "sel.hylkaa_poisto": "Atmesti — siūlė lieka",
  "sel.poisto_virhe": "Nepavyko apdoroti ištrynimo prašymo.",
  "sel.poisto_esitys_vihje": "Siūlė neištrinama iš karto: prašymas siunčiamas darbų vadovui arba administratoriui patvirtinti ir rodomas sąraše «Laukia patvirtinimo». Importuota, patvirtinta ar patikrinta siūlė neištrinama — naudokite «Nedaroma».",
  "sel.poisto_ratkaisu_vihje": "Patvirtinus siūlė ištrinama, o prašymas su duomenimis išlieka įrašuose. Savo paties prašymo patvirtinti negalite.",
  "sel.poisto_hylkays_peruste": "Atmetimo priežastis (privaloma tik atmetant)",
  "kanta.moduuli.henkilot.nimi": "Personalas",
  "kanta.moduuli.henkilot.kuvaus": "Asmenų registras, kompetencijos, darbo laikas.",
  "kanta.moduuli.hitsausloki.nimi": "Suvirinimo žurnalas",
  "kanta.moduuli.hitsausloki.kuvaus": "Vamzdynų sritis: siūlės, lydinių numeriai, NDT ir slėgio bandymai su atsekamumu.",
  "kanta.moduuli.iv_asennus.nimi": "ŠVOK montavimas",
  "kanta.moduuli.iv_asennus.kuvaus": "Ortakių montavimas: sistema → ortakio atkarpa → galinis elementas, sandarumo ir oro srauto matavimai prietaisais, pasirengimas perdavimui.",
  "kanta.moduuli.kalusto.nimi": "Įranga",
  "kanta.moduuli.kalusto.kuvaus": "Suvirinimo aparatai, krautuvai ir kita įranga. Patikros su sertifikatais ir priminimais apie galiojimo pabaigą.",
  "kanta.moduuli.kayttajat.nimi": "Naudotojų valdymas",
  "kanta.moduuli.kayttajat.kuvaus": "Paskyros, vaidmenys, kvietimo nuorodos.",
  "kanta.moduuli.kohteet.nimi": "Objektai",
  "kanta.moduuli.kohteet.kuvaus": "Objektai, išteklių poreikiai, laiko juosta.",
  "kanta.moduuli.laiteasennus.nimi": "Įrangos montavimas",
  "kanta.moduuli.laiteasennus.kuvaus": "Įrangos montavimas ir paleidimas kaip etapų grandinės, jungčių priveržimo patvirtinimas ir perdavimo medžiaga.",
  "kanta.moduuli.liitteet.nimi": "Priedai",
  "kanta.moduuli.liitteet.kuvaus": "Sertifikatai ir kiti failai kaip įrašų priedai.",
  "kanta.moduuli.mitoitus.nimi": "Pajėgumų užklausa",
  "kanta.moduuli.mitoitus.kuvaus": "Ar išteklių pakaks naujai sutarčiai.",
  "kanta.moduuli.osaaminen.nimi": "Kompetencijų keliai",
  "kanta.moduuli.osaaminen.kuvaus": "Kompetencijų keliai, lygiai ir iš atlikto darbo išvestas kompetencijos lygis. Academy pagrindas.",
  "kanta.moduuli.patevyydet.nimi": "Kvalifikacijos",
  "kanta.moduuli.patevyydet.kuvaus": "Kortelės ir sertifikatai su įspėjimais apie galiojimo pabaigą.",
  "kanta.moduuli.poissaolot.nimi": "Neatvykimai",
  "kanta.moduuli.poissaolot.kuvaus": "Atostogos, ligos ir kiti neatvykimai.",
  "kanta.moduuli.puutteet.nimi": "Trūkumai ir spragos",
  "kanta.moduuli.puutteet.kuvaus": "Kas negerai: radinys, atsakomybė, poveikis ir amžius viename sąraše. Bendras — trūkumas gali nurodyti į bet ką, o išorinė atsakomybė atskiriama nuo mūsų pačių atvirų darbų. Suvirinimo žurnalo defektai, šaltinio duomenų spragos ir dokumentacijos skola yra atskirame modulyje.",
  "kanta.moduuli.resurssit.nimi": "Ištekliai ir pajėgumai",
  "kanta.moduuli.resurssit.kuvaus": "Tinklelis, paskirstymas, trūkumas. Sistemos šerdis.",
  "kanta.moduuli.tarjous.nimi": "Pasiūlymai",
  "kanta.moduuli.tarjous.kuvaus": "Pasiūlymo struktūra: kiekiai, valandos, sąnaudos, marža ir rizika. Priimtas pasiūlymas tampa objektu, o faktiniai duomenys kaupiami pagal jį.",
  "kanta.oikeus.academy.nimi": "Academy naudojama",
  "kanta.oikeus.academy.kuvaus": "Gali naudotis Academy: kursais, testais ir savo atlikimais. Administratoriaus, planuotojo ir besimokančiojo vaidmenys Academy mato visada; kitiems ji suteikiama asmeniškai. Objekto darbų vadovas gali ją suteikti lauko paskyroms savo objektuose.",
  "kanta.oikeus.ainestodistukset_luku.nimi": "Medžiagų sertifikatai (skaitymas)",
  "kanta.oikeus.ainestodistukset_luku.kuvaus": "Gali skaityti objekto medžiagų sertifikatus ir lydinių numerių aprėptį, bet ne pridėti ar ištrinti. Pvz., užsakovo atstovas galutinei dokumentacijai. Visa įmonė arba vienas objektas.",
  "kanta.oikeus.arkaluonteiset_henkilotiedot.nimi": "Jautrūs asmens duomenys",
  "kanta.oikeus.arkaluonteiset_henkilotiedot.kuvaus": "Darbo užmokestis, asmens kodas, banko sąskaita ir priedai, pažymėti kaip jautrūs.",
  "kanta.oikeus.hitsausloki_tyonjohto.nimi": "Suvirinimo žurnalo darbų vadovo rodinys",
  "kanta.oikeus.hitsausloki_tyonjohto.kuvaus": "Lauko paskyra mato viso objekto būseną suvirinimo žurnale (šiandienos siūlės, atviri trūkumai, «Kas užstrigo») ir darbų vadovo spaudinį. Be šios teisės lauko paskyra mato tik savo siūles ir įrašymą. Oficialus žurnalas lauko darbams neskirtas.",
  "kanta.oikeus.kaannostarkistus.nimi": "Vertimų peržiūra",
  "kanta.oikeus.kaannostarkistus.kuvaus": "Gali peržiūrėti naudotojo sąsajos vertimus savo kalba (paskyros kalba) ir siūlyti pataisymus. Pataisymas nenaudojamas iki patvirtinimo.",
  "kanta.oikeus.kaannosten_hyvaksynta.nimi": "Vertimų patvirtinimas",
  "kanta.oikeus.kaannosten_hyvaksynta.kuvaus": "Gali patvirtinti arba atmesti peržiūrėtojų vertimų pataisymus visomis kalbomis.",
  "kanta.oikeus.kalustovastaava.nimi": "Atsakingas už įrangą",
  "kanta.oikeus.kalustovastaava.kuvaus": "Tvarko įrangos registrą: prideda, redaguoja, importuoja ir eksportuoja įrangą. Visa įmonė (pvz., biuro medžiagų koordinatorius) arba vienas objektas (objekto darbų vadovas).",
  "kanta.oikeus.osaaminen_arviointi.nimi": "Praktinio vertinimo patvirtinimas",
  "kanta.oikeus.osaaminen_arviointi.kuvaus": "Patvirtina etapų atlikimą ir įskaito ankstesnę patirtį.",
  "kanta.oikeus.osaaminen_nimitys.nimi": "Priskyrimas kompetencijų keliui",
  "kanta.oikeus.osaaminen_nimitys.kuvaus": "Atidaro asmeniui naują kelią ir atšaukia priskyrimą.",
  "kanta.oikeus.osaaminen_rajat.nimi": "Kompetencijų ribos",
  "kanta.oikeus.osaaminen_rajat.kuvaus": "Apibrėžia kelius, lygius ir ribas.",
  "kanta.oikeus.perehdytykset_luku.nimi": "Instruktažai (skaitymas)",
  "kanta.oikeus.perehdytykset_luku.kuvaus": "Gali skaityti objekto instruktažus (kas instruktuotas). Pagal nutylėjimą užsakovui neskirta. Visa įmonė arba vienas objektas.",
  "kanta.oikeus.punakyna_hyvaksynta.nimi": "Raudonojo žymėjimo patvirtinimas",
  "kanta.oikeus.punakyna_hyvaksynta.kuvaus": "Gali vėliau patvirtinti lauke atliktą pakeitimą: pridėtą siūlę su papildomu numeriu ir sprendimą, kad suplanuota siūlė nedaroma. Skirta išoriniam tvirtintojui — inspektoriui, projektavimo biurui ar užsakovo atstovui — kuris tvirtindamas pasirenka savo pareigas. Galima apriboti vienu objektu. Įmonės pačios darbų vadovai tvirtina be šios teisės.",
  "kanta.oikeus.punch_poikkeama.nimi": "Defekto išimtis",
  "kanta.oikeus.punch_poikkeama.kuvaus": "Gali patvirtinti linijos patikrą, nors linija turi atvirą A klasės defektą (blokuoja hidraulinį bandymą). Išimtis su priežastimi įrašoma patvirtinime. Visa įmonė arba vienas objektas (pvz., projekto vadovas).",
  "kanta.oikeus.viestin_lahetys.nimi": "Pranešimų siuntimas",
  "kanta.oikeus.viestin_lahetys.kuvaus": "Gali siųsti vienpusius pranešimus programoje: visiems, pasirinktiems naudotojams arba objekto darbų vadovams. Tai teisė, o ne vaidmuo, nes siuntėjas gali būti biuro komunikacijos specialistas.",
  "pu.vastuu_suodatin.tyonjohto": "Darbų vadovai",
  "pu.vastuu_suodatin.suunnittelu": "Projektavimas",
  "pu.vastuu_suodatin.ulkoinen": "Išorinė atsakomybė",
  "pu.vastuu_suodatin.muu": "Kita (įrašyta)",
  "pu.vastuu_suodatin.ei": "Atsakomybė neįrašyta",
  "testaus.yla": "Demo",
  "testaus.otsikko": "Testavimo instrukcija",
  "testaus.tulosta": "Spausdinti (A4)",
  "testaus.haku_virhe": "Nepavyko įkelti testavimo instrukcijos.",
  "valikko.testaus": "Testavimas",
  "valikko.ohjeet": "Instrukcijos",
  "ohjeet.vain_kielella": "Ši instrukcija prieinama tik {kieli} kalba.",
  "kieli.nimi.fi": "Suomių",
  "kieli.nimi.en": "Anglų",
  "valikko.ryhma.tuki": "Pagalba",
  "valikko.testauspalaute": "Testavimo atsiliepimai",
  "yla.ohjeet": "Instrukcijos",
  "tpa.uutta_otsikko": "Nauja testuoti",
  "tpa.katsottu": "peržiūrėta",
  "tpa.ilmoitukset_otsikko": "Pranešimai apie naujoves testuoti",
  "tpa.ilmoitus_tila.luonnos": "Juodraštis — išsiunčiamas 7:00",
  "tpa.ilmoitus_tila.lahetetty": "Išsiųsta",
  "tpa.ilmoitus_tila.peruttu": "Atšaukta",
  "tpa.riveja": "{n} eil.",
  "tpa.peru": "Atšaukti šiandienos pranešimą",
  "tpa.peru_vahvistus": "Atšaukti šiandienos pranešimą? Tie patys pakeitimai bus rytojaus juodraštyje.",
  "tpa.peru_virhe": "Nepavyko atšaukti.",
  "tpa.nappi": "Atsiliepimas",
  "tpa.otsikko": "Atsiliepimas apie šį puslapį",
  "tpa.sulje": "Uždaryti",
  "tpa.peruuta": "Atšaukti",
  "tpa.laheta": "Siųsti atsiliepimą",
  "tpa.tyyppi": "Tipas",
  "tpa.tyyppi.puuttuu": "Trūksta",
  "tpa.tyyppi.vaikea": "Sunku suprasti",
  "tpa.tyyppi.virhe": "Klaida",
  "tpa.tyyppi.hienosti": "Puikiai padaryta",
  "tpa.mita_huomasit": "Ką pastebėjote?",
  "tpa.nimikirjaimet": "Jūsų inicialai (neprivaloma)",
  "tpa.nimikirjaimet_esim": "pvz., AB",
  "tpa.nimikirjaimet_selite": "Šiuo prisijungimu naudojasi keli testuotojai. Jūsų inicialai įsimenami šioje naršyklėje, o jūsų žymos išsaugomos pagal juos — jūs nematote kitų žymų, o jie nemato jūsų. Eksporte rodomi tik inicialai.",
  "tpa.ohje_merkitse": "Pažymėkite kiekvieną užduotį iš karto, kai ją atlikote. Jūsų pasirinkimas išsaugomas iš karto — galite sustoti ir tęsti vėliau.",
  "tpa.tehtavan_tulos": "Užduoties {nro} rezultatas",
  "tpa.tulos.onnistui": "✓ Pavyko",
  "tpa.tulos.ei_onnistunut": "✗ Nepavyko",
  "tpa.tulos.ei_ymmarretty": "? Nesupratau, ką daryti",
  "tpa.kommentti": "Komentaras (neprivaloma)",
  "tpa.tallennettu": "Išsaugota {klo}",
  "tpa.tallennus_virhe": "Nepavyko išsaugoti. Bandykite dar kartą.",
  "tpa.lopuksi": "Pabaigai (viskas neprivaloma)",
  "tpa.kysymys.puuttuu": "Ar trūksta ko nors, ko jums reikėtų darbe?",
  "tpa.kysymys.vaikea": "Ką buvo sunku suprasti?",
  "tpa.kysymys.hienosti": "Kas buvo TIKRAI puikiai padaryta?",
  "tpa.kysymys.kayttaisi": "Ar naudotumėte tai objekte? (1 = ne, 5 = tikrai)",
  "tpa.kysymys.perustelu": "Priežastis viena eilute",
  "tpa.perustelu_esim": "pvz., įrašyti greičiau nei popieriuje",
  "tpa.puhelin": "telefonas",
  "tpa.tietokone": "kompiuteris",
  "tpa.kiitos": "Ačiū! Jūsų atsiliepimas išsaugotas.",
  "tpa.lahetys_virhe": "Nepavyko išsiųsti atsiliepimo.",
  "tpa.syy_tyyppi_teksti": "Pasirinkite tipą ir parašykite, ką pastebėjote.",
  "tpa.syy_tyyppi": "Pasirinkite tipą.",
  "tpa.syy_teksti": "Parašykite, ką pastebėjote.",
  "tpa.kuka_nakee": "Atsiliepimas keliauja tiesiai „Sampo Industrial“ kūrėjams.",
  "tpa.koonti_otsikko": "Testavimo atsiliepimai",
  "tpa.suodata_rooli": "Vaidmuo",
  "tpa.suodata_laji": "Rūšis",
  "tpa.suodata_tyyppi": "Tipas",
  "tpa.kaikki": "Visi",
  "tpa.laji.tehtava": "Užduotys",
  "tpa.laji.loppu": "Baigiamieji klausimai",
  "tpa.laji.sivu": "Atsiliepimo mygtukas",
  "tpa.ei_palautetta": "Pagal pasirinktus filtrus atsiliepimų nėra.",
  "tpa.haku_virhe": "Nepavyko įkelti atsiliepimų.",
  "tpa.s_rooli": "Vaidmuo",
  "tpa.s_kohta": "Punktas",
  "tpa.s_tulos": "Rezultatas / tipas",
  "tpa.s_teksti": "Tekstas",
  "tpa.s_testaaja": "Testuotojas",
  "tpa.s_aika": "Laikas",
  "ohjeet.yla": "Naudotojo instrukcija",
  "ohjeet.otsikko": "Instrukcijos",
  "ohjeet.haku_virhe": "Nepavyko įkelti instrukcijos.",
  "ohjeet.rooli": "Vaidmuo",
  "ohjeet.kirjoittamatta": "instrukcijos dar nėra",
  "ohjeet.ei_ohjetta": "Vaidmens «{rooli}» instrukcija dar neparašyta.",
  "ohjeet.testausohje": "Testavimo instrukcija",
  "ohjeet.rooli.paakayttaja": "Administratorius",
  "ohjeet.rooli.projektipaallikko": "Projekto vadovas",
  "ohjeet.rooli.tyonjohtaja": "Darbų vadovas",
  "ohjeet.rooli.hitsaaja": "Suvirintojas",
  "ohjeet.rooli.asentaja": "Vamzdynų montuotojas",
  "ohjeet.rooli.kenttatyo": "Lauko darbai",
  "ohjeet.rooli.tilaaja": "Užsakovas",
  "ohjeet.rooli.tarkastaja": "Inspektorius",
  "testaus.loydokset": "Radiniai",
  "testaus.l_missa": "Kur / ką dariau",
  "testaus.l_tapahtui": "Kas nutiko",
  "testaus.l_odotin": "Ko tikėjausi",
  /* T530 oikeusnäkymä (12.10.2026, konekäännös, tarkistamatta) */
  "oik.tiivistelma_tyhja": "Nėra paketų ar atskirų teisių",
  "oik.tee_hanesta": "Paskirti …",
  "oik.tee_vihje": "Paketas suteikia vaidmeniui reikalingas teises vienu projekto pasirinkimu. Pašalinus paketą, pašalinamos tik jo suteiktos teisės.",
  "oik.voimassa": "galioja",
  "oik.anna": "Suteikti paketą",
  "oik.muuta": "Keisti projektus",
  "oik.pura": "Pašalinti paketą",
  "oik.pura_vahvista": "Pašalinti paketą «{nimi}»? Kitaip suteiktos teisės lieka. Vaidmuo nesikeičia.",
  "oik.koko_yritys": "Visa įmonė",
  "oik.valitut_kohteet": "Pasirinkti projektai",
  "oik.hae_kohde": "Ieškoti projekto",
  "oik.nayta_suljetut": "Rodyti ir uždarytus projektus",
  "oik.valittu_n": "pasirinkta: {n}",
  "oik.ei_kohteita": "Pasirinkite bent vieną projektą arba «Visa įmonė».",
  "oik.vaatii_roolin": "Reikalingas vaidmuo «{rooli}» — pridėti kartu",
  "oik.laji_ulkopuolinen": "Tik išorinei paskyrai (užsakovas ar tikrinimo įstaiga)",
  "oik.laji_henkilo": "Tik savo darbuotojų paskyrai",
  "oik.koskee_koko_yritysta": "{oikeudet} visada taikoma visai įmonei",
  "oik.ei_oikeuksia": "Atskirų teisių nėra — tik vaidmuo",
  "oik.peruste": "Priežastis (nebūtina)",
  "oik.tallenna": "Išsaugoti",
  "oik.peru": "Atšaukti",
  "oik.lisaasetukset": "Papildomi nustatymai · suteikta teisių: {n}",
  "oik.hae_oikeus": "Ieškoti teisės",
  "oik.paketista": "iš paketo {paketit}",
  "oik.ei_annettu": "nesuteikta",
  "oik.anna_oikeus": "Suteikti",
  "oik.poista_oikeus": "Pašalinti",
  "oik.lisatietoa": "Daugiau informacijos",
  "oik.kopioi": "Kopijuoti teises iš asmens…",
  "oik.kopioi_valitse": "Pasirinkite paskyrą",
  "oik.kopioi_saa": "Ši paskyra gaus:",
  "oik.kopioi_vahvista": "Kopijuoti",
  "oik.kopioi_ei": "Jautrūs asmens duomenys ir vaidmenys nekopijuojami. Suteikėju įrašomi jūs.",
  "oik.kopioi_tyhja": "Šaltinio paskyroje nėra ką kopijuoti.",
  "oik.tallennettu": "Išsaugota",
  "oik.joukko_anna": "Suteikti paketą pasirinktiems ({n})",
  "oik.joukko_valitse": "Pasirinkite paskyras eilučių žymimaisiais langeliais",
  "oik.joukko_tulos": "{myonnetty}/{valittu} gavo paketą",
  "oik.valitse_paketti": "Pasirinkite paketą",
  "oik.arkaluonteiset_erikseen": "Jautrūs asmens duomenys suteikiami atskiru pasirinkimu, ne paketais.",
  "oik.ryhma.hitsaus_laatu": "Suvirinimas ir kokybė",
  "oik.ryhma.materiaalit_kalusto": "Medžiagos ir įranga",
  "oik.ryhma.osaaminen": "Kompetencija",
  "oik.ryhma.kielet_viestit": "Kalbos ir pranešimai",
  "oik.ryhma.henkilotiedot": "Asmens duomenys",
  "oik.paketti.materiaalivastaava.nimi": "Medžiagų atsakingas",
  "oik.paketti.materiaalivastaava.kuvaus": "Medžiagos ir medžiagų sertifikatai pasirinktuose projektuose",
  "oik.paketti.hitsauskoordinaattori.nimi": "Suvirinimo koordinatorius",
  "oik.paketti.hitsauskoordinaattori.kuvaus": "WPS, suvirintojų kvalifikacijos, medžiagų sertifikatai ir instruktažai",
  "oik.paketti.valvoja.nimi": "Užsakovo prižiūrėtojas",
  "oik.paketti.valvoja.kuvaus": "Tvirtina patvirtinimo laukiančius suvirinimo pakeitimus ir skaito medžiagų sertifikatus",
  "oik.paketti.punch.nimi": "Punch tikrintojas",
  "oik.paketti.punch.kuvaus": "Registruoja ir patvirtina punch (vaidmuo Tikrintojas)",
  "oik.paketti.linjatarkastaja.nimi": "Linijos tikrintojas",
  "oik.paketti.linjatarkastaja.kuvaus": "Linijų patikros ir punch (vaidmuo Tikrintojas)",
  "oik.paketti.ndt.nimi": "NDT tikrintojas",
  "oik.paketti.ndt.kuvaus": "Registruoja NDT rezultatus (vaidmuo Tikrintojas, išorinė paskyra)",
  "oik.paketti.tyonsuunnittelija.nimi": "Darbų planuotojas",
  "oik.paketti.tyonsuunnittelija.kuvaus": "Išteklių planavimas ir darbų paketai (vaidmuo Projekto vadovas)",
  "oik.paketti.kalustovastaava.nimi": "Įrangos atsakingas",
  "oik.paketti.kalustovastaava.kuvaus": "Įrangos registras ir QR etiketės",
  "kanta.oikeus.hitsauskoordinointi.nimi": "Suvirinimo koordinavimas",
  "kanta.oikeus.hitsauskoordinointi.kuvaus": "Gali importuoti WPS ir projekto NDT reikalavimus bei registruoti ir šalinti kvalifikacijas be išteklių planavimo ir komercinių rodinių. NDT reikalavimus galima apriboti projektu; WPS ir kvalifikacijos galioja visai įmonei.",
  "kanta.oikeus.materiaalit.nimi": "Medžiagos",
  "kanta.oikeus.materiaalit.kuvaus": "Gali pridėti, taisyti ir šalinti medžiagų sertifikatus ir lydinių numerius bei registruoti sandėlio nomenklatūrą ir operacijas. Galima apriboti projektu.",
  "oik.ei_talle": "Ne šiai paskyrai: {paketit} — {syy}",
  "oik.vaatii_roolin_lyhyt": "reikalingas vaidmuo {rooli}",
  "oik.lisatietoa_x": "Daugiau informacijos: {nimi}",
  "oik.annettu_koko": "suteikta · visa įmonė",
  "oik.annettu_n": "suteikta · projektų: {n}",
  "oik.n_annettu": "suteikta: {n}",
  "kay.tunnus_lyhyt": "Paskyra",
  "kay.vaihda": "Keisti",
  // 15.10.2026 (Toni): puuttuvat liettuankieliset — valikko, latausviestit, Hubin säännöt, virheet
  "valikko.suunnitelma": "3 savaičių planas",
  "valikko.odottaa_vahvistusta": "Laukia patvirtinimo",
  "virhe.hoitaja_jo": "Šią eilutę jau tvarko kitas asmuo. Darbų vadovas gali ją perskirti.",
  "virhe.hoitaja_ei_kelpaa": "Pasirinkta paskyra nemato šios eilutės arba neturi teisės į eilę.",
  "virhe.ei_hoitajaa": "Šios eilutės niekas netvarko.",
  "virhe.ei_oikeutta_osoittaa": "Kito vardu priskirti gali tik darbų vadovas arba administratorius.",
  "virhe.ei_oikeutta_vapauttaa": "Kito tvarkomą eilutę atlaisvinti gali tik darbų vadovas arba administratorius.",
  "virhe.ei_poisteta": "Darbų paketas netrinamas — archyvuokite jį.",
  "virhe.jo_arkistoitu": "Darbų paketas jau archyvuotas.",
  "virhe.hitsinumero_muoto": "Siūlės numeris netinka: naudokite numerį arba subnumerį (pvz., 12 arba 12.1), ne daugiau kaip 6 skaitmenys prieš tašką.",
  "virhe.emo_moniselitteinen": "Pagrindinė siūlė neaiški: toje pačioje linijoje ir lape yra kelios siūlės šiuo numeriu.",
  "virhe.korjattava_moniselitteinen": "Taisytina siūlė neaiški: keletas siūlių turi šį numerį.",
  "virhe.ndt_tunnistetiedot_puuttuvat": "NDT rezultatui reikia tikrintojo ir protokolo numerio.",
  "lataus.ladataan": "Įkeliama…",
  "lataus.yrita": "Bandyti dar kartą",
  "lataus.kohteet": "Nepavyko įkelti objektų",
  "lataus.kohteet_henkilot": "Nepavyko įkelti objektų ir žmonių",
  "lataus.osaamisluokat": "Nepavyko įkelti kompetencijų klasių",
  "hub.saanto.paiva_jasentymaton": "data neatpažinta",
  "hub.saanto.sulatus_puuttuu": "trūksta lydinio numerio",
  "hub.saanto.korjaus_orpo": "remontas be originalios siūlės",
  "hub.saanto.painekoe_valine": "slėgio bandymas: priemonė",
  "hub.saanto.hitsisuunnitelma_puuttuu": "trūksta suvirinimo plano",
  "hub.saanto.perehdytys": "instruktažas objekte",
  "hub.saanto.materiaali_puuttuu": "trūksta medžiagos",
  "hub.saanto.patevyys_vanhenee": "kvalifikacija baigia galioti",
  "hub.saanto.patevyys_kesken": "kvalifikacija nebaigta",
  "hub.saanto.kalusto_katsastus": "įrangos patikra",
  "hub.saanto.kalusto_ehdotus": "įrangos pasiūlymas",
  "hub.saanto.hitsaaja_tuntematon": "suvirintojas nežinomas",
  "hub.saanto.isometri_puuttuu": "trūksta izometrijos",
  "hub.saanto.iv_ilmavirta": "VĖDINIMAS: oro srautas",
  "hub.saanto.iv_tiiviys": "VĖDINIMAS: sandarumas",
  "hub.saanto.iv_kalibrointi_i": "VĖDINIMAS: kalibravimas (oro srautas)",
  "hub.saanto.iv_kalibrointi_t": "VĖDINIMAS: kalibravimas (sandarumas)",
  "hub.saanto.henkilo": "asmuo",
  "hub.saanto.tarra-normalisointi": "lipduko normalizavimas",
  "hub.saanto.ped_iv_sweco": "PED/VĖDINIMAS (projektuotojo medžiaga)",
  "hub.saanto.dn_epaselva": "DN neaiškus",
  "hub.saanto.hitsinumero_puuttuu": "trūksta siūlės numerio",
  "hub.saanto.hitsinumero_epaselva": "siūlės numeris neaiškus",
  "hub.saanto.muoviputki_epaily": "siūlė plastikiniame vamzdyje?",
  "hub.saanto.rt_hylatty_korjaus": "RT atmesta: taisymas ir pakartotinis RT",
  "hub.saanto.ndt_poytakirja_puuttuu": "trūksta NDT protokolo",
  "vt.raportti": "Protokolo Nr.",
  "ndt.tunnistetiedot_pakolliset": "Tikrintojas ir protokolo numeris yra privalomi.",
  "vt.hyvaksynta_otsikko": "VT priimta, siūlė {nro}",
  "vt.tallenna_hyvaksytty": "Išsaugoti priimtą VT",
  "vt.raportti_pakollinen": "Protokolo numeris yra privalomas.",
  "kuittaus.tunnista_ohje_ilman_tarraa": "Ieškoti: siūlė, linija arba įrenginys (pvz., 0101)",
  "sel.kohde_peruuntunut": "Objektas {kohde} atšauktas. Šios linijos siūlių, patikrinimų ir trūkumų registruoti negalima.",
  "virhe.kohde_peruuntunut": "Objektas atšauktas — jam nieko neregistruojama.",
  "su.tarve_puuttuu": "poreikis nenurodytas",
  "su.lahde": "Poreikis: išteklių poreikis ({rivit} eil., {henkiloita} žm., įmonės numatytoji darbo diena) · Paskirstyta: išteklių planavimas",
  "su.lahde_ei_tarvetta": "Poreikis: šioms savaitėms išteklių poreikio nėra (Išteklių planavimas → Ko reikia objektui) · Paskirstyta: išteklių planavimas",
  "nippu.syy_numeroton_yleinen": "{n} eil. be numerio, kuriose yra data arba suvirintojas — taisyti siūlių sąraše",
  "nippu.aloittamaton_yleinen": "nepradėta eilutė, patikrinkite",
  "su.alku": "Pradžia",
  "su.loppu": "Pabaiga",
  "su.tallenna": "Išsaugoti",
  "su.valitse": "Pasirinkti paketą",
  "su.valittuja": "Pasirinkta: {n}",
  "su.aseta_valituille": "Nustatyti pasirinktiems",
  "su.loppu_ennen_alkua": "Pabaiga yra prieš pradžią.",
  // 250 (Toni 19.10.2026): liitteen laji
  "liite.laji_valinta": "Tipas",
  "liite.laji_tavallinen": "Nuotrauka ar kitas priedas",
  "liite.laji.allekirjoitettu_poytakirja": "Pasirašytas protokolas",
  "liite.laji.allekirjoitus": "Parašas",
  "liite.galleriasta": "Pasirinkti iš galerijos",
  // 251 (T621, Toni 19.10.2026)
  "ltar.allekirjoitus": "Užsakovo atstovo parašas",
  "ltar.allekirjoita_ohje": "Pasirašykite pirštu arba rašikliu",
  "ltar.tyhjenna": "Išvalyti",
  "ltar.syy_allekirjoitus": "Trūksta užsakovo atstovo parašo — nupieškite parašą arba pridėkite pasirašytą protokolą",
  "ltar.allekirjoitettu": "Pasirašė {nimi} · {aika}",
  "ltar.paperi_liitteena": "Pridėtas pasirašytas protokolas ({n})",
  "ltar.tarkastuskuvat": "Patikrinimo nuotraukos",
  "ltar.lisaa_tarkastuskuva": "Pridėti patikrinimo nuotrauką",
  "ltar.tarkastuskuva_vihje": "Nuotraukos mygtukas atidaro kamerą. Pasirašytą popierinį protokolą pridėkite pasirinkę tipą «Pasirašytas protokolas».",
  "virhe.linjatarkastus_kohdat_kesken": "Prieš patvirtinant reikia užpildyti visus 9 punktus.",
  "virhe.linjatarkastus_allekirjoitus_puuttuu": "Trūksta užsakovo atstovo parašo: nupieškite parašą arba pridėkite pasirašytą protokolą.",
  "virhe.ei_hyvaksyntaoikeutta": "Vartus tvirtinti gali tik asmuo, turintis teisę „Approve a gate“ šiam objektui.",
  "virhe.ei_siirto_oikeutta": "Terminą perkelti gali tik asmuo, turintis teisę „Move a gate deadline“ šiam objektui.",
  "virhe.portti_lukittu": "Vartai užrakinti: ankstesnių vartų užduotys neatliktos.",
  "virhe.tehtavia_kesken": "Vartai turi neatliktų užduočių.",
  "virhe.jo_hyvaksytty":"Vartai jau patvirtinti.",
  "virhe.sama_paiva": "Naujas terminas sutampa su dabartiniu.",
  "virhe.ulkopuolinen_tarvitsee_kohteen":"Išorinė paskyra visada kuriama objektui. Pasirinkite bent vieną objektą.",
  "virhe.vt_peruste_puuttuu":"Kai kurioms siūlėms trūksta VT. 7.2 punktą galima pažymėti kaip OK tik nurodžius priežastį.",
  "virhe.linjatarkastus_lukittu": "Patvirtinto linijos patikrinimo parašo keisti negalima.",
  "virhe.allekirjoitus_tyhja": "Parašas tuščias.",
  // T653 (25.10.2026): luokkarekisterin virheet — konekäännös, tarkistamatta.
  "virhe.luokat_puuttuvat": "Pasirinkite «kur» ir «koks defektas».",
  "virhe.tuntematon_luokka": "Pasirinkimo nėra sąraše.",
  "virhe.lisatieto_puuttuu": "Parašykite papildomą informaciją, kai pasirinkta «Kita».",
};
